/* eslint-disable */
/**
 * Power Supply Notebook API
 * Power Supply Notebook Application
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
import { ApuShowVisitTriageCertifications } from '../model/apuShowVisitTriageCertifications';
import { ApuTriageCertifications } from '../model/apuTriageCertifications';
import { AssetHierarchySearchDTO } from '../model/assetHierarchySearchDTO';
import { AssetType } from '../model/assetType';
import { AssetTypeDTO } from '../model/assetTypeDTO';
import { BatteryFilteredRequest } from '../model/batteryFilteredRequest';
import { BatteryHealthFilteredResponse } from '../model/batteryHealthFilteredResponse';
import { CreateJobRequest } from '../model/createJobRequest';
import { CurrentType } from '../model/currentType';
import { CurrentTypeDTO } from '../model/currentTypeDTO';
import { DeploymentStatusDTO } from '../model/deploymentStatusDTO';
import { FuelTankEntity } from '../model/fuelTankEntity';
import { FuelTankSize } from '../model/fuelTankSize';
import { FuelTankSizeDTO } from '../model/fuelTankSizeDTO';
import { Generator } from '../model/generator';
import { GenomeTransponderModelObject } from '../model/genomeTransponderModelObject';
import { GeneratorInventoryReportResponse } from '../model/generatorInventoryReportResponse';
import { GeneratorMobileSearch } from '../model/generator-mobile-search';
import { GeneratorSearch } from '../model/generatorSearch';
import { GeneratorSearchDTO } from '../model/generatorSearchDTO';
import { GeneratorUsageReportResponse } from '../model/generatorUsageReportResponse';
import { HierarchySearchPayload } from '../model/hierarchySearchPayload';
import { LocationType } from '../model/locationType';
import { LocationTypeDTO } from '../model/locationTypeDTO';
import { MaintenanceType } from '../model/maintenanceType';
import { MaintenanceTypeDTO } from '../model/maintenanceTypeDTO';
import { ManufactureType } from '../model/manufactureType';
import { ManufactureTypeDTO } from '../model/manufactureTypeDTO';
import { ModelType } from '../model/modelType';
import { ModelTypeDTO } from '../model/modelTypeDTO';
import { RecoverRequest } from '../model/recoverRequest';
import { RefuelRequest } from '../model/refuelRequest';
import { StatusType } from '../model/statusType';
import { StatusTypeDTO } from '../model/statusTypeDTO';
import { StatesEntity } from '../model/statesEntity';
import { TelemetryActionRequest } from '../model/telemetryActionRequest';
import { TrailerEntity } from '../model/trailerEntity';
import { VoltageType } from '../model/voltageType';
import { VoltageTypeDTO } from '../model/voltageTypeDTO';
import { TrailerNameIdDTO } from '../model/trailerNameIdDTO';
import {
  AcceptedRejectedTriages,
  AccessLog,
  AdminUser,
  AlertBizRulesResponse,
  AlertThresholdConfigRequest,
  AlertThresholdConfigResponse,
  APIErrorReport,
  Apu,
  ApuInspectionReport,
  ApuReport,
  ApuShowVisit,
  ApuType,
  BaseResponseDTO,
  BatteryBalancer,
  BatteryBulkUpload,
  BatteryHealthScoreResponse,
  BatteryHeaterMatType,
  BatteryReport,
  BatteryReportByNode,
  BatteryType,
  CabinetVendor,
  CpoOptekData,
  DeepCycleTelemetryExport,
  EmailNotificationAddresses,
  EngRegion,
  EstimatedDesignRuntime,
  FiberNode,
  FuelTank,
  GenomeTelemetryHistoryResponses,
  ImageMetaDataUpdateRequest,
  InputSurgeArrestor,
  InspectionReport,
  InspectionReportByNode,
  InvalidPowerSupply,
  IP,
  LocationReport,
  MovePowerSupply,
  NaturalGasProvider,
  NetworkHeadEnd,
  NetworkHierarchyRegion,
  NetworkMismatch,
  NextGenNode,
  OutputSurgeArrestor,
  PowerSupply,
  PowerSupplyAlertLevelResponse,
  PowerSupplyAlertNameMapping,
  PowerSupplyAlertResponse,
  PowerSupplyAlertsRequest,
  PowerSupplyAlertStatusResponse,
  PowerSupplyApproveRequest,
  PowerSupplyBattBulkUploadStatus,
  PowerSupplyBatteryBulkUploadStatus,
  PowerSupplyBulkReport,
  PowerSupplyBulkUpload,
  PowerSupplyBulkUploadStatus,
  PowerSupplyCertificationsReqResponse,
  PowerSupplyCombinedInventoryReportsRequest,
  PowerSupplyCombinedInventoryReportsResponse,
  PowerSupplyCombinedInventoryRequest,
  PowerSupplyCombinedReport,
  PowerSupplyCpn2,
  PowerSupplyDeletedReport,
  PowerSupplyImageMetaData,
  PowerSupplyLogHistory,
  PowerSupplyModel,
  PowerSupplyNetworkHierarchyFailureModeAlertsStats,
  PowerSupplyNetworkHierarchyStats,
  Powersupplynotebook,
  PowerSupplyOperationsReport,
  PowerSupplyOperationsResponse,
  PowerSupplyPowerHouse,
  PowerSupplyRemoteTestRequest,
  PowerSupplyRemoteTestResponse,
  PowerSupplyReport,
  PowerSupplySearch,
  PowerSupplySeverityAlertResponse,
  PowerSupplySfp,
  PowerSupplySfpTriage,
  PowerSupplySpatialNetBulkUploadStatus,
  PowerSupplyTriage,
  PowerSupplyTriageDelta,
  PowerSupplyTriageImage,
  PowerSupplyTriageSections,
  PowerSupplyVendor,
  Prefix,
  PSAlertNodeAnalysisMetrics,
  PSAlertStatisticsResponse,
  PsBillingCodes,
  PSCertMaterialItem,
  PSCertTriageMaterialItem,
  PsEditFieldsMetadata,
  PsMaterialBillingCodes,
  PSNameRegion,
  PSRemoteAllTestRunDetails,
  PSRemoteTelemetryBatteryMinuteDetails,
  PSRemoteTelemetryMinuteDetails,
  PSRemoteTestHistory,
  PSRemoteTestReport,
  PSRemoteTestRunDetails,
  PSRemoteTestSchedule,
  PSRemoteTestScheduleAdvanceConfig,
  PSRemoteTestScheduleRunDetails,
  PSRemoteTestScheduleSimpleAdvance,
  PSRemoteTestStart,
  PSRemoteTestStopRequests,
  PSReview,
  PSTelemetryAlertProfile,
  PSTelemetryThresholds,
  ReliabilityReportByNode,
  Scroller,
  SpatialNetUpload,
  SpatialNetUploadStatus,
  Standby,
  State,
  StormModeTelemetryHistoryRequest,
  StormModeTelemetryHistoryResponse,
  TelemetryDataResponse,
  TelemetryHistoryRequest,
  TelemetryHourlyDataResponse,
  Trailer,
  Transponder,
  TransponderModel,
  TransponderReport,
  TransponderVendor,
  TriageBaseResponse,
  UserDetails,
  VulnerabilityReportByNode
} from '../model/models';
import { NWTTeam } from '../model/nWTTeam';
import { PowerSupplyAlertDetailsResponse } from '../model/powerSupplyAlertDetailsResponse';
import { PowerSupplyAlertsDetailsRequest } from '../model/powerSupplyAlertsDetailsRequest';
import { PowerSupplyNetworkSyncReport } from '../model/powerSupplyNetworkSyncReport';
import { PowerSupplyNodeAssociationReport } from '../model/powerSupplyNodeAssociationReport';
import { PowerSupplyTriageCertDelta } from '../model/powerSupplyTriageCertDelta';
import { PsCertificationReportByNode } from '../model/psCertificationReportByNode';
import { PsCertificationReportRequest } from '../model/psCertificationReportRequest';
import { PsCertificationReportResponse } from '../model/psCertificationReportResponse';
import { PsCertsReportsByHie } from '../model/psCertsReportsByHie';
import { PSCertWorkItem } from '../model/pSCertWorkItem';
import { PsCombinedReportsByDivision } from '../model/psCombinedReportsByDivision';
import { PsCombinedReportsByHie } from '../model/psCombinedReportsByHie';
import { PsEQJbReportsByHie } from '../model/psEQJbReportsByHie';
import { PSFilteredRequest } from '../model/pSFilteredRequest';
import { PSFilteredResponse } from '../model/pSFilteredResponse';
import { PSJobsAudit } from '../model/pSJobsAudit';
import { PSJobsAuditExport } from '../model/pSJobsAuditExport';
import { PSJobsAuditListView } from '../model/pSJobsAuditListView';
import { PsnbCertsEqJobResponse } from '../model/psnbCertsEqJobResponse';
import { PsnbEqJobResponse } from '../model/psnbEqJobResponse';
import { PsnbHierarchyLocationPreferencesModel } from '../model/psnbHierarchyLocationPreferencesModel';
import { PsnbUserInfo } from '../model/psnbUserInfo';
import { PsnbUserRolesPermissionConfig } from '../model/psnbUserRolesPermissionConfig';
import { PsnbUserRolesPermissionConfigResponse } from '../model/psnbUserRolesPermissionConfigResponse';
import { PSRemoteTestCmReset } from '../model/pSRemoteTestCmReset';
import { PsReportsByHie } from '../model/psReportsByHie';
import { PsSearchByHieRequest } from '../model/psSearchByHieRequest';
import { PsSearchByHieResponse } from '../model/psSearchByHieResponse';
import { PSTriageCertWorkItem } from '../model/pSTriageCertWorkItem';
import { ScrollerUpdateDTO } from '../model/scrollerUpdateDTO';
import { SearchPsTriageByHie } from '../model/searchPsTriageByHie';
import { TaskOptions } from '../model/taskOptions';
import { TransponderRequest } from '../model/transponderRequest';
import { BASE_PATH, COLLECTION_FORMATS, PSNB_BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root'
})
export class DefaultService {
  public defaultHeaders: HttpHeaders = new HttpHeaders();
  public configuration: Configuration = new Configuration();
  public encoder: HttpParameterCodec;

  public constructor(
    protected httpClient: HttpClient,
    @Inject(PSNB_BASE_PATH) private psnbBasePath: string,
    @Optional()@Inject(BASE_PATH) private basePath: string,
    @Optional() private config: Configuration
  ) {
    if (this.config !== undefined && this.config !== null) {
      this.configuration = this.config;
    }

    if (this.configuration.basePath === undefined || this.configuration?.basePath === null &&
        this.configuration.basePath.length === 0) {
        this.configuration.basePath = this.basePath; // window.location.pathname (see app.module.ts files)
    }

    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key,
            (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
          httpParams, value[k], key != null ? `${key}.${k}` : k));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Add Test Schedule
   * @param pSRemoteTestScheduleSimpleAdvance
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public addTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public addTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public addTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/addTestSchedule`,
      pSRemoteTestScheduleSimpleAdvance,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search by mac address
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advancePowerSupplyMacSearch(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySearch>>;
  public advancePowerSupplyMacSearch(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySearch>>>;
  public advancePowerSupplyMacSearch(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySearch>>>;
  public advancePowerSupplyMacSearch(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling advancePowerSupplyMacSearch.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (mac !== undefined && mac !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>mac, 'mac');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySearch>>(`${this.configuration.basePath}/api/psnb/search/advancePowerSupplyMacSearch`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Advance search by address address
   * @param address
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByAddress(address: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySearch>>;
  public advanceSearchByAddress(address: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySearch>>>;
  public advanceSearchByAddress(address: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySearch>>>;
  public advanceSearchByAddress(address: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (address === null || address === undefined) {
      throw new Error('Required parameter address was null or undefined when calling advanceSearchByAddress.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (address !== undefined && address !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>address, 'address');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySearch>>(`${this.configuration.basePath}/api/psnb/search/advanceSearchByAddress`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Advance search by power supply name
   * @param headendOrTown
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByHeadendOrTown(headendOrTown: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySearch>>;
  public advanceSearchByHeadendOrTown(headendOrTown: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySearch>>>;
  public advanceSearchByHeadendOrTown(headendOrTown: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySearch>>>;
  public advanceSearchByHeadendOrTown(headendOrTown: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (headendOrTown === null || headendOrTown === undefined) {
      throw new Error('Required parameter headendOrTown was null or undefined when calling advanceSearchByHeadendOrTown.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (headendOrTown !== undefined && headendOrTown !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>headendOrTown, 'headendOrTown');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySearch>>(`${this.configuration.basePath}/api/psnb/search/advanceSearchByHeadendOrTown`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Advance search by power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByPowerSupplyId(powerSupplyId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySearch>>;
  public advanceSearchByPowerSupplyId(powerSupplyId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySearch>>>;
  public advanceSearchByPowerSupplyId(powerSupplyId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySearch>>>;
  public advanceSearchByPowerSupplyId(powerSupplyId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling advanceSearchByPowerSupplyId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySearch>>(`${this.configuration.basePath}/api/psnb/search/advanceSearchByPowerSupplyId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Advance search by power supply name
   * @param powerSupplyName
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByPowerSupplyName(powerSupplyName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySearch>>;
  public advanceSearchByPowerSupplyName(powerSupplyName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySearch>>>;
  public advanceSearchByPowerSupplyName(powerSupplyName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySearch>>>;
  public advanceSearchByPowerSupplyName(powerSupplyName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyName === null || powerSupplyName === undefined) {
      throw new Error('Required parameter powerSupplyName was null or undefined when calling advanceSearchByPowerSupplyName.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyName !== undefined && powerSupplyName !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyName, 'powerSupplyName');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySearch>>(`${this.configuration.basePath}/api/psnb/search/advanceSearchByPowerSupplyName`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Battery Bulk Upload
   * @param batteryBulkUpload
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public batteryBulkUpload(batteryBulkUpload?: Array<BatteryBulkUpload>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyBatteryBulkUploadStatus>>;
  public batteryBulkUpload(batteryBulkUpload?: Array<BatteryBulkUpload>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyBatteryBulkUploadStatus>>>;
  public batteryBulkUpload(batteryBulkUpload?: Array<BatteryBulkUpload>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyBatteryBulkUploadStatus>>>;
  public batteryBulkUpload(batteryBulkUpload?: Array<BatteryBulkUpload>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyBatteryBulkUploadStatus>>(`${this.configuration.basePath}/api/psnb/batteryBulkUpload`,
      batteryBulkUpload,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Access Log
   * @param accessLog
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAccessLog(accessLog?: AccessLog, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createAccessLog(accessLog?: AccessLog, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createAccessLog(accessLog?: AccessLog, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createAccessLog(accessLog?: AccessLog, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createAccessLog`,
      accessLog,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Admin User
   * @param adminUser
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAdminUser(adminUser?: AdminUser, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createAdminUser(adminUser?: AdminUser, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createAdminUser(adminUser?: AdminUser, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createAdminUser(adminUser?: AdminUser, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/createAdminUser`,
      adminUser,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create APU
   * @param apu
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createApu(apu?: Apu, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createApu(apu?: Apu, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createApu(apu?: Apu, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createApu(apu?: Apu, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createApu`,
      apu,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create APU Type
   * @param apuType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createApuType(apuType?: ApuType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createApuType(apuType?: ApuType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createApuType(apuType?: ApuType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createApuType(apuType?: ApuType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createApuType`,
      apuType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create APU Visit
   * @param apuShowVisit
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createApuVisit(apuShowVisit?: ApuShowVisit, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createApuVisit`,
      apuShowVisit,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Battery Balancers
   * @param batteryBalancer
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBatteryBalancers(batteryBalancer?: BatteryBalancer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public createBatteryBalancers(batteryBalancer?: BatteryBalancer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public createBatteryBalancers(batteryBalancer?: BatteryBalancer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public createBatteryBalancers(batteryBalancer?: BatteryBalancer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<number>(`${this.configuration.basePath}/api/psnb/admin/createBatteryBalancer`,
      batteryBalancer,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Battery Heater Mat Type
   * @param batteryHeaterMatType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createBatteryHeaterMatType`,
      batteryHeaterMatType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Battery Type
   * @param batteryType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBatteryType(batteryType?: BatteryType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createBatteryType(batteryType?: BatteryType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createBatteryType(batteryType?: BatteryType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createBatteryType(batteryType?: BatteryType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createBatteryType`,
      batteryType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Cabinet Vendor
   * @param cabinetVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createCabinetVendor(cabinetVendor?: CabinetVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createCabinetVendor`,
      cabinetVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Create Controller Card Type
  //  * @param controllerCardType
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public createControllerCardType(controllerCardType?: ControllerCardType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  // public createControllerCardType(controllerCardType?: ControllerCardType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  // public createControllerCardType(controllerCardType?: ControllerCardType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  // public createControllerCardType(controllerCardType?: ControllerCardType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     // to determine the Content-Type header
  //     const consumes: string[] = [
  //         'application/json',
  //         'application/xml'
  //     ];
  //     const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
  //     if (httpContentTypeSelected !== undefined) {
  //         headers = headers.set('Content-Type', httpContentTypeSelected);
  //     }

  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.post<number>(`${this.configuration.basePath}/api/psnb/admin/createControllerCardType`,
  //         controllerCardType,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Create Estimated Design Runtime
   * @param estimatedDesignRuntime
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createEstimatedDesignRuntime`,
      estimatedDesignRuntime,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Input Surge Arrestor
   * @param inputSurgeArrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createInputSurgeArrestor`,
      inputSurgeArrestor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Natural Gas Provider
   * @param naturalGasProvider
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createNaturalGasProvider`,
      naturalGasProvider,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Next Gen Node
   * @param nextGenNode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createNextGenNode(nextGenNode?: NextGenNode, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createNextGenNode(nextGenNode?: NextGenNode, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createNextGenNode(nextGenNode?: NextGenNode, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createNextGenNode(nextGenNode?: NextGenNode, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createNextGenNode`,
      nextGenNode,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Output Surge Arrestor
   * @param outputSurgeArrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createOutputSurgeArrestor`,
      outputSurgeArrestor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create a new Power Supply
   * @param powerSupply
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupply(powerSupply?: PowerSupply, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPowerSupply(powerSupply?: PowerSupply, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPowerSupply(powerSupply?: PowerSupply, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPowerSupply(powerSupply?: PowerSupply, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/createPowerSupply`,
      powerSupply,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply Cpn
   * @param powerSupplyCpn2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupplyCpn(powerSupplyCpn2: PowerSupplyCpn2, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPowerSupplyCpn(powerSupplyCpn2: PowerSupplyCpn2, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPowerSupplyCpn(powerSupplyCpn2: PowerSupplyCpn2, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPowerSupplyCpn(powerSupplyCpn2: PowerSupplyCpn2, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyCpn2 === null || powerSupplyCpn2 === undefined) {
      throw new Error('Required parameter powerSupplyCpn2 was null or undefined when calling createPowerSupplyCpn.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createPowerSupplyCpn`,
      powerSupplyCpn2,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply By Non Comcast User
   * @param powerSupplyTriage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriage>;
  public createPowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriage>>;
  public createPowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriage>>;
  public createPowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyTriage>(`${this.configuration.basePath}/api/psnb/ps/createPowerSupplyForNonComcastUsers`,
      powerSupplyTriage,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply Model
   * @param powerSupplyModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createPowerSupplyModel`,
      powerSupplyModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply Vendor
   * @param powerSupplyVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createPowerSupplyVendor`,
      powerSupplyVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Prefix
   * @param prefix
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPrefix(prefix?: Prefix, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPrefix(prefix?: Prefix, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPrefix(prefix?: Prefix, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPrefix(prefix?: Prefix, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createPrefix`,
      prefix,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Scroller
   * @param scroller
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createScroller(scroller?: Scroller, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createScroller(scroller?: Scroller, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createScroller(scroller?: Scroller, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createScroller(scroller?: Scroller, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createScroller`,
      scroller,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Transponder Model
   * @param transponderModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTransponderModel(transponderModel?: TransponderModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createTransponderModel(transponderModel?: TransponderModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createTransponderModel(transponderModel?: TransponderModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createTransponderModel(transponderModel?: TransponderModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createTransponderModel`,
      transponderModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Transponder Vendor
   * @param transponderVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createTransponderVendor(transponderVendor?: TransponderVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createTransponderVendor`,
      transponderVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Access Log
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAccessLog(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteAccessLog(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteAccessLog(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteAccessLog(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteAccessLog.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteAccessLog/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Admin User
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAdminUser(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteAdminUser(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteAdminUser(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteAdminUser(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteAdminUser.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/deleteAdminUser/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete all invalid Power Supply records
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAllInvalidPowerSupplies(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteAllInvalidPowerSupplies(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteAllInvalidPowerSupplies(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteAllInvalidPowerSupplies(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/deleteAllInvalidPowerSupplies`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete APU Type
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteApuType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteApuType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteApuType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteApuType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteApuType.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteApuType/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Battery Balancer
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBatteryBalancer(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deleteBatteryBalancer(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deleteBatteryBalancer(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deleteBatteryBalancer(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteBatteryBalancer.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deleteBatteryBalancer/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Battery Heater Mat Type
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBatteryHeaterMatType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteBatteryHeaterMatType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteBatteryHeaterMatType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteBatteryHeaterMatType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteBatteryHeaterMatType.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteBatteryHeaterMatType/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Battery Type
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBatteryType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteBatteryType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteBatteryType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteBatteryType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteBatteryType.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteBatteryType/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Cabinet Vendor
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCabinetVendor(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteCabinetVendor(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteCabinetVendor(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteCabinetVendor(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCabinetVendor.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteCabinetVendor/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Delete Controller Card Type
  //  * @param id
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public deleteControllerCardType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  // public deleteControllerCardType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  // public deleteControllerCardType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  // public deleteControllerCardType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (id === null || id === undefined) {
  //         throw new Error('Required parameter id was null or undefined when calling deleteControllerCardType.');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deleteControllerCardType/${encodeURIComponent(String(id))}`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Delete Estimated Design Runtime
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEstimatedDesignRuntime(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteEstimatedDesignRuntime(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteEstimatedDesignRuntime(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteEstimatedDesignRuntime(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteEstimatedDesignRuntime.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteEstimatedDesignRuntime/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Image details by power supply id
   * @param psId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteImageByPSId(psId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public deleteImageByPSId(psId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteImageByPSId(psId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteImageByPSId(psId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling deleteImageByPSId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/deleteImageByPSId/${encodeURIComponent(String(psId))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Image details by power supply id
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteImageByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public deleteImageByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteImageByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteImageByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling deleteImageByTriageId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/deleteImageByTriageId/${encodeURIComponent(String(triageId))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Input Surge Arrestor
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteInputSurgeArrestor(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteInputSurgeArrestor(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteInputSurgeArrestor(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteInputSurgeArrestor(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteInputSurgeArrestor.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteInputSurgeArrestor/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete invalid Power Supply
   * @param type
   * @param powerSupply
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteInvalidPowerSupply(type: number, powerSupply?: PowerSupply, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteInvalidPowerSupply(type: number, powerSupply?: PowerSupply, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteInvalidPowerSupply(type: number, powerSupply?: PowerSupply, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteInvalidPowerSupply(type: number, powerSupply?: PowerSupply, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (type === null || type === undefined) {
      throw new Error('Required parameter type was null or undefined when calling deleteInvalidPowerSupply.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/deleteInvalidPowerSupply/${encodeURIComponent(String(type))}`,
      powerSupply,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Natural Gas Provider
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteNaturalGasProvider(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteNaturalGasProvider(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteNaturalGasProvider(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteNaturalGasProvider(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteNaturalGasProvider.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteNaturalGasProvider/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Next Gen Node
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteNextGenNode(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteNextGenNode(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteNextGenNode(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteNextGenNode(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteNextGenNode.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteNextGenNode/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Output Surge Arrestor
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOutputSurgeArrestor(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteOutputSurgeArrestor(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteOutputSurgeArrestor(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteOutputSurgeArrestor(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteOutputSurgeArrestor.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteOutputSurgeArrestor/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePowerSupply(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePowerSupply(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePowerSupply(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePowerSupply(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling deletePowerSupply.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/deletePowerSupply/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Model
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePowerSupplyModel(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePowerSupplyModel(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePowerSupplyModel(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePowerSupplyModel(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePowerSupplyModel.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deletePowerSupplyModel/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Vendor
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePowerSupplyVendor(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePowerSupplyVendor(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePowerSupplyVendor(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePowerSupplyVendor(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePowerSupplyVendor.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deletePowerSupplyVendor/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Prefix
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePrefix(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePrefix(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePrefix(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePrefix(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePrefix.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deletePrefix/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Scroller
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteScroller(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteScroller(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteScroller(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteScroller(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteScroller.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteScroller/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Image details by power supply id
   * @param psId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSdsImageByPSId(psId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public deleteSdsImageByPSId(psId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteSdsImageByPSId(psId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteSdsImageByPSId(psId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling deleteSdsImageByPSId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/deleteSdsImageByPSId/${encodeURIComponent(String(psId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply Image details by power supply id
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSdsImageByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public deleteSdsImageByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteSdsImageByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteSdsImageByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling deleteSdsImageByTriageId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/deleteSdsImageByTriageId/${encodeURIComponent(String(triageId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Test Schedule
   * @param testScheduleId
   * @param deleteFlag
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTestSchedule(testScheduleId: number, deleteFlag: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTestSchedule(testScheduleId: number, deleteFlag: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTestSchedule(testScheduleId: number, deleteFlag: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTestSchedule(testScheduleId: number, deleteFlag: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (testScheduleId === null || testScheduleId === undefined) {
      throw new Error('Required parameter testScheduleId was null or undefined when calling deleteTestSchedule.');
    }
    if (deleteFlag === null || deleteFlag === undefined) {
      throw new Error('Required parameter deleteFlag was null or undefined when calling deleteTestSchedule.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteTestSchedule/${encodeURIComponent(String(testScheduleId))}/${encodeURIComponent(String(deleteFlag))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Delete Test Schedule
   * @param scheduledStatus
   * @param testScheduleId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateScheduledStatus(scheduledStatus: number, testScheduleId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateScheduledStatus(scheduledStatus: number, testScheduleId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateScheduledStatus(scheduledStatus: number, testScheduleId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateScheduledStatus(scheduledStatus: number, testScheduleId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (scheduledStatus === null || scheduledStatus === undefined) {
      throw new Error('Required parameter scheduledStatus was null or undefined when calling updateScheduledStatus.');
    }
    if (testScheduleId === null || testScheduleId === undefined) {
      throw new Error('Required parameter testScheduleId was null or undefined when calling updateScheduledStatus.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateScheduledStatus/${encodeURIComponent(String(scheduledStatus))}/${encodeURIComponent(String(testScheduleId))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Delete Transponder Model
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTransponderModel(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTransponderModel(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTransponderModel(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTransponderModel(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteTransponderModel.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteTransponderModel/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Transponder Vendor
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTransponderVendor(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTransponderVendor(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTransponderVendor(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTransponderVendor(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteTransponderVendor.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteTransponderVendor/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * DOCSIS Reset
   * @param ip
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public docsisReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public docsisReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public docsisReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public docsisReset(ip: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling docsisReset.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling docsisReset.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling docsisReset.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/docsisReset`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit test Schedule
   * @param pSRemoteTestScheduleSimpleAdvance
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editTestSchedule(pSRemoteTestScheduleSimpleAdvance?: PSRemoteTestScheduleSimpleAdvance, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/editTestSchedule`,
      pSRemoteTestScheduleSimpleAdvance,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Generate IP Address
   * @param iP
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateIpAddress(iP?: IP, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public generateIpAddress(iP?: IP, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public generateIpAddress(iP?: IP, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public generateIpAddress(iP?: IP, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/generateIpAddress`,
      iP,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Generate Mac Address
   * @param region
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateMacAddress(region: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Transponder>;
  public generateMacAddress(region: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Transponder>>;
  public generateMacAddress(region: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Transponder>>;
  public generateMacAddress(region: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (region === null || region === undefined) {
      throw new Error('Required parameter region was null or undefined when calling generateMacAddress.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Transponder>(`${this.configuration.basePath}/api/psnb/ps/generateMacAddress/${encodeURIComponent(String(region))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get APU Inspection Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAPUInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ApuInspectionReport>>;
  public getAPUInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ApuInspectionReport>>>;
  public getAPUInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ApuInspectionReport>>>;
  public getAPUInspectionReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getAPUInspectionReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<ApuInspectionReport>>(`${this.configuration.basePath}/api/psnb/reports/getAPUInspectionReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get APU Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAPUReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ApuReport>>;
  public getAPUReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ApuReport>>>;
  public getAPUReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ApuReport>>>;
  public getAPUReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getAPUReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<ApuReport>>(`${this.configuration.basePath}/api/psnb/reports/getAPUReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Access Logs
   * @param days
   * @param search
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAccessLogs(days: number, search: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<AccessLog>>;
  public getAccessLogs(days: number, search: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<AccessLog>>>;
  public getAccessLogs(days: number, search: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<AccessLog>>>;
  public getAccessLogs(days: number, search: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (days === null || days === undefined) {
      throw new Error('Required parameter days was null or undefined when calling getAccessLogs.');
    }
    if (search === null || search === undefined) {
      throw new Error('Required parameter search was null or undefined when calling getAccessLogs.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (days !== undefined && days !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>days, 'days');
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>search, 'search');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<AccessLog>>(`${this.configuration.basePath}/api/psnb/admin/getAccessLogs`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Admin Users
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAdminUsers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<AdminUser>>;
  public getAdminUsers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<AdminUser>>>;
  public getAdminUsers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<AdminUser>>>;
  public getAdminUsers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<AdminUser>>(`${this.configuration.basePath}/api/psnb/getAdminUsers`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Advanced Test Config by Schedule Id
   * @param testScheduleId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAdvancedTestConfigurationByScheduleId(testScheduleId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestScheduleAdvanceConfig>>;
  public getAdvancedTestConfigurationByScheduleId(testScheduleId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestScheduleAdvanceConfig>>>;
  public getAdvancedTestConfigurationByScheduleId(testScheduleId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestScheduleAdvanceConfig>>>;
  public getAdvancedTestConfigurationByScheduleId(testScheduleId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (testScheduleId === null || testScheduleId === undefined) {
      throw new Error('Required parameter testScheduleId was null or undefined when calling getAdvancedTestConfigurationByScheduleId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTestScheduleAdvanceConfig>>(`${this.configuration.basePath}/api/psnb/admin/getAdvancedTestConfigurationByScheduleId/${encodeURIComponent(String(testScheduleId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Alert Biz Rules
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAlertBizRules(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<AlertBizRulesResponse>;
  public getAlertBizRules(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<AlertBizRulesResponse>>;
  public getAlertBizRules(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<AlertBizRulesResponse>>;
  public getAlertBizRules(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<AlertBizRulesResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertBizRules`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Threshold Config Details
   * @param alertTypeKey
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAlertThresholdConfigList(alertTypeKey: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<AlertThresholdConfigResponse>;
  public getAlertThresholdConfigList(alertTypeKey: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<AlertThresholdConfigResponse>>;
  public getAlertThresholdConfigList(alertTypeKey: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<AlertThresholdConfigResponse>>;
  public getAlertThresholdConfigList(alertTypeKey: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (alertTypeKey === null || alertTypeKey === undefined) {
      throw new Error('Required parameter alertTypeKey was null or undefined when calling getAlertThresholdConfigList.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (alertTypeKey !== undefined && alertTypeKey !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>alertTypeKey, 'alertTypeKey');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<AlertThresholdConfigResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertThresholdConfig`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts - alert level by macAddress
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAlertsAlertLevel(requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyAlertLevelResponse>;
  public getAlertsAlertLevel(requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyAlertLevelResponse>>;
  public getAlertsAlertLevel(requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyAlertLevelResponse>>;
  public getAlertsAlertLevel(requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyAlertLevelResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertsAlertLevel`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts severity by macAddress
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAlertsSeverityLevel(requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplySeverityAlertResponse>;
  public getAlertsSeverityLevel(requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplySeverityAlertResponse>>;
  public getAlertsSeverityLevel(requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplySeverityAlertResponse>>;
  public getAlertsSeverityLevel(requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplySeverityAlertResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertsSeverityLevel`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All APU Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllApuTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ApuType>>;
  public getAllApuTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ApuType>>>;
  public getAllApuTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ApuType>>>;
  public getAllApuTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<ApuType>>(`${this.configuration.basePath}/api/psnb/admin/getAllApuTypes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All Prefixes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllPrefixes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<Prefix>>;
  public getAllPrefixes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<Prefix>>>;
  public getAllPrefixes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<Prefix>>>;
  public getAllPrefixes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<Prefix>>(`${this.configuration.basePath}/api/psnb/admin/getAllPrefixes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get APU by Power SupplyId
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getApuByPowerSupplyId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Apu>;
  public getApuByPowerSupplyId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Apu>>;
  public getApuByPowerSupplyId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Apu>>;
  public getApuByPowerSupplyId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getApuByPowerSupplyId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Apu>(`${this.configuration.basePath}/api/psnb/admin/getApuByPowerSupplyId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get APU Visit By Power Supply ID
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getApuVisitByPowerSupplyId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<ApuShowVisit>;
  public getApuVisitByPowerSupplyId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<ApuShowVisit>>;
  public getApuVisitByPowerSupplyId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<ApuShowVisit>>;
  public getApuVisitByPowerSupplyId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getApuVisitByPowerSupplyId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<ApuShowVisit>(`${this.configuration.basePath}/api/psnb/admin/getApuVisitByPowerSupplyId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Balancers
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBatteryBalancers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryBalancer>>;
  public getBatteryBalancers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryBalancer>>>;
  public getBatteryBalancers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryBalancer>>>;
  public getBatteryBalancers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<BatteryBalancer>>(`${this.configuration.basePath}/api/psnb/admin/getBatteryBalancers`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Heater Mat Type
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBatteryHeaterMatTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryHeaterMatType>>;
  public getBatteryHeaterMatTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryHeaterMatType>>>;
  public getBatteryHeaterMatTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryHeaterMatType>>>;
  public getBatteryHeaterMatTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<BatteryHeaterMatType>>(`${this.configuration.basePath}/api/psnb/admin/getBatteryHeaterMatTypes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryReport>>;
  public getBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryReport>>>;
  public getBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryReport>>>;
  public getBatteryReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getBatteryReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<BatteryReport>>(`${this.configuration.basePath}/api/psnb/reports/getBatteryReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Template
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBatteryTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<Blob>;
  public getBatteryTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpResponse<Blob>>;
  public getBatteryTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpEvent<Blob>>;
  public getBatteryTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/vnd.ms-excel'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/getBatteryTemplate`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBatteryTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryType>>;
  public getBatteryTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryType>>>;
  public getBatteryTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryType>>>;
  public getBatteryTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<BatteryType>>(`${this.configuration.basePath}/api/psnb/admin/getBatteryTypes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply bulk Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBulkPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyBulkReport>>;
  public getBulkPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyBulkReport>>>;
  public getBulkPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyBulkReport>>>;
  public getBulkPowerSupplyReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getBulkPowerSupplyReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyBulkReport>>(`${this.configuration.basePath}/api/psnb/reports/getBulkPowerSupplyReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Cabinet Vendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCabinetVendors(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<CabinetVendor>>;
  public getCabinetVendors(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<CabinetVendor>>>;
  public getCabinetVendors(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<CabinetVendor>>>;
  public getCabinetVendors(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<CabinetVendor>>(`${this.configuration.basePath}/api/psnb/admin/getCabinetVendors`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCodebigTxt(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<string>;
  public getCodebigTxt(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpResponse<string>>;
  public getCodebigTxt(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpEvent<string>>;
  public getCodebigTxt(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain'}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/plain'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<string>(`${this.configuration.basePath}/codebig.txt`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCodebigTxt1(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<string>;
  public getCodebigTxt1(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpResponse<string>>;
  public getCodebigTxt1(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpEvent<string>>;
  public getCodebigTxt1(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain'}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/plain'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<string>(`${this.configuration.basePath}/api/psnb/codebig.txt`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply combined inventory Report
   * @param powerSupplyCombinedInventoryRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCombinedInventoryPowerSupplyReports(powerSupplyCombinedInventoryRequest: PowerSupplyCombinedInventoryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyCombinedInventoryReportsResponse>;
  public getCombinedInventoryPowerSupplyReports(powerSupplyCombinedInventoryRequest: PowerSupplyCombinedInventoryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyCombinedInventoryReportsResponse>>;
  public getCombinedInventoryPowerSupplyReports(powerSupplyCombinedInventoryRequest: PowerSupplyCombinedInventoryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyCombinedInventoryReportsResponse>>;
  public getCombinedInventoryPowerSupplyReports(powerSupplyCombinedInventoryRequest: PowerSupplyCombinedInventoryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyCombinedInventoryRequest === null || powerSupplyCombinedInventoryRequest === undefined) {
      throw new Error('Required parameter powerSupplyCombinedInventoryRequest was null or undefined when calling getCombinedInventoryPowerSupplyReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyCombinedInventoryReportsResponse>(`${this.configuration.basePath}/api/psnb/reports/getCombinedInventoryPowerSupplyReports`,
      powerSupplyCombinedInventoryRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply combined inventory Report Export
   * @param powerSupplyCombinedInventoryReportsRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCombinedInventoryPowerSupplyReportsExport(powerSupplyCombinedInventoryReportsRequest?: PowerSupplyCombinedInventoryReportsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyCombinedReport>>;
  public getCombinedInventoryPowerSupplyReportsExport(powerSupplyCombinedInventoryReportsRequest?: PowerSupplyCombinedInventoryReportsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyCombinedReport>>>;
  public getCombinedInventoryPowerSupplyReportsExport(powerSupplyCombinedInventoryReportsRequest?: PowerSupplyCombinedInventoryReportsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyCombinedReport>>>;
  public getCombinedInventoryPowerSupplyReportsExport(powerSupplyCombinedInventoryReportsRequest?: PowerSupplyCombinedInventoryReportsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyCombinedReport>>(`${this.configuration.basePath}/api/psnb/reports/getCombinedInventoryPowerSupplyReportsExport`,
      powerSupplyCombinedInventoryReportsRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Head Ends
   * @param path
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCommunities(path: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getCommunities(path: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getCommunities(path: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getCommunities(path: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (path === null || path === undefined) {
      throw new Error('Required parameter path was null or undefined when calling getCommunities.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (path !== undefined && path !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>path, 'path');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/network/getCommunities`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Communites by HUB ID
   * @param path
   * @param ncpHubId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCommunitiesByHubId(path: string, ncpHubId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getCommunitiesByHubId(path: string, ncpHubId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getCommunitiesByHubId(path: string, ncpHubId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getCommunitiesByHubId(path: string, ncpHubId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (path === null || path === undefined) {
      throw new Error('Required parameter path was null or undefined when calling getCommunitiesByHubId.');
    }
    if (ncpHubId === null || ncpHubId === undefined) {
      throw new Error('Required parameter ncpHubId was null or undefined when calling getCommunitiesByHubId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (path !== undefined && path !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>path, 'path');
    }
    if (ncpHubId !== undefined && ncpHubId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ncpHubId, 'ncpHubId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/network/getCommunitiesByHubId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get continuity link by mac
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getContinuityLink(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public getContinuityLink(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public getContinuityLink(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public getContinuityLink(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling getContinuityLink.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (mac !== undefined && mac !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>mac, 'mac');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/network/getContinuityLink`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Get Controller Card Type
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getControllerCardTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ControllerCardType>>;
  // public getControllerCardTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ControllerCardType>>>;
  // public getControllerCardTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ControllerCardType>>>;
  // public getControllerCardTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<ControllerCardType>>(`${this.configuration.basePath}/api/psnb/admin/getControllerCardTypes`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Search Eng Regions
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEngRegion(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<EngRegion>>;
  public getEngRegion(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<EngRegion>>>;
  public getEngRegion(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<EngRegion>>>;
  public getEngRegion(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<EngRegion>>(`${this.configuration.basePath}/api/psnb/network/getEngRegions`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Estimated Design Runtime
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEstimatedDesignRuntimes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<EstimatedDesignRuntime>>;
  public getEstimatedDesignRuntimes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<EstimatedDesignRuntime>>>;
  public getEstimatedDesignRuntimes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<EstimatedDesignRuntime>>>;
  public getEstimatedDesignRuntimes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<EstimatedDesignRuntime>>(`${this.configuration.basePath}/api/psnb/admin/getEstimatedDesignRuntimes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Input Surge Arrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInputSurgeArrestors(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<InputSurgeArrestor>>;
  public getInputSurgeArrestors(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<InputSurgeArrestor>>>;
  public getInputSurgeArrestors(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<InputSurgeArrestor>>>;
  public getInputSurgeArrestors(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<InputSurgeArrestor>>(`${this.configuration.basePath}/api/psnb/admin/getInputSurgeArrestors`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Inspection Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<InspectionReport>>;
  public getInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<InspectionReport>>>;
  public getInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<InspectionReport>>>;
  public getInspectionReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getInspectionReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<InspectionReport>>(`${this.configuration.basePath}/api/psnb/reports/getInspectionReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all invalid power supplies
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInvalidPowerSupplies(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<InvalidPowerSupply>>;
  public getInvalidPowerSupplies(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<InvalidPowerSupply>>>;
  public getInvalidPowerSupplies(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<InvalidPowerSupply>>>;
  public getInvalidPowerSupplies(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<InvalidPowerSupply>>(`${this.configuration.basePath}/api/psnb/ps/getInvalidPowerSupplies`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Location Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLocationReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<LocationReport>>;
  public getLocationReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<LocationReport>>>;
  public getLocationReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<LocationReport>>>;
  public getLocationReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getLocationReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<LocationReport>>(`${this.configuration.basePath}/api/psnb/reports/getLocationReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Natural Gas Provider
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNaturalGasProviders(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<NaturalGasProvider>>;
  public getNaturalGasProviders(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<NaturalGasProvider>>>;
  public getNaturalGasProviders(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<NaturalGasProvider>>>;
  public getNaturalGasProviders(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<NaturalGasProvider>>(`${this.configuration.basePath}/api/psnb/admin/getNaturalGasProviders`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Head Ends
   * @param path
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNetworkHeadEnd(path: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<NetworkHeadEnd>>;
  public getNetworkHeadEnd(path: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<NetworkHeadEnd>>>;
  public getNetworkHeadEnd(path: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<NetworkHeadEnd>>>;
  public getNetworkHeadEnd(path: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (path === null || path === undefined) {
      throw new Error('Required parameter path was null or undefined when calling getNetworkHeadEnd.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (path !== undefined && path !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>path, 'path');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<NetworkHeadEnd>>(`${this.configuration.basePath}/api/psnb/network/getHeadends`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Next Gen Node
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNextGenNodes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<NextGenNode>>;
  public getNextGenNodes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<NextGenNode>>>;
  public getNextGenNodes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<NextGenNode>>>;
  public getNextGenNodes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<NextGenNode>>(`${this.configuration.basePath}/api/psnb/admin/getNextGenNodes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts node analysis metrics
   * @param alertId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNodeAnalysisMetricsByAlertId(alertId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSAlertNodeAnalysisMetrics>>;
  public getNodeAnalysisMetricsByAlertId(alertId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSAlertNodeAnalysisMetrics>>>;
  public getNodeAnalysisMetricsByAlertId(alertId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSAlertNodeAnalysisMetrics>>>;
  public getNodeAnalysisMetricsByAlertId(alertId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (alertId === null || alertId === undefined) {
      throw new Error('Required parameter alertId was null or undefined when calling getNodeAnalysisMetricsByAlertId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (alertId !== undefined && alertId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>alertId, 'alertId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSAlertNodeAnalysisMetrics>>(`${this.configuration.basePath}/api/psnb/ps/getNodeMetrics`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Output Surge Arrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOutputSurgeArrestors(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<OutputSurgeArrestor>>;
  public getOutputSurgeArrestors(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<OutputSurgeArrestor>>>;
  public getOutputSurgeArrestors(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<OutputSurgeArrestor>>>;
  public getOutputSurgeArrestors(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<OutputSurgeArrestor>>(`${this.configuration.basePath}/api/psnb/admin/getOutputSurgeArrestors`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS All Tests - Success and Failure by HierarchyId
   * @param hierarchyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSAllTests(hierarchyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteAllTestRunDetails>>;
  public getPSAllTests(hierarchyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteAllTestRunDetails>>>;
  public getPSAllTests(hierarchyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteAllTestRunDetails>>>;
  public getPSAllTests(hierarchyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (hierarchyId === null || hierarchyId === undefined) {
      throw new Error('Required parameter hierarchyId was null or undefined when calling getPSAllTests.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteAllTestRunDetails>>(`${this.configuration.basePath}/api/psnb/admin/getPSAllTests/${encodeURIComponent(String(hierarchyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all power supplies in triage
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSDeltaDetails(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriageDelta>;
  public getPSDeltaDetails(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriageDelta>>;
  public getPSDeltaDetails(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriageDelta>>;
  public getPSDeltaDetails(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPSDeltaDetails.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyTriageDelta>(`${this.configuration.basePath}/api/psnb/ps/getPSDeltaDetails`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Log History
   * @param path
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSHistory(path: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSReview>>;
  public getPSHistory(path: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSReview>>>;
  public getPSHistory(path: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSReview>>>;
  public getPSHistory(path: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (path === null || path === undefined) {
      throw new Error('Required parameter path was null or undefined when calling getPSHistory.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (path !== undefined && path !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>path, 'path');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSReview>>(`${this.configuration.basePath}/api/psnb/powersupply/getPSHistory`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Log History by Power Supply ID
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSLogHistoryByPSId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyLogHistory>>;
  public getPSLogHistoryByPSId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyLogHistory>>>;
  public getPSLogHistoryByPSId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyLogHistory>>>;
  public getPSLogHistoryByPSId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPSLogHistoryByPSId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyLogHistory>>(`${this.configuration.basePath}/api/psnb/powersupply/getPSLogHistoryByPSId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PSNB Network Mismatch
   * @param nodeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSNBNetworkMismatch(nodeId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<NetworkMismatch>>;
  public getPSNBNetworkMismatch(nodeId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<NetworkMismatch>>>;
  public getPSNBNetworkMismatch(nodeId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<NetworkMismatch>>>;
  public getPSNBNetworkMismatch(nodeId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<NetworkMismatch>>(`${this.configuration.basePath}/api/psnb/getPSNBNetworkMismatch`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Name and Region
   * @param nodeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSNameAndRegion(nodeId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PSNameRegion>;
  public getPSNameAndRegion(nodeId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PSNameRegion>>;
  public getPSNameAndRegion(nodeId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PSNameRegion>>;
  public getPSNameAndRegion(nodeId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling getPSNameAndRegion.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PSNameRegion>(`${this.configuration.basePath}/api/psnb/ps/getPSNameAndRegion/${encodeURIComponent(String(nodeId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Get PS Network Hierarchy Stats by NhoId
  //  * @param nhoId
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getPSNetworkHierarchyStatsByNhoId(nhoId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyNetworkHierarchyStats>>;
  // public getPSNetworkHierarchyStatsByNhoId(nhoId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyNetworkHierarchyStats>>>;
  // public getPSNetworkHierarchyStatsByNhoId(nhoId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyNetworkHierarchyStats>>>;
  // public getPSNetworkHierarchyStatsByNhoId(nhoId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (nhoId === null || nhoId === undefined) {
  //         throw new Error('Required parameter nhoId was null or undefined when calling getPSNetworkHierarchyStatsByNhoId.');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<PowerSupplyNetworkHierarchyStats>>(`${this.configuration.basePath}/api/psnb/getPSNetworkHierarchyStatsByNhoId/${encodeURIComponent(String(nhoId))}`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get PS Network Hierarchy Stats by NhoId
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSNetworkHierarchyStatsByNhoId(requestBody: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyNetworkHierarchyStats>>;
  public getPSNetworkHierarchyStatsByNhoId(requestBody: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyNetworkHierarchyStats>>>;
  public getPSNetworkHierarchyStatsByNhoId(requestBody: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyNetworkHierarchyStats>>>;
  public getPSNetworkHierarchyStatsByNhoId(requestBody: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling getPSNetworkHierarchyStatsByNhoId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyNetworkHierarchyStats>>(`${this.configuration.basePath}/api/psnb/getPSNetworkHierarchyStatsByNhoId`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Test Run details by Test Run Id
   * @param testRunId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSRemoteTestRunDetails(testRunId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestRunDetails>>;
  public getPSRemoteTestRunDetails(testRunId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestRunDetails>>>;
  public getPSRemoteTestRunDetails(testRunId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestRunDetails>>>;
  public getPSRemoteTestRunDetails(testRunId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (testRunId === null || testRunId === undefined) {
      throw new Error('Required parameter testRunId was null or undefined when calling getPSRemoteTestRunDetails.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTestRunDetails>>(`${this.configuration.basePath}/api/psnb/admin/getPSRemoteTestDetails/${encodeURIComponent(String(testRunId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply Mobile changes to DB
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSSectionsTriageList(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriageSections>;
  public getPSSectionsTriageList(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriageSections>>;
  public getPSSectionsTriageList(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriageSections>>;
  public getPSSectionsTriageList(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPSSectionsTriageList.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyTriageSections>(`${this.configuration.basePath}/api/psnb/mobile/psTriageBySections`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Status Link by Mac
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSStatusLink(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public getPSStatusLink(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public getPSStatusLink(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public getPSStatusLink(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling getPSStatusLink.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/getPSStatusLink/${encodeURIComponent(String(mac))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Template
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<Blob>;
  public getPSTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpResponse<Blob>>;
  public getPSTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpEvent<Blob>>;
  public getPSTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/vnd.ms-excel'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/getPSTemplate`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply triag record by triage id
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSTriage(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriage>;
  public getPSTriage(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriage>>;
  public getPSTriage(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriage>>;
  public getPSTriage(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPSTriage.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyTriage>(`${this.configuration.basePath}/api/psnb/ps/getPSTriage`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply triage record by powersupply id
   * @param psId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSTriageByPsId(psId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriage>;
  public getPSTriageByPsId(psId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriage>>;
  public getPSTriageByPsId(psId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriage>>;
  public getPSTriageByPsId(psId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getPSTriageByPsId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyTriage>(`${this.configuration.basePath}/api/psnb/ps/getPSTriageByPsId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply by API Error Report
   * @param nodeId
   * @param regionName
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSuppliesByAPIErrorReports(nodeId: number, regionName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<APIErrorReport>>;
  public getPowerSuppliesByAPIErrorReports(nodeId: number, regionName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<APIErrorReport>>>;
  public getPowerSuppliesByAPIErrorReports(nodeId: number, regionName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<APIErrorReport>>>;
  public getPowerSuppliesByAPIErrorReports(nodeId: number, regionName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling getPowerSuppliesByAPIErrorReports.');
    }
    if (regionName === null || regionName === undefined) {
      throw new Error('Required parameter regionName was null or undefined when calling getPowerSuppliesByAPIErrorReports.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    if (regionName !== undefined && regionName !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>regionName, 'regionName');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<APIErrorReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSuppliesByAPIErrorReports`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply by Node Battery Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSuppliesByNodeBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryReportByNode>>;
  public getPowerSuppliesByNodeBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryReportByNode>>>;
  public getPowerSuppliesByNodeBatteryReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryReportByNode>>>;
  public getPowerSuppliesByNodeBatteryReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSuppliesByNodeBatteryReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<BatteryReportByNode>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSuppliesByNodeBatteryReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PowerSupply by Node Inspection Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSuppliesByNodeInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<InspectionReportByNode>>;
  public getPowerSuppliesByNodeInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<InspectionReportByNode>>>;
  public getPowerSuppliesByNodeInspectionReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<InspectionReportByNode>>>;
  public getPowerSuppliesByNodeInspectionReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSuppliesByNodeInspectionReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<InspectionReportByNode>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSuppliesByNodeInspectionReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alert types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyAlertTypesList(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyAlertNameMapping>>;
  public getPowerSupplyAlertTypesList(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyAlertNameMapping>>>;
  public getPowerSupplyAlertTypesList(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyAlertNameMapping>>>;
  public getPowerSupplyAlertTypesList(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyAlertNameMapping>>(`${this.configuration.basePath}/api/psnb/ps/getAlertTypes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts and metrics by dates and node id for Export
   * @param powerSupplyAlertsRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyAlertsAndMetrics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyAlertResponse>;
  public getPowerSupplyAlertsAndMetrics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyAlertResponse>>;
  public getPowerSupplyAlertsAndMetrics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyAlertResponse>>;
  public getPowerSupplyAlertsAndMetrics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyAlertResponse>(`${this.configuration.basePath}/api/psnb/ps/psAlertsExport`,
      powerSupplyAlertsRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts by dates and node id or psid or macaddress
   * @param powerSupplyAlertsRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyAlertsList(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyAlertResponse>;
  public getPowerSupplyAlertsList(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyAlertResponse>>;
  public getPowerSupplyAlertsList(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyAlertResponse>>;
  public getPowerSupplyAlertsList(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyAlertResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlerts`,
      powerSupplyAlertsRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts statistics
   * @param powerSupplyAlertsRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyAlertsStatistics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PSAlertStatisticsResponse>;
  public getPowerSupplyAlertsStatistics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PSAlertStatisticsResponse>>;
  public getPowerSupplyAlertsStatistics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PSAlertStatisticsResponse>>;
  public getPowerSupplyAlertsStatistics(powerSupplyAlertsRequest?: PowerSupplyAlertsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PSAlertStatisticsResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertStats`,
      powerSupplyAlertsRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply record with power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyById(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupply>;
  public getPowerSupplyById(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupply>>;
  public getPowerSupplyById(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupply>>;
  public getPowerSupplyById(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPowerSupplyById.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupply>(`${this.configuration.basePath}/api/psnb/ps/getPowerSupplyById/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Generate power supply record with mac
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyByMAC(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupply>;
  public getPowerSupplyByMAC(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupply>>;
  public getPowerSupplyByMAC(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupply>>;
  public getPowerSupplyByMAC(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling getPowerSupplyByMAC.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupply>(`${this.configuration.basePath}/api/psnb/ps/getPowerSupplyByMAC/${encodeURIComponent(String(mac))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply SFP by power Supply ID
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplySfpByPowerSupplyId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplySfp>;
  public getPowerSupplySfpByPowerSupplyId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplySfp>>;
  public getPowerSupplySfpByPowerSupplyId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplySfp>>;
  public getPowerSupplySfpByPowerSupplyId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPowerSupplySfpByPowerSupplyId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplySfp>(`${this.configuration.basePath}/api/psnb/ps/getPowerSupplySfpByPowerSupplyId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply SFP
   * @param powerSupplySfp
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfp === null || powerSupplySfp === undefined) {
      throw new Error('Required parameter powerSupplySfp was null or undefined when calling createPowerSupplySfp.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/createPowerSupplySfp`,
      powerSupplySfp,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Power Supply SFP
   * @param powerSupplySfp
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfp === null || powerSupplySfp === undefined) {
      throw new Error('Required parameter powerSupplySfp was null or undefined when calling updatePowerSupplySfp.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/updatePowerSupplySfp`,
      powerSupplySfp,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Power Supply SFP
   * @param powerSupplySfp
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePowerSupplySfp(powerSupplySfp: PowerSupplySfp, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfp === null || powerSupplySfp === undefined) {
      throw new Error('Required parameter powerSupplySfp was null or undefined when calling deletePowerSupplySfp.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/deletePowerSupplySfp`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Cpn by power Supply ID
   * @param id
   * @param supplyNumber
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyCpnByPowerSupplyId(id: number, supplyNumber: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyCpn2>;
  public getPowerSupplyCpnByPowerSupplyId(id: number, supplyNumber: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyCpn2>>;
  public getPowerSupplyCpnByPowerSupplyId(id: number, supplyNumber: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyCpn2>>;
  public getPowerSupplyCpnByPowerSupplyId(id: number, supplyNumber: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPowerSupplyCpnByPowerSupplyId.');
    }
    if (supplyNumber === null || supplyNumber === undefined) {
      throw new Error('Required parameter supplyNumber was null or undefined when calling getPowerSupplyCpnByPowerSupplyId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyCpn2>(`${this.configuration.basePath}/api/psnb/admin/getPowerSupplyCpnByPowerSupplyId/${encodeURIComponent(String(id))}/${encodeURIComponent(String(supplyNumber))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get Power Supply Deleted Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyDeletedReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyDeletedReport>>;
  public getPowerSupplyDeletedReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyDeletedReport>>>;
  public getPowerSupplyDeletedReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyDeletedReport>>>;
  public getPowerSupplyDeletedReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSupplyDeletedReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyDeletedReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyDeletedReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all power supplies
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyList(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupply>>;
  public getPowerSupplyList(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupply>>>;
  public getPowerSupplyList(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupply>>>;
  public getPowerSupplyList(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupply>>(`${this.configuration.basePath}/api/psnb/ps/getPowerSupplyList`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Models
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyModels(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyModel>>;
  public getPowerSupplyModels(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyModel>>>;
  public getPowerSupplyModels(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyModel>>>;
  public getPowerSupplyModels(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyModel>>(`${this.configuration.basePath}/api/psnb/admin/getPowerSupplyModel`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply operations list
   * @param powerSupplyId
   * @param startDate
   * @param endDate
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyOperationsList(powerSupplyId: number, startDate?: string, endDate?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyOperationsReport>>;
  public getPowerSupplyOperationsList(powerSupplyId: number, startDate?: string, endDate?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyOperationsReport>>>;
  public getPowerSupplyOperationsList(powerSupplyId: number, startDate?: string, endDate?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyOperationsReport>>>;
  public getPowerSupplyOperationsList(powerSupplyId: number, startDate?: string, endDate?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPowerSupplyOperationsList.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (startDate !== undefined && startDate !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>startDate, 'startDate');
    }
    if (endDate !== undefined && endDate !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>endDate, 'endDate');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyOperationsReport>>(`${this.configuration.basePath}/api/psnb/ps/genome/getPowerSupplyOperationsList`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get Power Supply Remote Test Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyRemoteTestReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestReport>>;
  public getPowerSupplyRemoteTestReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestReport>>>;
  public getPowerSupplyRemoteTestReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestReport>>>;
  public getPowerSupplyRemoteTestReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSupplyRemoteTestReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSRemoteTestReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyRemoteTestReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Remote Test Report view
   * @param powerSupplyRemoteTestRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyRemoteTestReportView(powerSupplyRemoteTestRequest?: PowerSupplyRemoteTestRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyRemoteTestResponse>;
  public getPowerSupplyRemoteTestReportView(powerSupplyRemoteTestRequest?: PowerSupplyRemoteTestRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyRemoteTestResponse>>;
  public getPowerSupplyRemoteTestReportView(powerSupplyRemoteTestRequest?: PowerSupplyRemoteTestRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyRemoteTestResponse>>;
  public getPowerSupplyRemoteTestReportView(powerSupplyRemoteTestRequest?: PowerSupplyRemoteTestRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyRemoteTestResponse>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyRemoteTestReportView`,
      powerSupplyRemoteTestRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyReport>>;
  public getPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyReport>>>;
  public getPowerSupplyReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyReport>>>;
  public getPowerSupplyReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSupplyReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Get power supply telemetry data
  //  * @param macAddress
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getPowerSupplyTelemetryData(macAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<TelemetryDataResponse>;
  // public getPowerSupplyTelemetryData(macAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<TelemetryDataResponse>>;
  // public getPowerSupplyTelemetryData(macAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<TelemetryDataResponse>>;
  // public getPowerSupplyTelemetryData(macAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (macAddress === null || macAddress === undefined) {
  //         throw new Error('Required parameter macAddress was null or undefined when calling getPowerSupplyTelemetryData.');
  //     }

  //     let queryParameters = new HttpParams({encoder: this.encoder});
  //     if (macAddress !== undefined && macAddress !== null) {
  //       queryParameters = this.addToHttpParams(queryParameters,
  //         <any>macAddress, 'macAddress');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<TelemetryDataResponse>(`${this.configuration.basePath}/api/psnb/telemetry/getPowerSupplyTelemetryData`,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }


  /**
   * Get power supply telemetry data
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyTelemetryData(macAddress?: string, powerSupplyId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<TelemetryDataResponse>;
  public getPowerSupplyTelemetryData(macAddress?: string, powerSupplyId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<TelemetryDataResponse>>;
  public getPowerSupplyTelemetryData(macAddress?: string, powerSupplyId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<TelemetryDataResponse>>;
  public getPowerSupplyTelemetryData(macAddress?: string, powerSupplyId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<TelemetryDataResponse>(`${this.configuration.basePath}/api/psnb/telemetry/getPowerSupplyTelemetryData`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply telemetry hourly data
   * @param macAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyTelemetryHourlyData(macAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<TelemetryHourlyDataResponse>;
  public getPowerSupplyTelemetryHourlyData(macAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<TelemetryHourlyDataResponse>>;
  public getPowerSupplyTelemetryHourlyData(macAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<TelemetryHourlyDataResponse>>;
  public getPowerSupplyTelemetryHourlyData(macAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling getPowerSupplyTelemetryHourlyData.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<TelemetryHourlyDataResponse>(`${this.configuration.basePath}/api/psnb/telemetry/getPowerSupplyTelemetryHourlyData`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply telemetry data
   * @param macAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyTelemetryMinuteData(macAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<TelemetryDataResponse>;
  public getPowerSupplyTelemetryMinuteData(macAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<TelemetryDataResponse>>;
  public getPowerSupplyTelemetryMinuteData(macAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<TelemetryDataResponse>>;
  public getPowerSupplyTelemetryMinuteData(macAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling getPowerSupplyTelemetryMinuteData.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<TelemetryDataResponse>(`${this.configuration.basePath}/api/psnb/telemetry/getPowerSupplyTelemetryMinuteData`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Battery Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyVendors(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyVendor>>;
  public getPowerSupplyVendors(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyVendor>>>;
  public getPowerSupplyVendors(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyVendor>>>;
  public getPowerSupplyVendors(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyVendor>>(`${this.configuration.basePath}/api/psnb/admin/getPowerSupplyVendors`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Power Supply Vendor By Root Id
   * @param rootId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyVendorsByRootId(rootId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyVendor>>;
  public getPowerSupplyVendorsByRootId(rootId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyVendor>>>;
  public getPowerSupplyVendorsByRootId(rootId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyVendor>>>;
  public getPowerSupplyVendorsByRootId(rootId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (rootId === null || rootId === undefined) {
      throw new Error('Required parameter rootId was null or undefined when calling getPowerSupplyVendorsByRootId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyVendor>>(`${this.configuration.basePath}/api/psnb/admin/getPowerSupplyVendorsByRootId/${encodeURIComponent(String(rootId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Prefix By Id
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPrefixById(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Prefix>;
  public getPrefixById(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Prefix>>;
  public getPrefixById(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Prefix>>;
  public getPrefixById(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPrefixById.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Prefix>(`${this.configuration.basePath}/api/psnb/admin/getPrefixById/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Prefix By Name
   * @param prefixName
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPrefixByPrefixName(prefixName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Prefix>;
  public getPrefixByPrefixName(prefixName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Prefix>>;
  public getPrefixByPrefixName(prefixName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Prefix>>;
  public getPrefixByPrefixName(prefixName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (prefixName === null || prefixName === undefined) {
      throw new Error('Required parameter prefixName was null or undefined when calling getPrefixByPrefixName.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Prefix>(`${this.configuration.basePath}/api/psnb/admin/getPrefixByPrefixName/${encodeURIComponent(String(prefixName))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Image details by power supply id
   * @param powerSupplyId
   * @param imageName
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbImageByPsId(powerSupplyId: number, imageName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<Blob>;
  public getPsnbImageByPsId(powerSupplyId: number, imageName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<HttpResponse<Blob>>;
  public getPsnbImageByPsId(powerSupplyId: number, imageName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<HttpEvent<Blob>>;
  public getPsnbImageByPsId(powerSupplyId: number, imageName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsnbImageByPsId.');
    }
    if (imageName === null || imageName === undefined) {
      throw new Error('Required parameter imageName was null or undefined when calling getPsnbImageByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'image/png',
        'image/jpeg'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/image/getPsnbImageByPsId/${encodeURIComponent(String(powerSupplyId))}/${encodeURIComponent(String(imageName))}`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Image details by power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbImageDetailByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PowerSupplyImageMetaData>>;
  public getPsnbImageDetailByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PowerSupplyImageMetaData>>>;
  public getPsnbImageDetailByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PowerSupplyImageMetaData>>>;
  public getPsnbImageDetailByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsnbImageDetailByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyImageMetaData>>(`${this.configuration.basePath}/api/psnb/image/getPsnbImageDetailByPsId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Image details by power supply id
   * @param powerSupplyId
   * @param category
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbSdsImageByPsIdAndCategory(powerSupplyId: number, category: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<Blob>;
  public getPsnbSdsImageByPsIdAndCategory(powerSupplyId: number, category: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<HttpResponse<Blob>>;
  public getPsnbSdsImageByPsIdAndCategory(powerSupplyId: number, category: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<HttpEvent<Blob>>;
  public getPsnbSdsImageByPsIdAndCategory(powerSupplyId: number, category: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsnbSdsImageByPsIdAndCategory.');
    }
    if (category === null || category === undefined) {
      throw new Error('Required parameter category was null or undefined when calling getPsnbSdsImageByPsIdAndCategory.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'image/png',
        'image/jpeg',
        'application/pdf'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/image/sds/getPsnbSdsImageByPsIdAndCategory/${encodeURIComponent(String(powerSupplyId))}/${encodeURIComponent(String(category))}`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Image details by power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbSdsImageDetailByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PowerSupplyImageMetaData>>;
  public getPsnbSdsImageDetailByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PowerSupplyImageMetaData>>>;
  public getPsnbSdsImageDetailByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PowerSupplyImageMetaData>>>;
  public getPsnbSdsImageDetailByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsnbSdsImageDetailByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyImageMetaData>>(`${this.configuration.basePath}/api/psnb/image/sds/getPsnbSdsImageDetailByPsId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Image details by power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbSdsPDFImageByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<Blob>;
  public getPsnbSdsPDFImageByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpResponse<Blob>>;
  public getPsnbSdsPDFImageByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpEvent<Blob>>;
  public getPsnbSdsPDFImageByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsnbSdsPDFImageByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/pdf'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/image/sds/getPsnbSdsPDFImageByPsId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Triage Image by Triage id &amp; category
   * @param triageId
   * @param category
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId(triageId: number, category: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<Blob>;
  public getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId(triageId: number, category: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<HttpResponse<Blob>>;
  public getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId(triageId: number, category: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<HttpEvent<Blob>>;
  public getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId(triageId: number, category: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg' | 'application/pdf'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId.');
    }
    if (category === null || category === undefined) {
      throw new Error('Required parameter category was null or undefined when calling getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'image/png',
        'image/jpeg',
        'application/pdf'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/image/sds/getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId/${encodeURIComponent(String(triageId))}/${encodeURIComponent(String(category))}`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Triage Image details(meta data) by power triage id
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbSdsTriageImageDetailByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PowerSupplyTriageImage>>;
  public getPsnbSdsTriageImageDetailByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PowerSupplyTriageImage>>>;
  public getPsnbSdsTriageImageDetailByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PowerSupplyTriageImage>>>;
  public getPsnbSdsTriageImageDetailByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPsnbSdsTriageImageDetailByTriageId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyTriageImage>>(`${this.configuration.basePath}/api/psnb/image/sds/getPsnbSdsTriageImageDetailByTriageId/${encodeURIComponent(String(triageId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Triage Image details(meta data) by power triage id
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsnbTriageImageDetailByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<PowerSupplyTriageImage>>;
  public getPsnbTriageImageDetailByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<PowerSupplyTriageImage>>>;
  public getPsnbTriageImageDetailByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<PowerSupplyTriageImage>>>;
  public getPsnbTriageImageDetailByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPsnbTriageImageDetailByTriageId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyTriageImage>>(`${this.configuration.basePath}/api/psnb/image/getPsnbTriageImageDetailByTriageId/${encodeURIComponent(String(triageId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get regions
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRegions(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<NetworkHierarchyRegion>>;
  public getRegions(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<NetworkHierarchyRegion>>>;
  public getRegions(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<NetworkHierarchyRegion>>>;
  public getRegions(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<NetworkHierarchyRegion>>(`${this.configuration.basePath}/api/psnb/ps/getRegions`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Network Reliability Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getReliabilityReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ReliabilityReportByNode>>;
  public getReliabilityReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ReliabilityReportByNode>>>;
  public getReliabilityReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ReliabilityReportByNode>>>;
  public getReliabilityReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getReliabilityReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<ReliabilityReportByNode>>(`${this.configuration.basePath}/api/psnb/reports/getReliabilityReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Scroller History
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScrollerHistory(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<Scroller>>;
  public getScrollerHistory(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<Scroller>>>;
  public getScrollerHistory(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<Scroller>>>;
  public getScrollerHistory(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<Scroller>>(`${this.configuration.basePath}/api/psnb/admin/getScrollerHistory`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get SpatialNetID by given mac address
   * @param macAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSpatialNetByMacAddress(macAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<SpatialNetUpload>>;
  public getSpatialNetByMacAddress(macAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<SpatialNetUpload>>>;
  public getSpatialNetByMacAddress(macAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<SpatialNetUpload>>>;
  public getSpatialNetByMacAddress(macAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling getSpatialNetByMacAddress.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<SpatialNetUpload>>(`${this.configuration.basePath}/api/psnb/getSpatialNetByMacAddress`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get SpatialNetID Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSpatialNetIdReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<SpatialNetUpload>>;
  public getSpatialNetIdReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<SpatialNetUpload>>>;
  public getSpatialNetIdReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<SpatialNetUpload>>>;
  public getSpatialNetIdReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getSpatialNetIdReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<SpatialNetUpload>>(`${this.configuration.basePath}/api/psnb/reports/getSpatialNetIdReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * This service is for downloading spatial net template
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSpatialNetTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<Blob>;
  public getSpatialNetTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpResponse<Blob>>;
  public getSpatialNetTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<HttpEvent<Blob>>;
  public getSpatialNetTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.ms-excel'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/vnd.ms-excel'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/getSpatialNetTemplate`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get States
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStates(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<State>>;
  public getStates(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<State>>>;
  public getStates(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<State>>>;
  public getStates(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<State>>(`${this.configuration.basePath}/api/psnb/powersupply/getStates`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get States By root ID
   * @param rootId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStatesByRootId(rootId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<State>>;
  public getStatesByRootId(rootId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<State>>>;
  public getStatesByRootId(rootId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<State>>>;
  public getStatesByRootId(rootId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (rootId === null || rootId === undefined) {
      throw new Error('Required parameter rootId was null or undefined when calling getStatesByRootId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<State>>(`${this.configuration.basePath}/api/psnb/powersupply/getStatesByRootId/${encodeURIComponent(String(rootId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply telemetry data
   * @param macAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTelemetryThresholds(macAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSTelemetryThresholds>>;
  public getTelemetryThresholds(macAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSTelemetryThresholds>>>;
  public getTelemetryThresholds(macAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSTelemetryThresholds>>>;
  public getTelemetryThresholds(macAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling getTelemetryThresholds.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSTelemetryThresholds>>(`${this.configuration.basePath}/api/psnb/telemetry/getTelemetryThresholds`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Test Run Schedule details by Schedule Id
   * @param testScheduleId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTestRunDetailsByScheduleId(testScheduleId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestScheduleRunDetails>>;
  public getTestRunDetailsByScheduleId(testScheduleId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestScheduleRunDetails>>>;
  public getTestRunDetailsByScheduleId(testScheduleId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestScheduleRunDetails>>>;
  public getTestRunDetailsByScheduleId(testScheduleId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (testScheduleId === null || testScheduleId === undefined) {
      throw new Error('Required parameter testScheduleId was null or undefined when calling getTestRunDetailsByScheduleId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTestScheduleRunDetails>>(`${this.configuration.basePath}/api/psnb/admin/getTestRunDetailsByScheduleId/${encodeURIComponent(String(testScheduleId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Remote Test Schedule
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTestScheduleDetails(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestSchedule>>;
  public getTestScheduleDetails(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestSchedule>>>;
  public getTestScheduleDetails(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestSchedule>>>;
  public getTestScheduleDetails(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTestSchedule>>(`${this.configuration.basePath}/api/psnb/admin/getTestScheduleDetails`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  //  /**
  //  * Get PS Remote Test Schedule by Hierarchy
  //  * @param nodeId
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getTestSchedulesByHierarchy(nodeId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestSchedule>>;
  // public getTestSchedulesByHierarchy(nodeId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestSchedule>>>;
  // public getTestSchedulesByHierarchy(nodeId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestSchedule>>>;
  // public getTestSchedulesByHierarchy(nodeId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (nodeId === null || nodeId === undefined) {
  //         throw new Error('Required parameter nodeId was null or undefined when calling getTestSchedulesByHierarchy.');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<PSRemoteTestSchedule>>(`${this.configuration.basePath}/api/psnb/admin/getTestSchedulesByHierarchy/${encodeURIComponent(String(nodeId))}`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get PS Remote Test Schedule by Hierarchy
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTestSchedulesByHierarchy(requestBody: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestSchedule>>;
  public getTestSchedulesByHierarchy(requestBody: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestSchedule>>>;
  public getTestSchedulesByHierarchy(requestBody: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestSchedule>>>;
  public getTestSchedulesByHierarchy(requestBody: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling getTestSchedulesByHierarchy.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSRemoteTestSchedule>>(`${this.configuration.basePath}/api/psnb/admin/getTestSchedulesByHierarchy`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get Transponder Models
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderModels(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<TransponderModel>>;
  public getTransponderModels(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<TransponderModel>>>;
  public getTransponderModels(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<TransponderModel>>>;
  public getTransponderModels(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TransponderModel>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderModels`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Transponder Model by Root ID
   * @param rootId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderModelsByRootId(rootId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<TransponderModel>>;
  public getTransponderModelsByRootId(rootId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<TransponderModel>>>;
  public getTransponderModelsByRootId(rootId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<TransponderModel>>>;
  public getTransponderModelsByRootId(rootId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (rootId === null || rootId === undefined) {
      throw new Error('Required parameter rootId was null or undefined when calling getTransponderModelsByRootId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TransponderModel>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderModelsByRootId/${encodeURIComponent(String(rootId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Transponder Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<TransponderReport>>;
  public getTransponderReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<TransponderReport>>>;
  public getTransponderReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<TransponderReport>>>;
  public getTransponderReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getTransponderReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<TransponderReport>>(`${this.configuration.basePath}/api/psnb/reports/getTransponderReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Transponder Vendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderVendors(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<TransponderVendor>>;
  public getTransponderVendors(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<TransponderVendor>>>;
  public getTransponderVendors(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<TransponderVendor>>>;
  public getTransponderVendors(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TransponderVendor>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderVendors`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create Transponder Vendor By Root Id
   * @param rootId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderVendorsByRootId(rootId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<TransponderVendor>>;
  public getTransponderVendorsByRootId(rootId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<TransponderVendor>>>;
  public getTransponderVendorsByRootId(rootId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<TransponderVendor>>>;
  public getTransponderVendorsByRootId(rootId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (rootId === null || rootId === undefined) {
      throw new Error('Required parameter rootId was null or undefined when calling getTransponderVendorsByRootId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TransponderVendor>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderVendorsByRootId/${encodeURIComponent(String(rootId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Triage Image by Triage id &amp; category
   * @param triageId
   * @param category
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriageImageByCategory(triageId: number, category: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<Blob>;
  public getTriageImageByCategory(triageId: number, category: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<HttpResponse<Blob>>;
  public getTriageImageByCategory(triageId: number, category: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<HttpEvent<Blob>>;
  public getTriageImageByCategory(triageId: number, category: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'image/png' | 'image/jpeg'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getTriageImageByCategory.');
    }
    if (category === null || category === undefined) {
      throw new Error('Required parameter category was null or undefined when calling getTriageImageByCategory.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'image/png',
        'image/jpeg'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnb/image/getTriageImageByCategory/${encodeURIComponent(String(triageId))}/${encodeURIComponent(String(category))}`,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all power supplies in triage
   * @param status
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriagePowerSupplyList(status: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyTriage>>;
  public getTriagePowerSupplyList(status: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyTriage>>>;
  public getTriagePowerSupplyList(status: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyTriage>>>;
  public getTriagePowerSupplyList(status: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (status === null || status === undefined) {
      throw new Error('Required parameter status was null or undefined when calling getTriagePowerSupplyList.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyTriage>>(`${this.configuration.basePath}/api/psnb/ps/getPSTriageSummary/${encodeURIComponent(String(status))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get User Details
   *
   * @param observe set whether or not to return the data Observable as the body, response or events.
   *        defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserDetails(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserDetails>;
  public getUserDetails(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserDetails>>;
  public getUserDetails(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserDetails>>;
  public getUserDetails(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }

    let httpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    } else {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected?.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<UserDetails>(`${this.configuration.basePath}/api/psnb/getUserDetails`,
      {
        headers,
        observe,
        reportProgress,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials
      }
    );
  }

  /**
   * Get Power Supply Network Vulnerability Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVulnerabilityReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<VulnerabilityReportByNode>>;
  public getVulnerabilityReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<VulnerabilityReportByNode>>>;
  public getVulnerabilityReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<VulnerabilityReportByNode>>>;
  public getVulnerabilityReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getVulnerabilityReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<VulnerabilityReportByNode>>(`${this.configuration.basePath}/api/psnb/reports/getVulnerabilityReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * HMS Reset
   * @param ip
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public hmsReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public hmsReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public hmsReset(ip: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public hmsReset(ip: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling hmsReset.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling hmsReset.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling hmsReset.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/hmsReset`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Is User Admin
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public isAdmin(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public isAdmin(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public isAdmin(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public isAdmin(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/isAdmin`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Is User XOC Admin
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public isXOCAdmin(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public isXOCAdmin(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public isXOCAdmin(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public isXOCAdmin(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/isXOCAdmin`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Move Power Supply
   * @param movePowerSupply
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public movePowerSupply(movePowerSupply?: Array<MovePowerSupply>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyBatteryBulkUploadStatus>>;
  public movePowerSupply(movePowerSupply?: Array<MovePowerSupply>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyBatteryBulkUploadStatus>>>;
  public movePowerSupply(movePowerSupply?: Array<MovePowerSupply>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyBatteryBulkUploadStatus>>>;
  public movePowerSupply(movePowerSupply?: Array<MovePowerSupply>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyBatteryBulkUploadStatus>>(`${this.configuration.basePath}/api/psnb/ps/movePowerSupply`,
      movePowerSupply,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Power Supply Bulk Upload
   * @param powerSupplyBulkUpload
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public powerSupplyBulkUpload(powerSupplyBulkUpload?: Array<PowerSupplyBulkUpload>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public powerSupplyBulkUpload(powerSupplyBulkUpload?: Array<PowerSupplyBulkUpload>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public powerSupplyBulkUpload(powerSupplyBulkUpload?: Array<PowerSupplyBulkUpload>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public powerSupplyBulkUpload(powerSupplyBulkUpload?: Array<PowerSupplyBulkUpload>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/powerSupplyBulkUpload`,
      powerSupplyBulkUpload,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Power Supply Bulk Upload Status
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public powerSupplyBulkUploadStatus(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyBulkUploadStatus>>;
  public powerSupplyBulkUploadStatus(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyBulkUploadStatus>>>;
  public powerSupplyBulkUploadStatus(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyBulkUploadStatus>>>;
  public powerSupplyBulkUploadStatus(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyBulkUploadStatus>>(`${this.configuration.basePath}/api/psnb/powerSupplyBulkUploadStatus`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public powersupplynotebook(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Powersupplynotebook>;
  public powersupplynotebook(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Powersupplynotebook>>;
  public powersupplynotebook(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Powersupplynotebook>>;
  public powersupplynotebook(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling powersupplynotebook.');
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Powersupplynotebook>(`${this.configuration.basePath}/api/psnb/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Pull Transponder details from D3P
  //  * @param iP
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public pullTransponder(iP?: IP, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Transponder>;
  // public pullTransponder(iP?: IP, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Transponder>>;
  // public pullTransponder(iP?: IP, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Transponder>>;
  // public pullTransponder(iP?: IP, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     // to determine the Content-Type header
  //     const consumes: string[] = [
  //         'application/json',
  //         'application/xml'
  //     ];
  //     const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
  //     if (httpContentTypeSelected !== undefined) {
  //         headers = headers.set('Content-Type', httpContentTypeSelected);
  //     }

  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.post<Transponder>(`${this.configuration.basePath}/api/psnb/ps/pullTransponder`,
  //         iP,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Pull Transponder details from genome telemetry realtime data
   * @param iP
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pullTransponder(iP: IP, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<GenomeTransponderModelObject>;
  public pullTransponder(iP: IP, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<GenomeTransponderModelObject>>;
  public pullTransponder(iP: IP, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<GenomeTransponderModelObject>>;
  public pullTransponder(iP: IP, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (iP === null || iP === undefined) {
      throw new Error('Required parameter iP was null or undefined when calling pullTransponder.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<GenomeTransponderModelObject>(`${this.configuration.basePath}/api/psnb/ps/pullTransponder`,
      iP,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Reject Power Suppy Entry By Non Comcast User
   * @param triageId
   * @param reason
   * @param comments
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectTriagePowerSupply(triageId: number, reason: string, comments?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public rejectTriagePowerSupply(triageId: number, reason: string, comments?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public rejectTriagePowerSupply(triageId: number, reason: string, comments?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public rejectTriagePowerSupply(triageId: number, reason: string, comments?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling rejectTriagePowerSupply.');
    }
    if (reason === null || reason === undefined) {
      throw new Error('Required parameter reason was null or undefined when calling rejectTriagePowerSupply.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    if (reason !== undefined && reason !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>reason, 'reason');
    }
    if (comments !== undefined && comments !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>comments, 'comments');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/rejectPSTriage`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Restart Power Supply Bulk Upload
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public restartBulkProcess(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<string>;
  public restartBulkProcess(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<string>>;
  public restartBulkProcess(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<string>>;
  public restartBulkProcess(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling restartBulkProcess.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<string>(`${this.configuration.basePath}/api/psnb/restartBulkProcess/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retest Failed Remote Start Tests
   * @param pSRemoteTestStart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retestFailedTests(pSRemoteTestStart?: PSRemoteTestStart, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public retestFailedTests(pSRemoteTestStart?: PSRemoteTestStart, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public retestFailedTests(pSRemoteTestStart?: PSRemoteTestStart, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public retestFailedTests(pSRemoteTestStart?: PSRemoteTestStart, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/retestFailedStartTests`,
      pSRemoteTestStart,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Run Power Supply Hierarchy Reconciler Manually
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public runPSHieRecManually(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<string>;
  public runPSHieRecManually(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<string>>;
  public runPSHieRecManually(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<string>>;
  public runPSHieRecManually(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<string>(`${this.configuration.basePath}/api/psnb/runPSHieRecManually`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Store Approved Triage Power Supply Image
   * @param triageId
   * @param powerSupplyId
   * @param acceptedRejectedTriages
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveApprovedTriageImage(triageId: number, powerSupplyId: number, acceptedRejectedTriages?: AcceptedRejectedTriages, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveApprovedTriageImage(triageId: number, powerSupplyId: number, acceptedRejectedTriages?: AcceptedRejectedTriages, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveApprovedTriageImage(triageId: number, powerSupplyId: number, acceptedRejectedTriages?: AcceptedRejectedTriages, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveApprovedTriageImage(triageId: number, powerSupplyId: number, acceptedRejectedTriages?: AcceptedRejectedTriages, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling saveApprovedTriageImage.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling saveApprovedTriageImage.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/mobile/image/saveApprovedTriageImage`,
      acceptedRejectedTriages,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply Mobile Triage Approved changes to DB
   * @param powerSupplyApproveRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveApprovedTriagePowerSupply(powerSupplyApproveRequest?: PowerSupplyApproveRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<TriageBaseResponse>;
  public saveApprovedTriagePowerSupply(powerSupplyApproveRequest?: PowerSupplyApproveRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<TriageBaseResponse>>;
  public saveApprovedTriagePowerSupply(powerSupplyApproveRequest?: PowerSupplyApproveRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<TriageBaseResponse>>;
  public saveApprovedTriagePowerSupply(powerSupplyApproveRequest?: PowerSupplyApproveRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<TriageBaseResponse>(`${this.configuration.basePath}/api/psnb/mobile/saveApprovedTriagePowerSupply`,
      powerSupplyApproveRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply changes to DB
   * @param powerSupply
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePowerSupply(powerSupply?: PowerSupply, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public savePowerSupply(powerSupply?: PowerSupply, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public savePowerSupply(powerSupply?: PowerSupply, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public savePowerSupply(powerSupply?: PowerSupply, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/savePowerSupply`,
      powerSupply,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply Mobile changes to DB
   * @param powerSupplyTriage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriage>;
  public savePowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriage>>;
  public savePowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriage>>;
  public savePowerSupplyForNonComcastUsers(powerSupplyTriage?: PowerSupplyTriage, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyTriage>(`${this.configuration.basePath}/api/psnb/mobile/savePowerSupplyForNonComcastUsers`,
      powerSupplyTriage,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sayHelloWorld(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<string>;
  public sayHelloWorld(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<string>>;
  public sayHelloWorld(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<string>>;
  public sayHelloWorld(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        '*/*'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<string>(`${this.configuration.basePath}/helloworld`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search Fiber Node
   * @param nodeId
   * @param search
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchFiberNode(nodeId: number, search: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<FiberNode>>;
  public searchFiberNode(nodeId: number, search: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<FiberNode>>>;
  public searchFiberNode(nodeId: number, search: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<FiberNode>>>;
  public searchFiberNode(nodeId: number, search: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling searchFiberNode.');
    }
    if (search === null || search === undefined) {
      throw new Error('Required parameter search was null or undefined when calling searchFiberNode.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>search, 'search');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<FiberNode>>(`${this.configuration.basePath}/api/psnb/network/searchFiberNode`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search power supplies
   * @param powerSupplyName
   * @param node
   * @param nodeCommunintyServed
   * @param nodeId
   * @param macAddress
   * @param address
   * @param latitude
   * @param longitude
   * @param distance
   * @param headendOrCommunity
   * @param regionId
   * @param powerSupplyId
   * @param nodeText
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPowerSupplies(powerSupplyName?: string, node?: string, nodeCommunintyServed?: string, nodeId?: number, macAddress?: string, address?: string, latitude?: number, longitude?: number, distance?: number, headendOrCommunity?: string, regionId?: number, powerSupplyId?: number, nodeText?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupply>>;
  public searchPowerSupplies(powerSupplyName?: string, node?: string, nodeCommunintyServed?: string, nodeId?: number, macAddress?: string, address?: string, latitude?: number, longitude?: number, distance?: number, headendOrCommunity?: string, regionId?: number, powerSupplyId?: number, nodeText?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupply>>>;
  public searchPowerSupplies(powerSupplyName?: string, node?: string, nodeCommunintyServed?: string, nodeId?: number, macAddress?: string, address?: string, latitude?: number, longitude?: number, distance?: number, headendOrCommunity?: string, regionId?: number, powerSupplyId?: number, nodeText?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupply>>>;
  public searchPowerSupplies(powerSupplyName?: string, node?: string, nodeCommunintyServed?: string, nodeId?: number, macAddress?: string, address?: string, latitude?: number, longitude?: number, distance?: number, headendOrCommunity?: string, regionId?: number, powerSupplyId?: number, nodeText?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyName !== undefined && powerSupplyName !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyName, 'powerSupplyName');
    }
    if (node !== undefined && node !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>node, 'node');
    }
    if (nodeCommunintyServed !== undefined && nodeCommunintyServed !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeCommunintyServed, 'nodeCommunintyServed');
    }
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (address !== undefined && address !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>address, 'address');
    }
    if (latitude !== undefined && latitude !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>latitude, 'latitude');
    }
    if (longitude !== undefined && longitude !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>longitude, 'longitude');
    }
    if (distance !== undefined && distance !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>distance, 'distance');
    }
    if (headendOrCommunity !== undefined && headendOrCommunity !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>headendOrCommunity, 'headendOrCommunity');
    }
    if (regionId !== undefined && regionId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>regionId, 'regionId');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (nodeText !== undefined && nodeText !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeText, 'nodeText');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupply>>(`${this.configuration.basePath}/api/psnb/search/searchPowerSupplies`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Search Power Supply by hierarchy
   * @param psSearchByHieRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPowerSupplyByHie(psSearchByHieRequest: PsSearchByHieRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsSearchByHieResponse>;
  public searchPowerSupplyByHie(psSearchByHieRequest: PsSearchByHieRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsSearchByHieResponse>>;
  public searchPowerSupplyByHie(psSearchByHieRequest: PsSearchByHieRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsSearchByHieResponse>>;
  public searchPowerSupplyByHie(psSearchByHieRequest: PsSearchByHieRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psSearchByHieRequest === null || psSearchByHieRequest === undefined) {
      throw new Error('Required parameter psSearchByHieRequest was null or undefined when calling searchPowerSupplyByHie.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PsSearchByHieResponse>(`${this.configuration.basePath}/api/psnb/search/searchPowerSupplyByHie`,
      psSearchByHieRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  // /**
  //  * Search Power Supply Triage by hierarchy
  //  * @param nodeId
  //  * @param status
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public searchPowerSupplyTriageByHie(nodeId: number, status: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyTriage>>;
  // public searchPowerSupplyTriageByHie(nodeId: number, status: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyTriage>>>;
  // public searchPowerSupplyTriageByHie(nodeId: number, status: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyTriage>>>;
  // public searchPowerSupplyTriageByHie(nodeId: number, status: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (nodeId === null || nodeId === undefined) {
  //         throw new Error('Required parameter nodeId was null or undefined when calling searchPowerSupplyTriageByHie.');
  //     }
  //     if (status === null || status === undefined) {
  //         throw new Error('Required parameter status was null or undefined when calling searchPowerSupplyTriageByHie.');
  //     }

  //     let queryParameters = new HttpParams({encoder: this.encoder});
  //     if (nodeId !== undefined && nodeId !== null) {
  //       queryParameters = this.addToHttpParams(queryParameters,
  //         <any>nodeId, 'nodeId');
  //     }
  //     if (status !== undefined && status !== null) {
  //       queryParameters = this.addToHttpParams(queryParameters,
  //         <any>status, 'status');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<PowerSupplyTriage>>(`${this.configuration.basePath}/api/psnb/mobile/searchPowerSupplyTriageByHie`,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }


  /**
   * Search Power Supply Triage by hierarchy
   * @param searchPsTriageByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPowerSupplyTriageByHie(searchPsTriageByHie: SearchPsTriageByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyTriage>>;
  public searchPowerSupplyTriageByHie(searchPsTriageByHie: SearchPsTriageByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyTriage>>>;
  public searchPowerSupplyTriageByHie(searchPsTriageByHie: SearchPsTriageByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyTriage>>>;
  public searchPowerSupplyTriageByHie(searchPsTriageByHie: SearchPsTriageByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (searchPsTriageByHie === null || searchPsTriageByHie === undefined) {
      throw new Error('Required parameter searchPsTriageByHie was null or undefined when calling searchPowerSupplyTriageByHie.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyTriage>>(`${this.configuration.basePath}/api/psnb/mobile/searchPowerSupplyTriageByHie`,
      searchPsTriageByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Self Test Start
   * @param ip
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public selfTestStart(ip: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public selfTestStart(ip: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public selfTestStart(ip: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public selfTestStart(ip: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling selfTestStart.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling selfTestStart.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling selfTestStart.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/selfTestStart`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Self Test Stop
   * @param ip
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public selfTestStop(ip: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public selfTestStop(ip: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public selfTestStop(ip: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public selfTestStop(ip: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling selfTestStop.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling selfTestStop.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling selfTestStop.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/selfTestStop`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Send Notification
   * @param file
   * @param jsonPart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendNotification(file?: Blob, jsonPart?: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public sendNotification(file?: Blob, jsonPart?: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public sendNotification(file?: Blob, jsonPart?: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public sendNotification(file?: Blob, jsonPart?: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'multipart/form-data'
    ];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any; };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({encoder: this.encoder});
    }

    if (file !== undefined) {
      formParams = formParams.append('file', <any>file) as any || formParams;
    }
    if (jsonPart !== undefined) {
      formParams = formParams.append('jsonPart', <any>jsonPart) as any || formParams;
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/sendNotification`,
      convertFormParamsToString ? formParams.toString() : formParams,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public serviceAppContextLogVerificationCheck(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<string>;
  public serviceAppContextLogVerificationCheck(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<string>>;
  public serviceAppContextLogVerificationCheck(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<string>>;
  public serviceAppContextLogVerificationCheck(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        '*/*'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<string>(`${this.configuration.basePath}/api/flightcheck/functional/logVerification`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Set Test Duration by IP
   * @param ip
   * @param testDuration
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setTestDurationByIP(ip: string, testDuration: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public setTestDurationByIP(ip: string, testDuration: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public setTestDurationByIP(ip: string, testDuration: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public setTestDurationByIP(ip: string, testDuration: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling setTestDurationByIP.');
    }
    if (testDuration === null || testDuration === undefined) {
      throw new Error('Required parameter testDuration was null or undefined when calling setTestDurationByIP.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (testDuration !== undefined && testDuration !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>testDuration, 'testDuration');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/setTestDurationByIP`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Set Test Duration by MAC
   * @param mac
   * @param testDuration
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setTestDurationByMac(mac: string, testDuration: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public setTestDurationByMac(mac: string, testDuration: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public setTestDurationByMac(mac: string, testDuration: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public setTestDurationByMac(mac: string, testDuration: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling setTestDurationByMac.');
    }
    if (testDuration === null || testDuration === undefined) {
      throw new Error('Required parameter testDuration was null or undefined when calling setTestDurationByMac.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (mac !== undefined && mac !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>mac, 'mac');
    }
    if (testDuration !== undefined && testDuration !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>testDuration, 'testDuration');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/setTestDurationByMac`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Stop Running Tests
   * @param pSRemoteTestStopRequests
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public stopRunningTest(pSRemoteTestStopRequests?: PSRemoteTestStopRequests, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public stopRunningTest(pSRemoteTestStopRequests?: PSRemoteTestStopRequests, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public stopRunningTest(pSRemoteTestStopRequests?: PSRemoteTestStopRequests, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public stopRunningTest(pSRemoteTestStopRequests?: PSRemoteTestStopRequests, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/StopRunningTest`,
      pSRemoteTestStopRequests,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Write power supply name, location to network transponder device that have null sysname
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public syncPSOnNeworkWithNullSysName(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public syncPSOnNeworkWithNullSysName(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public syncPSOnNeworkWithNullSysName(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public syncPSOnNeworkWithNullSysName(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/syncPSOnNeworkWithNullSysName`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Write power supply name, location to network transponder device that have mismatch with PSNB inventory
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public syncPSOnNeworkWithSysNameOrLocationMismatch(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public syncPSOnNeworkWithSysNameOrLocationMismatch(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public syncPSOnNeworkWithSysNameOrLocationMismatch(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public syncPSOnNeworkWithSysNameOrLocationMismatch(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/syncPSOnNeworkWithSysNameOrLocationMismatch`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public testAzureConnection(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public testAzureConnection(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public testAzureConnection(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public testAzureConnection(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/psnb/testAzure`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public testSoap(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
  public testSoap(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
  public testSoap(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
  public testSoap(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<any>(`${this.configuration.basePath}/testSoap`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Access Log
   * @param accessLog
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAccessLog(accessLog?: AccessLog, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateAccessLog(accessLog?: AccessLog, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateAccessLog(accessLog?: AccessLog, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateAccessLog(accessLog?: AccessLog, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateAccessLog`,
      accessLog,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Admin User
   * @param adminUser
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAdminUser(adminUser?: AdminUser, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateAdminUser(adminUser?: AdminUser, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateAdminUser(adminUser?: AdminUser, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateAdminUser(adminUser?: AdminUser, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/updateAdminUser`,
      adminUser,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Threshold Config
   * @param alertThresholdConfigRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAlertThresholdConfigList(alertThresholdConfigRequest?: Array<AlertThresholdConfigRequest>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateAlertThresholdConfigList(alertThresholdConfigRequest?: Array<AlertThresholdConfigRequest>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateAlertThresholdConfigList(alertThresholdConfigRequest?: Array<AlertThresholdConfigRequest>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateAlertThresholdConfigList(alertThresholdConfigRequest?: Array<AlertThresholdConfigRequest>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/updateThresholdConfig`,
      alertThresholdConfigRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update APU
   * @param apu
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateApu(apu?: Apu, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateApu(apu?: Apu, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateApu(apu?: Apu, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateApu(apu?: Apu, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateApu`,
      apu,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update APU type
   * @param apuType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateApuType(apuType?: ApuType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateApuType(apuType?: ApuType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateApuType(apuType?: ApuType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateApuType(apuType?: ApuType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateApuType`,
      apuType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update APU Visit
   * @param apuShowVisit
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateApuVisit(apuShowVisit?: ApuShowVisit, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateApuVisit(apuShowVisit?: ApuShowVisit, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateApuVisit`,
      apuShowVisit,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Battery Balancer
   * @param batteryBalancer
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBatteryBalancer(batteryBalancer?: BatteryBalancer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public updateBatteryBalancer(batteryBalancer?: BatteryBalancer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public updateBatteryBalancer(batteryBalancer?: BatteryBalancer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public updateBatteryBalancer(batteryBalancer?: BatteryBalancer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<number>(`${this.configuration.basePath}/api/psnb/admin/updateBatteryBalancer`,
      batteryBalancer,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Battery Heater Mat Type
   * @param batteryHeaterMatType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateBatteryHeaterMatType(batteryHeaterMatType?: BatteryHeaterMatType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateBatteryHeaterMatType`,
      batteryHeaterMatType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Battery Type
   * @param batteryType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBatteryType(batteryType?: BatteryType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateBatteryType(batteryType?: BatteryType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateBatteryType(batteryType?: BatteryType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateBatteryType(batteryType?: BatteryType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateBatteryType`,
      batteryType,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Cabinet Vendor
   * @param cabinetVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateCabinetVendor(cabinetVendor?: CabinetVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateCabinetVendor(cabinetVendor?: CabinetVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateCabinetVendor`,
      cabinetVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Update Controller Card Type
  //  * @param controllerCardType
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public updateControllerCardType(controllerCardType?: ControllerCardType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  // public updateControllerCardType(controllerCardType?: ControllerCardType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  // public updateControllerCardType(controllerCardType?: ControllerCardType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  // public updateControllerCardType(controllerCardType?: ControllerCardType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     // to determine the Content-Type header
  //     const consumes: string[] = [
  //         'application/json',
  //         'application/xml'
  //     ];
  //     const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
  //     if (httpContentTypeSelected !== undefined) {
  //         headers = headers.set('Content-Type', httpContentTypeSelected);
  //     }

  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.put<number>(`${this.configuration.basePath}/api/psnb/admin/updateControllerCardType`,
  //         controllerCardType,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Update Estimated Design Runtime
   * @param estimatedDesignRuntime
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateEstimatedDesignRuntime(estimatedDesignRuntime?: EstimatedDesignRuntime, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateEstimatedDesignRuntime`,
      estimatedDesignRuntime,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Input Surge Arrestor
   * @param inputSurgeArrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateInputSurgeArrestor(inputSurgeArrestor?: InputSurgeArrestor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateInputSurgeArrestor`,
      inputSurgeArrestor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Natural Gas Provider
   * @param naturalGasProvider
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateNaturalGasProvider(naturalGasProvider?: NaturalGasProvider, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateNaturalGasProvider`,
      naturalGasProvider,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Next Gen Node
   * @param nextGenNode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateNextGenNode(nextGenNode?: NextGenNode, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateNextGenNode(nextGenNode?: NextGenNode, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateNextGenNode(nextGenNode?: NextGenNode, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateNextGenNode(nextGenNode?: NextGenNode, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateNextGenNode`,
      nextGenNode,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Output Surge Arrestor
   * @param outputSurgeArrestor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateOutputSurgeArrestor(outputSurgeArrestor?: OutputSurgeArrestor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateOutputSurgeArrestor`,
      outputSurgeArrestor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Power Supply Cpn
   * @param powerSupplyCpn2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePowerSupplyCpn(powerSupplyCpn2?: PowerSupplyCpn2, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePowerSupplyCpn(powerSupplyCpn2?: PowerSupplyCpn2, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePowerSupplyCpn(powerSupplyCpn2?: PowerSupplyCpn2, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePowerSupplyCpn(powerSupplyCpn2?: PowerSupplyCpn2, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updatePowerSupplyCpn`,
      powerSupplyCpn2,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Power Supply Model
   * @param powerSupplyModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePowerSupplyModel(powerSupplyModel?: PowerSupplyModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updatePowerSupplyModel`,
      powerSupplyModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Battery Type
   * @param powerSupplyVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePowerSupplyVendor(powerSupplyVendor?: PowerSupplyVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updatePowerSupplyVendor`,
      powerSupplyVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Prefix
   * @param prefix
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePrefix(prefix?: Prefix, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePrefix(prefix?: Prefix, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePrefix(prefix?: Prefix, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePrefix(prefix?: Prefix, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updatePrefix`,
      prefix,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Scroller
   * @param scroller
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateScroller(scroller?: Scroller, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateScroller(scroller?: Scroller, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateScroller(scroller?: Scroller, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateScroller(scroller?: Scroller, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateScroller`,
      scroller,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Transponder Model
   * @param transponderModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTransponderModel(transponderModel?: TransponderModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateTransponderModel(transponderModel?: TransponderModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateTransponderModel(transponderModel?: TransponderModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateTransponderModel(transponderModel?: TransponderModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateTransponderModel`,
      transponderModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Transponder Vendor
   * @param transponderVendor
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateTransponderVendor(transponderVendor?: TransponderVendor, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateTransponderVendor(transponderVendor?: TransponderVendor, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateTransponderVendor`,
      transponderVendor,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Upload Power Supply Image
   * @param triageId
   * @param filePart
   * @param jsonPart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public uploadImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public uploadImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public uploadImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public uploadImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'multipart/form-data'
    ];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any; };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({encoder: this.encoder});
    }

    if (filePart) {
      if (useForm) {
        filePart.forEach((element) => {
          formParams = formParams.append('filePart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('filePart', filePart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }
    if (jsonPart) {
      if (useForm) {
        jsonPart.forEach((element) => {
          formParams = formParams.append('jsonPart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('jsonPart', jsonPart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/uploadPsnbImage`,
      convertFormParamsToString ? formParams.toString() : formParams,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Upload Power Supply Image
  //  * @param triageId
  //  * @param filePart
  //  * @param jsonPart
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public uploadSdsImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  // public uploadSdsImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  // public uploadSdsImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  // public uploadSdsImage(triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

  //     let queryParameters = new HttpParams({encoder: this.encoder});
  //     if (triageId !== undefined && triageId !== null) {
  //       queryParameters = this.addToHttpParams(queryParameters,
  //         <any>triageId, 'triageId');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }

  //     // to determine the Content-Type header
  //     const consumes: string[] = [
  //         'multipart/form-data'
  //     ];

  //     const canConsumeForm = this.canConsumeForm(consumes);

  //     let formParams: { append(param: string, value: any): any; };
  //     let useForm = false;
  //     let convertFormParamsToString = false;
  //     // use FormData to transmit files using content-type "multipart/form-data"
  //     // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
  //     useForm = canConsumeForm;
  //     // use FormData to transmit files using content-type "multipart/form-data"
  //     // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
  //     useForm = canConsumeForm;
  //     if (useForm) {
  //         formParams = new FormData();
  //     } else {
  //         formParams = new HttpParams({encoder: this.encoder});
  //     }

  //     if (filePart) {
  //         if (useForm) {
  //             filePart.forEach((element) => {
  //                 formParams = formParams.append('filePart', <any>element) as any || formParams;
  //         })
  //         } else {
  //             formParams = formParams.append('filePart', filePart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
  //         }
  //     }
  //     if (jsonPart) {
  //         if (useForm) {
  //             jsonPart.forEach((element) => {
  //                 formParams = formParams.append('jsonPart', <any>element) as any || formParams;
  //         })
  //         } else {
  //             formParams = formParams.append('jsonPart', jsonPart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
  //         }
  //     }

  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/uploadSdsImage`,
  //         convertFormParamsToString ? formParams.toString() : formParams,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Upload Power Supply Image
   * @param filePart
   * @param jsonPart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public uploadSdsPDFImage(filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public uploadSdsPDFImage(filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public uploadSdsPDFImage(filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public uploadSdsPDFImage(filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'multipart/form-data'
    ];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any; };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({encoder: this.encoder});
    }

    if (filePart) {
      if (useForm) {
        filePart.forEach((element) => {
          formParams = formParams.append('filePart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('filePart', filePart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }
    if (jsonPart) {
      if (useForm) {
        jsonPart.forEach((element) => {
          formParams = formParams.append('jsonPart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('jsonPart', jsonPart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/uploadSdsPDFImage`,
      convertFormParamsToString ? formParams.toString() : formParams,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * This service is for uploading spatial net id upload
   * @param spatialNetUpload
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public uploadSpatialNetData(spatialNetUpload?: Array<SpatialNetUpload>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<SpatialNetUploadStatus>;
  public uploadSpatialNetData(spatialNetUpload?: Array<SpatialNetUpload>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<SpatialNetUploadStatus>>;
  public uploadSpatialNetData(spatialNetUpload?: Array<SpatialNetUpload>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<SpatialNetUploadStatus>>;
  public uploadSpatialNetData(spatialNetUpload?: Array<SpatialNetUpload>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<SpatialNetUploadStatus>(`${this.configuration.basePath}/api/psnb/admin/uploadSpatialNetData`,
      spatialNetUpload,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Validate Mac Place Holder
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateMacPlaceholder(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public validateMacPlaceholder(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public validateMacPlaceholder(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public validateMacPlaceholder(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling validateMacPlaceholder.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/validateMacPlaceholder/${encodeURIComponent(String(mac))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Remote Test History
   * @param psId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyRemoteTestHistory(psId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTestHistory>>;
  public getPowerSupplyRemoteTestHistory(psId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTestHistory>>>;
  public getPowerSupplyRemoteTestHistory(psId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTestHistory>>>;
  public getPowerSupplyRemoteTestHistory(psId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getPowerSupplyRemoteTestHistory.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTestHistory>>(`${this.configuration.basePath}/api/psnb/psRemoteTest/getPowerSupplyRemoteTestHistory`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //      * Get power supply telemetry history data
  //      * @param telemetryHistoryRequest
  //      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //      * @param reportProgress flag to report request and response progress.
  //      */
  //     public getPowerSupplyTelemetryHistory(telemetryHistoryRequest?: TelemetryHistoryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<GenomeTelemetryHistoryResponses>;
  //     public getPowerSupplyTelemetryHistory(telemetryHistoryRequest?: TelemetryHistoryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<GenomeTelemetryHistoryResponses>>;
  //     public getPowerSupplyTelemetryHistory(telemetryHistoryRequest?: TelemetryHistoryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<GenomeTelemetryHistoryResponses>>;
  //     public getPowerSupplyTelemetryHistory(telemetryHistoryRequest?: TelemetryHistoryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

  //         let headers = this.defaultHeaders;

  //         // authentication (bearerAuth) required
  //         if (this.configuration.accessToken) {
  //             const accessToken = typeof this.configuration.accessToken === 'function'
  //                 ? this.configuration.accessToken()
  //                 : this.configuration.accessToken;
  //             headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //         }
  //         let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //         if (httpHeaderAcceptSelected === undefined) {
  //             // to determine the Accept header
  //             const httpHeaderAccepts: string[] = [
  //                 'application/json',
  //                 'application/xml'
  //             ];
  //             httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //         }
  //         if (httpHeaderAcceptSelected !== undefined) {
  //             headers = headers.set('Accept', httpHeaderAcceptSelected);
  //         }


  //         // to determine the Content-Type header
  //         const consumes: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
  //         if (httpContentTypeSelected !== undefined) {
  //             headers = headers.set('Content-Type', httpContentTypeSelected);
  //         }

  //         let responseType: 'text' | 'json' = 'json';
  //         if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //             responseType = 'text';
  //         }
  //         //return this.httpClient.post<GenomeTelemetryHistoryResponses>(`${this.configuration.basePath}/api/psnb/telemetry/history/getPowerSupplyTelemetryHistory`,
  //         return this.httpClient.post<GenomeTelemetryHistoryResponses>(`http://localhost:6062/api/psnb/telemetry/history/getPowerSupplyTelemetryHistory`,
  //         telemetryHistoryRequest,
  //             {
  //                 responseType: <any>responseType,
  //                 withCredentials: this.configuration.withCredentials,
  //                 headers: headers,
  //                 observe: observe,
  //                 reportProgress: reportProgress
  //             }
  //         );
  //     }


  /**
   * Get power supply telemetry history data

   * @param telemetryHistoryRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyTelemetryHistory(telemetryHistoryRequest: TelemetryHistoryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<GenomeTelemetryHistoryResponses>;
  public getPowerSupplyTelemetryHistory(telemetryHistoryRequest: TelemetryHistoryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<GenomeTelemetryHistoryResponses>>;
  public getPowerSupplyTelemetryHistory(telemetryHistoryRequest: TelemetryHistoryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<GenomeTelemetryHistoryResponses>>;
  public getPowerSupplyTelemetryHistory(telemetryHistoryRequest: TelemetryHistoryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (telemetryHistoryRequest === null || telemetryHistoryRequest === undefined) {
      throw new Error('Required parameter telemetryHistoryRequest was null or undefined when calling getPowerSupplyTelemetryHistory.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    let basePath: string = this.configuration.basePath;
    if (basePath === undefined || basePath === null || basePath.length === 0) {
      basePath = this.psnbBasePath;
    }

    return this.httpClient.post<GenomeTelemetryHistoryResponses>(
      `${basePath}/api/psnb/telemetry/history/getPowerSupplyTelemetryHistory`,
      telemetryHistoryRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }




  /**

   * Update Power Supply ID by Mac
   * @param imageMetaDataUpdateRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePSIDAndTriageIDByMacAndCategory(imageMetaDataUpdateRequest?: ImageMetaDataUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public updatePSIDAndTriageIDByMacAndCategory(imageMetaDataUpdateRequest?: ImageMetaDataUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePSIDAndTriageIDByMacAndCategory(imageMetaDataUpdateRequest?: ImageMetaDataUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePSIDAndTriageIDByMacAndCategory(imageMetaDataUpdateRequest?: ImageMetaDataUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/updatePSIDAndTriageIDByMacAndCategory`,
      imageMetaDataUpdateRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Create PS Edit Fields Metadata
   * @param psEditFieldsMetadata
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public createPsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public createPsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public createPsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<number>(`${this.configuration.basePath}/api/psnb/admin/createPsEditFieldsMetadata`,
      psEditFieldsMetadata,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Update PS Edit Fields Metadata
   * @param psEditFieldsMetadata
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public updatePsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public updatePsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public updatePsEditFieldsMetadata(psEditFieldsMetadata?: PsEditFieldsMetadata, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<number>(`${this.configuration.basePath}/api/psnb/admin/updatePsEditFieldsMetadata`,
      psEditFieldsMetadata,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get All PS Edit Fields Metadata
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllPsEditFieldsMetadata(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsEditFieldsMetadata>>;
  public getAllPsEditFieldsMetadata(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsEditFieldsMetadata>>>;
  public getAllPsEditFieldsMetadata(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsEditFieldsMetadata>>>;
  public getAllPsEditFieldsMetadata(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsEditFieldsMetadata>>(`${this.configuration.basePath}/api/psnb/admin/getAllPsEditFieldsMetadata`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Edit Fields Metadata
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePsEditFieldsMetadata(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deletePsEditFieldsMetadata(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deletePsEditFieldsMetadata(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deletePsEditFieldsMetadata(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePsEditFieldsMetadata.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deletePsEditFieldsMetadata/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Upload Power Supply Image
   * @param actionType
   * @param triageId
   * @param filePart
   * @param jsonPart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public uploadSdsImage(actionType: string, triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
  public uploadSdsImage(actionType: string, triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
  public uploadSdsImage(actionType: string, triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
  public uploadSdsImage(actionType: string, triageId?: number, filePart?: Array<Blob>, jsonPart?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
    if (actionType === null || actionType === undefined) {
      throw new Error('Required parameter actionType was null or undefined when calling uploadSdsImage.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    if (actionType !== undefined && actionType !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>actionType, 'actionType');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'multipart/form-data'
    ];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any; };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({encoder: this.encoder});
    }

    if (filePart) {
      if (useForm) {
        filePart.forEach((element) => {
          formParams = formParams.append('filePart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('filePart', filePart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }
    if (jsonPart) {
      if (useForm) {
        jsonPart.forEach((element) => {
          formParams = formParams.append('jsonPart', <any>element) as any || formParams;
        })
      } else {
        formParams = formParams.append('jsonPart', jsonPart.join(COLLECTION_FORMATS['csv'])) as any || formParams;
      }
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/image/sds/uploadSdsImage`,
      convertFormParamsToString ? formParams.toString() : formParams,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PS BillingCodes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsBillingCodes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsBillingCodes>>;
  public getPsBillingCodes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsBillingCodes>>>;
  public getPsBillingCodes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsBillingCodes>>>;
  public getPsBillingCodes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsBillingCodes>>(`${this.configuration.basePath}/api/psnb/admin/getPsBillingCodes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Create PS Billing Codes
   * @param psBillingCodes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public createPsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public createPsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public createPsBillingCodes(psBillingCodes?: PsBillingCodes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<number>(`${this.configuration.basePath}/api/psnb/admin/createPsBillingCodes`,
      psBillingCodes,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Update PS Billing Codes
   * @param psBillingCodes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public updatePsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public updatePsBillingCodes(psBillingCodes?: PsBillingCodes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public updatePsBillingCodes(psBillingCodes?: PsBillingCodes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<number>(`${this.configuration.basePath}/api/psnb/admin/updatePsBillingCodes`,
      psBillingCodes,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Delete PS Billing Codes
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePsBillingCodes(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deletePsBillingCodes(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deletePsBillingCodes(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deletePsBillingCodes(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePsBillingCodes.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deletePsBillingCodes/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply combined inventory Report Export Stream
   * @param psCombinedReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCombinedInventoryPowerSupplyReportsExportStream(psCombinedReportsByHie: PsCombinedReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<Blob>;
  public getCombinedInventoryPowerSupplyReportsExportStream(psCombinedReportsByHie: PsCombinedReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpResponse<Blob>>;
  public getCombinedInventoryPowerSupplyReportsExportStream(psCombinedReportsByHie: PsCombinedReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpEvent<Blob>>;
  public getCombinedInventoryPowerSupplyReportsExportStream(psCombinedReportsByHie: PsCombinedReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv'}): Observable<any> {
    if (psCombinedReportsByHie === null || psCombinedReportsByHie === undefined) {
      throw new Error('Required parameter psCombinedReportsByHie was null or undefined when calling getCombinedInventoryPowerSupplyReportsExportStream.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/csv'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post(`${this.configuration.basePath}/api/psnb/reports/getCombinedInventoryPowerSupplyReportsExportStream`,
      psCombinedReportsByHie,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PowerSupply combined inventory Report Export Stream for Divisional level
   * @param psCombinedReportsByDivision
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCombinedInventoryPowerSupplyReportsExportStreamDivLevel(psCombinedReportsByDivision: PsCombinedReportsByDivision, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<Blob>;
  public getCombinedInventoryPowerSupplyReportsExportStreamDivLevel(psCombinedReportsByDivision: PsCombinedReportsByDivision, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpResponse<Blob>>;
  public getCombinedInventoryPowerSupplyReportsExportStreamDivLevel(psCombinedReportsByDivision: PsCombinedReportsByDivision, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpEvent<Blob>>;
  public getCombinedInventoryPowerSupplyReportsExportStreamDivLevel(psCombinedReportsByDivision: PsCombinedReportsByDivision, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv'}): Observable<any> {
    if (psCombinedReportsByDivision === null || psCombinedReportsByDivision === undefined) {
      throw new Error('Required parameter psCombinedReportsByDivision was null or undefined when calling getCombinedInventoryPowerSupplyReportsExportStreamDivLevel.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/csv'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post(`${this.configuration.basePath}/api/psnb/reports/getCombinedInventoryPowerSupplyReportsExportStreamDivLevel`,
      psCombinedReportsByDivision,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply status based on active alerts by powerSupplyId
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyStatusList(requestBody: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyAlertStatusResponse>;
  public getPowerSupplyStatusList(requestBody: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyAlertStatusResponse>>;
  public getPowerSupplyStatusList(requestBody: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyAlertStatusResponse>>;
  public getPowerSupplyStatusList(requestBody: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling getPowerSupplyStatusList.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyAlertStatusResponse>(`${this.configuration.basePath}/api/psnb/ps/getPowerSupplyStatusList`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply telemetry thresholds alert profile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTelemetryThresholdsAlertProfile(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getTelemetryThresholdsAlertProfile(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getTelemetryThresholdsAlertProfile(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getTelemetryThresholdsAlertProfile(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/telemetry/getTelemetryThresholdsAlertProfile`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PS Certification ID
   * @param powerSupplyId
   * @param inspectionDate
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSCertificationID(powerSupplyId: number, inspectionDate?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public getPSCertificationID(powerSupplyId: number, inspectionDate?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public getPSCertificationID(powerSupplyId: number, inspectionDate?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public getPSCertificationID(powerSupplyId: number, inspectionDate?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPSCertificationID.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (inspectionDate !== undefined && inspectionDate !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>inspectionDate, 'inspectionDate');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<number>(`${this.configuration.basePath}/api/psnb/psCert/getPSCertificationID`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Certifications
   * @param powerSupplyId
   * @param psCertificationId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSCertifications(powerSupplyId: number, psCertificationId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyCertificationsReqResponse>>;
  public getPSCertifications(powerSupplyId: number, psCertificationId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyCertificationsReqResponse>>>;
  public getPSCertifications(powerSupplyId: number, psCertificationId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyCertificationsReqResponse>>>;
  public getPSCertifications(powerSupplyId: number, psCertificationId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPSCertifications.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (psCertificationId !== undefined && psCertificationId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psCertificationId, 'psCertificationId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyCertificationsReqResponse>>(`${this.configuration.basePath}/api/psnb/psCert/getPSCertifications`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Certificate
   * @param powerSupplyCertificationsReqResponse
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePSCertificate(powerSupplyCertificationsReqResponse: PowerSupplyCertificationsReqResponse, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public savePSCertificate(powerSupplyCertificationsReqResponse: PowerSupplyCertificationsReqResponse, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public savePSCertificate(powerSupplyCertificationsReqResponse: PowerSupplyCertificationsReqResponse, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public savePSCertificate(powerSupplyCertificationsReqResponse: PowerSupplyCertificationsReqResponse, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyCertificationsReqResponse === null || powerSupplyCertificationsReqResponse === undefined) {
      throw new Error('Required parameter powerSupplyCertificationsReqResponse was null or undefined when calling savePSCertificate.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/savePSCertificate`,
      powerSupplyCertificationsReqResponse,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Certification WorkItem
   * @param pSCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertWorkItem === null || pSCertWorkItem === undefined) {
      throw new Error('Required parameter pSCertWorkItem was null or undefined when calling saveWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }
    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/saveWorkItem`,
      pSCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Certification WorkItem
   * @param psWorkItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkItem(psWorkItemId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteWorkItem(psWorkItemId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteWorkItem(psWorkItemId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteWorkItem(psWorkItemId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psWorkItemId === null || psWorkItemId === undefined) {
      throw new Error('Required parameter psWorkItemId was null or undefined when calling deleteWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/deleteWorkItem/${encodeURIComponent(String(psWorkItemId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   /**
   * Get PS Cert Work Item
   * @param powerSupplyId
   * @param psCertificationId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getWorkItems(powerSupplyId: number, psCertificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertWorkItem>>;
  public getWorkItems(powerSupplyId: number, psCertificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertWorkItem>>>;
  public getWorkItems(powerSupplyId: number, psCertificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertWorkItem>>>;
  public getWorkItems(powerSupplyId: number, psCertificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getWorkItems.');
    }
    if (psCertificationId === null || psCertificationId === undefined) {
      throw new Error('Required parameter psCertificationId was null or undefined when calling getWorkItems.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (psCertificationId !== undefined && psCertificationId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psCertificationId, 'psCertificationId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertWorkItem>>(`${this.configuration.basePath}/api/psnb/psCert/getWorkItems`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit PS Certification WorkItem
   * @param pSCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editWorkItem(pSCertWorkItem: Array<PSCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertWorkItem === null || pSCertWorkItem === undefined) {
      throw new Error('Required parameter pSCertWorkItem was null or undefined when calling editWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/editWorkItem`,
      pSCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get Power Supply Certification Report Export
   * @param psCertsReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsCertificationReport(psCertsReportsByHie: PsCertsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsCertificationReportByNode>>;
  public getPsCertificationReport(psCertsReportsByHie: PsCertsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsCertificationReportByNode>>>;
  public getPsCertificationReport(psCertsReportsByHie: PsCertsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsCertificationReportByNode>>>;
  public getPsCertificationReport(psCertsReportsByHie: PsCertsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psCertsReportsByHie === null || psCertsReportsByHie === undefined) {
      throw new Error('Required parameter psCertsReportsByHie was null or undefined when calling getPsCertificationReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PsCertificationReportByNode>>(`${this.configuration.basePath}/api/psnb/reports/getPsCertificationReport`,
      psCertsReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Certification Report  view
   * @param psCertificationReportRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsCertificationReportView(psCertificationReportRequest: PsCertificationReportRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsCertificationReportResponse>;
  public getPsCertificationReportView(psCertificationReportRequest: PsCertificationReportRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsCertificationReportResponse>>;
  public getPsCertificationReportView(psCertificationReportRequest: PsCertificationReportRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsCertificationReportResponse>>;
  public getPsCertificationReportView(psCertificationReportRequest: PsCertificationReportRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psCertificationReportRequest === null || psCertificationReportRequest === undefined) {
      throw new Error('Required parameter psCertificationReportRequest was null or undefined when calling getPsCertificationReportView.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PsCertificationReportResponse>(`${this.configuration.basePath}/api/psnb/reports/getPsCertificationReportView`,
      psCertificationReportRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Get PS Triage Cert Work Item
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriageWorkItems(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSTriageCertWorkItem>>;
  public getTriageWorkItems(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSTriageCertWorkItem>>>;
  public getTriageWorkItems(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSTriageCertWorkItem>>>;
  public getTriageWorkItems(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getTriageWorkItems.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSTriageCertWorkItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/getTriageWorkItems`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Triage Certification WorkItem
   * @param pSTriageCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSTriageCertWorkItem>>;
  public saveTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSTriageCertWorkItem>>>;
  public saveTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSTriageCertWorkItem>>>;
  public saveTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTriageCertWorkItem === null || pSTriageCertWorkItem === undefined) {
      throw new Error('Required parameter pSTriageCertWorkItem was null or undefined when calling saveTriageWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSTriageCertWorkItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageWorkItem`,
      pSTriageCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit PS Triage Certification WorkItem
   * @param pSTriageCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editTriageWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTriageCertWorkItem === null || pSTriageCertWorkItem === undefined) {
      throw new Error('Required parameter pSTriageCertWorkItem was null or undefined when calling editTriageWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/editTriageWorkItem`,
      pSTriageCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Certification WorkItem
   * @param psWorkItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTriageWorkItem(psWorkItemId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTriageWorkItem(psWorkItemId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTriageWorkItem(psWorkItemId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTriageWorkItem(psWorkItemId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psWorkItemId === null || psWorkItemId === undefined) {
      throw new Error('Required parameter psWorkItemId was null or undefined when calling deleteTriageWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/deleteTriageWorkItem/${encodeURIComponent(String(psWorkItemId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Certification ID
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAPUCertificationByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<ApuTriageCertifications>;
  public getAPUCertificationByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<ApuTriageCertifications>>;
  public getAPUCertificationByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<ApuTriageCertifications>>;
  public getAPUCertificationByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getAPUCertificationByTriageId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<ApuTriageCertifications>(`${this.configuration.basePath}/api/psnb/triage/psCert/getAPUCertificationByTriageId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Certifications
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAPUShowvisitCertificationByTriageId(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<ApuShowVisitTriageCertifications>;
  public getAPUShowvisitCertificationByTriageId(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<ApuShowVisitTriageCertifications>>;
  public getAPUShowvisitCertificationByTriageId(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<ApuShowVisitTriageCertifications>>;
  public getAPUShowvisitCertificationByTriageId(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getAPUShowvisitCertificationByTriageId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<ApuShowVisitTriageCertifications>(`${this.configuration.basePath}/api/psnb/triage/psCert/getAPUShowVisitCertificationByTriageId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Triage APU Certificate
   * @param apuTriageCertifications
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageAPUCertificate(apuTriageCertifications: ApuTriageCertifications, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveTriageAPUCertificate(apuTriageCertifications: ApuTriageCertifications, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveTriageAPUCertificate(apuTriageCertifications: ApuTriageCertifications, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveTriageAPUCertificate(apuTriageCertifications: ApuTriageCertifications, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (apuTriageCertifications === null || apuTriageCertifications === undefined) {
      throw new Error('Required parameter apuTriageCertifications was null or undefined when calling saveTriageAPUCertificate.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageAPUCertificate`,
      apuTriageCertifications,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Triage APU ShowVisit Certificate
   * @param apuShowVisitTriageCertifications
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageAPUShowVisitCertificate(apuShowVisitTriageCertifications: ApuShowVisitTriageCertifications, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveTriageAPUShowVisitCertificate(apuShowVisitTriageCertifications: ApuShowVisitTriageCertifications, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveTriageAPUShowVisitCertificate(apuShowVisitTriageCertifications: ApuShowVisitTriageCertifications, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveTriageAPUShowVisitCertificate(apuShowVisitTriageCertifications: ApuShowVisitTriageCertifications, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (apuShowVisitTriageCertifications === null || apuShowVisitTriageCertifications === undefined) {
      throw new Error('Required parameter apuShowVisitTriageCertifications was null or undefined when calling saveTriageAPUShowVisitCertificate.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageAPUShowVisitCertificate`,
      apuShowVisitTriageCertifications,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Triage ID Certification WorkItem
   * @param pSTriageCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTriageIDWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateTriageIDWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateTriageIDWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateTriageIDWorkItem(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTriageCertWorkItem === null || pSTriageCertWorkItem === undefined) {
      throw new Error('Required parameter pSTriageCertWorkItem was null or undefined when calling updateTriageIDWorkItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/updateTriageIDWorkItem`,
      pSTriageCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Triage Cert Work Item By PS Cert Id
   * @param psCertId
   * @param psId
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriageWorkItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSTriageCertWorkItem>>;
  public getTriageWorkItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSTriageCertWorkItem>>>;
  public getTriageWorkItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSTriageCertWorkItem>>>;
  public getTriageWorkItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psCertId === null || psCertId === undefined) {
      throw new Error('Required parameter psCertId was null or undefined when calling getTriageWorkItemsBYPsCertID.');
    }
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getTriageWorkItemsBYPsCertID.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psCertId !== undefined && psCertId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psCertId, 'psCertId');
    }
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSTriageCertWorkItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/getTriageWorkItemsBYPsCertID`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get power supply certificate delta
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSCertDeltaDetails(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyTriageCertDelta>;
  public getPSCertDeltaDetails(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyTriageCertDelta>>;
  public getPSCertDeltaDetails(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyTriageCertDelta>>;
  public getPSCertDeltaDetails(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPSCertDeltaDetails.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyTriageCertDelta>(`${this.configuration.basePath}/api/psnb/ps/getPSCertDeltaDetails`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Save Triage Work Items to Master
   * @param pSTriageCertWorkItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageWorkItemToMaster(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveTriageWorkItemToMaster(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveTriageWorkItemToMaster(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveTriageWorkItemToMaster(pSTriageCertWorkItem: Array<PSTriageCertWorkItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTriageCertWorkItem === null || pSTriageCertWorkItem === undefined) {
      throw new Error('Required parameter pSTriageCertWorkItem was null or undefined when calling saveTriageWorkItemToMaster.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageWorkItemToMaster`,
      pSTriageCertWorkItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Cert Work Items by PS Id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getWorkItemsByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertWorkItem>>;
  public getWorkItemsByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertWorkItem>>>;
  public getWorkItemsByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertWorkItem>>>;
  public getWorkItemsByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getWorkItemsByPsId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertWorkItem>>(`${this.configuration.basePath}/api/psnb/psCert/getWorkItemsByPsId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search Power Supply by hierarchy Export
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPowerSupplyByHieExport(requestBody: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<Blob>;
  public searchPowerSupplyByHieExport(requestBody: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpResponse<Blob>>;
  public searchPowerSupplyByHieExport(requestBody: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv'}): Observable<HttpEvent<Blob>>;
  public searchPowerSupplyByHieExport(requestBody: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv'}): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling searchPowerSupplyByHieExport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'text/csv'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post(`${this.configuration.basePath}/api/psnb/search/searchPowerSupplyByHieExport`,
      requestBody,
      {
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Power Supply Battery Bulk Upload Status
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public powerSupplyBatteryBulkUploadStatus(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyBattBulkUploadStatus>>;
  public powerSupplyBatteryBulkUploadStatus(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyBattBulkUploadStatus>>>;
  public powerSupplyBatteryBulkUploadStatus(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyBattBulkUploadStatus>>>;
  public powerSupplyBatteryBulkUploadStatus(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplyBattBulkUploadStatus>>(`${this.configuration.basePath}/api/psnb/powerSupplyBatteryBulkUploadStatus`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Power Supply Spatial Net Bulk Upload Status
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public powerSupplySpatialNetBulkUploadStatus(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplySpatialNetBulkUploadStatus>>;
  public powerSupplySpatialNetBulkUploadStatus(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplySpatialNetBulkUploadStatus>>>;
  public powerSupplySpatialNetBulkUploadStatus(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplySpatialNetBulkUploadStatus>>>;
  public powerSupplySpatialNetBulkUploadStatus(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PowerSupplySpatialNetBulkUploadStatus>>(`${this.configuration.basePath}/api/psnb/powerSupplySpatialNetBulkUploadStatus`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  //Added for User Roles and Permissions Config
  /**
   * Get all permissions of roles in Power Supply Notebook
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllPsUserRolesPermissionConfig(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsnbUserRolesPermissionConfig>>;
  public getAllPsUserRolesPermissionConfig(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsnbUserRolesPermissionConfig>>>;
  public getAllPsUserRolesPermissionConfig(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsnbUserRolesPermissionConfig>>>;
  public getAllPsUserRolesPermissionConfig(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsnbUserRolesPermissionConfig>>(`${this.configuration.basePath}/api/psnb/admin/getAllRolesPermission`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get user role along with its permissions for functionality in Power Supply Notebook
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserRolePermissionConfigs(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsnbUserRolesPermissionConfigResponse>>;
  public getUserRolePermissionConfigs(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsnbUserRolesPermissionConfigResponse>>>;
  public getUserRolePermissionConfigs(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsnbUserRolesPermissionConfigResponse>>>;
  public getUserRolePermissionConfigs(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsnbUserRolesPermissionConfigResponse>>(`${this.configuration.basePath}/api/psnb/admin/getUserRolePermissionConfigs`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update permissions of a role in Power Supply Notebook
   * @param psnbUserRolesPermissionConfig
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRolesPermission(psnbUserRolesPermissionConfig: PsnbUserRolesPermissionConfig, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateRolesPermission(psnbUserRolesPermissionConfig: PsnbUserRolesPermissionConfig, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateRolesPermission(psnbUserRolesPermissionConfig: PsnbUserRolesPermissionConfig, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateRolesPermission(psnbUserRolesPermissionConfig: PsnbUserRolesPermissionConfig, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psnbUserRolesPermissionConfig === null || psnbUserRolesPermissionConfig === undefined) {
      throw new Error('Required parameter psnbUserRolesPermissionConfig was null or undefined when calling updateRolesPermission.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateRolesPermission`,
      psnbUserRolesPermissionConfig,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create PS Alert Profiles
   * @param pSTelemetryAlertProfile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPsAlertProfiles(pSTelemetryAlertProfile: Array<PSTelemetryAlertProfile>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public createPsAlertProfiles(pSTelemetryAlertProfile: Array<PSTelemetryAlertProfile>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public createPsAlertProfiles(pSTelemetryAlertProfile: Array<PSTelemetryAlertProfile>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public createPsAlertProfiles(pSTelemetryAlertProfile: Array<PSTelemetryAlertProfile>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTelemetryAlertProfile === null || pSTelemetryAlertProfile === undefined) {
      throw new Error('Required parameter pSTelemetryAlertProfile was null or undefined when calling createPsAlertProfiles.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<number>(`${this.configuration.basePath}/api/psnb/admin/createPsAlertProfilesTelemetryThresholds`,
      pSTelemetryAlertProfile,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Alert Profile
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePsAlertsProfile(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deletePsAlertsProfile(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deletePsAlertsProfile(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deletePsAlertsProfile(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePsAlertsProfile.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deletePsAlertsProfileTelemetryThreshold/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All PS Alert Profile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllPsAlertsProfile(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSTelemetryAlertProfile>>;
  public getAllPsAlertsProfile(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSTelemetryAlertProfile>>>;
  public getAllPsAlertsProfile(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSTelemetryAlertProfile>>>;
  public getAllPsAlertsProfile(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSTelemetryAlertProfile>>(`${this.configuration.basePath}/api/psnb/admin/getAllPsAlertsProfileTelemetryThresholds`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create PS Alert Profile
   * @param pSTelemetryAlertProfile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePsAlertsProfile(pSTelemetryAlertProfile: PSTelemetryAlertProfile, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public updatePsAlertsProfile(pSTelemetryAlertProfile: PSTelemetryAlertProfile, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public updatePsAlertsProfile(pSTelemetryAlertProfile: PSTelemetryAlertProfile, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public updatePsAlertsProfile(pSTelemetryAlertProfile: PSTelemetryAlertProfile, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSTelemetryAlertProfile === null || pSTelemetryAlertProfile === undefined) {
      throw new Error('Required parameter pSTelemetryAlertProfile was null or undefined when calling updatePsAlertsProfile.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<number>(`${this.configuration.basePath}/api/psnb/admin/updatePsAlertsProfileTelemetryThreshold`,
      pSTelemetryAlertProfile,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Create a User in Power Supply Notebook
   * @param psnbUserInfo
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createUser(psnbUserInfo: PsnbUserInfo, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createUser(psnbUserInfo: PsnbUserInfo, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createUser(psnbUserInfo: PsnbUserInfo, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createUser(psnbUserInfo: PsnbUserInfo, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psnbUserInfo === null || psnbUserInfo === undefined) {
      throw new Error('Required parameter psnbUserInfo was null or undefined when calling createUser.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createUser`,
      psnbUserInfo,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete a User in Power Supply Notebook
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUser(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deleteUser(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deleteUser(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deleteUser(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteUser.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/admin/deleteUser/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all users in Power Supply Notebook
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllUsers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsnbUserInfo>>;
  public getAllUsers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsnbUserInfo>>>;
  public getAllUsers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsnbUserInfo>>>;
  public getAllUsers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsnbUserInfo>>(`${this.configuration.basePath}/api/psnb/admin/getAllUsers`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get User Role in Power Supply Notebook
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserRole(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public getUserRole(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public getUserRole(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public getUserRole(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/getUserRole`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update a User in Power Supply Notebook
   * @param psnbUserInfo
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateUser(psnbUserInfo: PsnbUserInfo, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateUser(psnbUserInfo: PsnbUserInfo, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateUser(psnbUserInfo: PsnbUserInfo, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateUser(psnbUserInfo: PsnbUserInfo, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psnbUserInfo === null || psnbUserInfo === undefined) {
      throw new Error('Required parameter psnbUserInfo was null or undefined when calling updateUser.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateUser`,
      psnbUserInfo,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Set RMODE for a Transponder
   * @param ip
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setRmodeByMac(ip: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyOperationsResponse>;
  public setRmodeByMac(ip: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public setRmodeByMac(ip: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public setRmodeByMac(ip: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling setRmodeByMac.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling setRmodeByMac.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling setRmodeByMac.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/genome/setRmodeByMac`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply real time RMODE status direct from Genome
   * @param mac
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRealTimeRmodeStatus(mac: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public getRealTimeRmodeStatus(mac: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public getRealTimeRmodeStatus(mac: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public getRealTimeRmodeStatus(mac: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (mac === null || mac === undefined) {
      throw new Error('Required parameter mac was null or undefined when calling getRealTimeRmodeStatus.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (mac !== undefined && mac !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>mac, 'mac');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/ps/genome/getRealTimeRmodeStatus`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Current EQ Job
   * @param stormAlertId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCurrentEQJob(stormAlertId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public getCurrentEQJob(stormAlertId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public getCurrentEQJob(stormAlertId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public getCurrentEQJob(stormAlertId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (stormAlertId === null || stormAlertId === undefined) {
      throw new Error('Required parameter stormAlertId was null or undefined when calling getCurrentEQJob.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (stormAlertId !== undefined && stormAlertId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>stormAlertId, 'stormAlertId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<number>(`${this.configuration.basePath}/api/psnb/eqJobs/getCurrentEQJob`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PS certs &amp; EQ Jobs Report data by NodeId &amp; Dates
   * @param psEQJbReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEQJobCertReportByHieAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsnbCertsEqJobResponse>;
  public getEQJobCertReportByHieAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsnbCertsEqJobResponse>>;
  public getEQJobCertReportByHieAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsnbCertsEqJobResponse>>;
  public getEQJobCertReportByHieAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psEQJbReportsByHie === null || psEQJbReportsByHie === undefined) {
      throw new Error('Required parameter psEQJbReportsByHie was null or undefined when calling getEQJobCertReportByHieAndDates.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PsnbCertsEqJobResponse>(`${this.configuration.basePath}/api/psnb/reports/eqJobs/getEQJobCertReportByHieAndDates`,
      psEQJbReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }



  /**
   * Get EQ Jobs data by PSID
   * @param psId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEqJobsDataByPsId(psId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsnbEqJobResponse>;
  public getEqJobsDataByPsId(psId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsnbEqJobResponse>>;
  public getEqJobsDataByPsId(psId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsnbEqJobResponse>>;
  public getEqJobsDataByPsId(psId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getEqJobsDataByPsId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PsnbEqJobResponse>(`${this.configuration.basePath}/api/psnb/eqJobs/getEqJobsDataByPsId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get EQ Jobs Report data by NodeId &amp; Dates
   * @param psEQJbReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEqJobsReportByNodeIdAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsnbEqJobResponse>;
  public getEqJobsReportByNodeIdAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsnbEqJobResponse>>;
  public getEqJobsReportByNodeIdAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsnbEqJobResponse>>;
  public getEqJobsReportByNodeIdAndDates(psEQJbReportsByHie: PsEQJbReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psEQJbReportsByHie === null || psEQJbReportsByHie === undefined) {
      throw new Error('Required parameter psEQJbReportsByHie was null or undefined when calling getEqJobsReportByNodeIdAndDates.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PsnbEqJobResponse>(`${this.configuration.basePath}/api/psnb/reports/eqJobs/getEqJobsReportByNodeIdAndDates`,
      psEQJbReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create PS Jobs Tickets
   * @param createJobRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPSJobsTickets(createJobRequest: Array<CreateJobRequest>, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<BaseResponseDTO>;
  public createPSJobsTickets(createJobRequest: Array<CreateJobRequest>, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<BaseResponseDTO>>;
  public createPSJobsTickets(createJobRequest: Array<CreateJobRequest>, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<BaseResponseDTO>>;
  public createPSJobsTickets(createJobRequest: Array<CreateJobRequest>, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (createJobRequest === null || createJobRequest === undefined) {
      throw new Error('Required parameter createJobRequest was null or undefined when calling createPSJobsTickets.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/eqJobs/createPSJobsTickets`,
      createJobRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Get Communities by nodeId
  //  * @param nodeId
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getCommunities1(nodeId: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<string>>;
  // public getCommunities1(nodeId: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<string>>>;
  // public getCommunities1(nodeId: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<string>>>;
  // public getCommunities1(nodeId: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
  //     if (nodeId === null || nodeId === undefined) {
  //         throw new Error('Required parameter nodeId was null or undefined when calling getCommunities1.');
  //     }

  //     let queryParameters = new HttpParams({ encoder: this.encoder });
  //     if (nodeId !== undefined && nodeId !== null) {
  //         queryParameters = this.addToHttpParams(queryParameters,
  //             <any>nodeId, 'nodeId');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getCommunities`,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get Communities by nodeId
   * @param nodeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCommunitiesbpticket(nodeId: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getCommunitiesbpticket(nodeId: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getCommunitiesbpticket(nodeId: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getCommunitiesbpticket(nodeId: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling getCommunitiesbpticket.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId) {
      nodeId.forEach((element) => {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>element, 'nodeId');
      })
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getCommunities`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Element task Types for PS Jobs
   * @param taskId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getElementTypesForTask(taskId: string, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<TaskOptions>>;
  public getElementTypesForTask(taskId: string, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<TaskOptions>>>;
  public getElementTypesForTask(taskId: string, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<TaskOptions>>>;
  public getElementTypesForTask(taskId: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling getElementTypesForTask.');
    }

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (taskId !== undefined && taskId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>taskId, 'taskId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TaskOptions>>(`${this.configuration.basePath}/api/psnb/eqJobs/getElementTypesForTask`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get Filtered PS For BP Ticketing
   * @param pSFilteredRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFilteredPsForTicketing(pSFilteredRequest: PSFilteredRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSFilteredResponse>>;
  public getFilteredPsForTicketing(pSFilteredRequest: PSFilteredRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSFilteredResponse>>>;
  public getFilteredPsForTicketing(pSFilteredRequest: PSFilteredRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSFilteredResponse>>>;
  public getFilteredPsForTicketing(pSFilteredRequest: PSFilteredRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSFilteredRequest === null || pSFilteredRequest === undefined) {
      throw new Error('Required parameter pSFilteredRequest was null or undefined when calling getFilteredPsForTicketing.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSFilteredResponse>>(`${this.configuration.basePath}/api/psnb/eqJobs/getFilteredPsForTicketing`,
      pSFilteredRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Filtered PS For Battery Health Ticketing
   * @param batteryFilteredRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFilteredPsForBatteryHealthTicketing(batteryFilteredRequest: BatteryFilteredRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<BatteryHealthFilteredResponse>>;
  public getFilteredPsForBatteryHealthTicketing(batteryFilteredRequest: BatteryFilteredRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<BatteryHealthFilteredResponse>>>;
  public getFilteredPsForBatteryHealthTicketing(batteryFilteredRequest: BatteryFilteredRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<BatteryHealthFilteredResponse>>>;
  public getFilteredPsForBatteryHealthTicketing(batteryFilteredRequest: BatteryFilteredRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (batteryFilteredRequest === null || batteryFilteredRequest === undefined) {
      throw new Error('Required parameter batteryFilteredRequest was null or undefined when calling getFilteredPsForBatteryHealthTicketing.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<BatteryHealthFilteredResponse>>(`${this.configuration.basePath}/api/psnb/eqJobs/getFilteredPsForBatteryHealthTicketing`,
      batteryFilteredRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  // /**
  //  * Get Headends by nodeId
  //  * @param nodeId
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getHeadends(nodeId: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<string>>;
  // public getHeadends(nodeId: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<string>>>;
  // public getHeadends(nodeId: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<string>>>;
  // public getHeadends(nodeId: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
  //     if (nodeId === null || nodeId === undefined) {
  //         throw new Error('Required parameter nodeId was null or undefined when calling getHeadends.');
  //     }

  //     let queryParameters = new HttpParams({ encoder: this.encoder });
  //     if (nodeId !== undefined && nodeId !== null) {
  //         queryParameters = this.addToHttpParams(queryParameters,
  //             <any>nodeId, 'nodeId');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getHeadends`,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get Headends by nodeId
   * @param nodeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHeadends(nodeId: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getHeadends(nodeId: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getHeadends(nodeId: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getHeadends(nodeId: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling getHeadends.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId) {
      nodeId.forEach((element) => {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>element, 'nodeId');
      })
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getHeadends`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Audit data for PS Jobs
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSJobsAudit(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<PSJobsAudit>>;
  public getPSJobsAudit(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<PSJobsAudit>>>;
  public getPSJobsAudit(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<PSJobsAudit>>>;
  public getPSJobsAudit(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSJobsAudit>>(`${this.configuration.basePath}/api/psnb/eqJobs/getPSJobsAudit`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  // /**
  //  * Get Audit data for PS Jobs Export
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getPSJobsAuditExport(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<PSJobsAuditExport>>;
  // public getPSJobsAuditExport(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<PSJobsAuditExport>>>;
  // public getPSJobsAuditExport(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<PSJobsAuditExport>>>;
  // public getPSJobsAuditExport(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<PSJobsAuditExport>>(`${this.configuration.basePath}/api/psnb/eqJobs/getPSJobsAuditExport`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get Audit data for PS Jobs Export
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSJobsAuditExport(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSJobsAuditExport>>;
  public getPSJobsAuditExport(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSJobsAuditExport>>>;
  public getPSJobsAuditExport(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSJobsAuditExport>>>;
  public getPSJobsAuditExport(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSJobsAuditExport>>(`${this.configuration.basePath}/api/psnb/eqJobs/getPSJobsAuditExport`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Audit List View data for PS Jobs Export
   * @param auditId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSJobsAuditListViewExport(auditId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSJobsAuditExport>>;
  public getPSJobsAuditListViewExport(auditId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSJobsAuditExport>>>;
  public getPSJobsAuditListViewExport(auditId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSJobsAuditExport>>>;
  public getPSJobsAuditListViewExport(auditId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (auditId === null || auditId === undefined) {
      throw new Error('Required parameter auditId was null or undefined when calling getPSJobsAuditListViewExport.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (auditId !== undefined && auditId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>auditId, 'auditId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSJobsAuditExport>>(`${this.configuration.basePath}/api/psnb/eqJobs/getPSJobsAuditListViewExport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Get Audit data for PS Jobs List View
   * @param auditId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSJobsAuditListView(auditId: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<PSJobsAuditListView>>;
  public getPSJobsAuditListView(auditId: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<PSJobsAuditListView>>>;
  public getPSJobsAuditListView(auditId: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<PSJobsAuditListView>>>;
  public getPSJobsAuditListView(auditId: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (auditId === null || auditId === undefined) {
      throw new Error('Required parameter auditId was null or undefined when calling getPSJobsAuditListView.');
    }

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (auditId !== undefined && auditId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>auditId, 'auditId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSJobsAuditListView>>(`${this.configuration.basePath}/api/psnb/eqJobs/getPSJobsAuditListView`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Eq Transponder Models Name
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEqTransponderModelsName(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getEqTransponderModelsName(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getEqTransponderModelsName(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getEqTransponderModelsName(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getEqTransponderModelsName`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Eq Transponder Vendors Name
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEqTransponderVendorsName(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getEqTransponderVendorsName(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getEqTransponderVendorsName(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getEqTransponderVendorsName(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getEqTransponderVendorsName`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  //  /**
  //  * Get NWT Teams
  //  * @param node
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getNWTTeams(node: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<NWTTeam>;
  // public getNWTTeams(node: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<NWTTeam>>;
  // public getNWTTeams(node: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<NWTTeam>>;
  // public getNWTTeams(node: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (node === null || node === undefined) {
  //         throw new Error('Required parameter node was null or undefined when calling getNWTTeams.');
  //     }

  //     let queryParameters = new HttpParams({encoder: this.encoder});
  //     if (node !== undefined && node !== null) {
  //       queryParameters = this.addToHttpParams(queryParameters,
  //         <any>node, 'node');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<NWTTeam>(`${this.configuration.basePath}/api/psnb/eqJobs/getNWTTeams`,
  //         {
  //             params: queryParameters,
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }


  /**
   * Get NWT Teams
   * @param node
   * @param state
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNWTTeams(node: string, state: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<NWTTeam>;
  public getNWTTeams(node: string, state: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<NWTTeam>>;
  public getNWTTeams(node: string, state: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<NWTTeam>>;
  public getNWTTeams(node: string, state: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (node === null || node === undefined) {
      throw new Error('Required parameter node was null or undefined when calling getNWTTeams.');
    }
    if (state === null || state === undefined) {
      throw new Error('Required parameter state was null or undefined when calling getNWTTeams.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (node !== undefined && node !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>node, 'node');
    }
    if (state !== undefined && state !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>state, 'state');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<NWTTeam>(`${this.configuration.basePath}/api/psnb/eqJobs/getNWTTeams`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get PowerSupply Node Association Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyNodeAssociationReports(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyNodeAssociationReport>>;
  public getPowerSupplyNodeAssociationReports(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyNodeAssociationReport>>>;
  public getPowerSupplyNodeAssociationReports(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyNodeAssociationReport>>>;
  public getPowerSupplyNodeAssociationReports(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSupplyNodeAssociationReports.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyNodeAssociationReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyNodeAssociationReports`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Monthly Remote Test CM Reset Bulk Selected PowerSupply
   * @param pSRemoteTestCmReset
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmResetSelectedPs(pSRemoteTestCmReset: PSRemoteTestCmReset, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public cmResetSelectedPs(pSRemoteTestCmReset: PSRemoteTestCmReset, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public cmResetSelectedPs(pSRemoteTestCmReset: PSRemoteTestCmReset, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public cmResetSelectedPs(pSRemoteTestCmReset: PSRemoteTestCmReset, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSRemoteTestCmReset === null || pSRemoteTestCmReset === undefined) {
      throw new Error('Required parameter pSRemoteTestCmReset was null or undefined when calling cmResetSelectedPs.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/cmResetSelectedPs`,
      pSRemoteTestCmReset,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply alerts details corrective action and probable cause of alarm for Major/Minor Alarms
   * @param powerSupplyAlertsDetailsRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAlertDetailsMessageList(powerSupplyAlertsDetailsRequest: PowerSupplyAlertsDetailsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyAlertDetailsResponse>;
  public getAlertDetailsMessageList(powerSupplyAlertsDetailsRequest: PowerSupplyAlertsDetailsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyAlertDetailsResponse>>;
  public getAlertDetailsMessageList(powerSupplyAlertsDetailsRequest: PowerSupplyAlertsDetailsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyAlertDetailsResponse>>;
  public getAlertDetailsMessageList(powerSupplyAlertsDetailsRequest: PowerSupplyAlertsDetailsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyAlertsDetailsRequest === null || powerSupplyAlertsDetailsRequest === undefined) {
      throw new Error('Required parameter powerSupplyAlertsDetailsRequest was null or undefined when calling getAlertDetailsMessageList.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyAlertDetailsResponse>(`${this.configuration.basePath}/api/psnb/ps/getAlertDetailsMessage`,
      powerSupplyAlertsDetailsRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PowerSupply Network Sync Report
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplyNetworkSyncReport(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyNetworkSyncReport>>;
  public getPowerSupplyNetworkSyncReport(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyNetworkSyncReport>>>;
  public getPowerSupplyNetworkSyncReport(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyNetworkSyncReport>>>;
  public getPowerSupplyNetworkSyncReport(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getPowerSupplyNetworkSyncReport.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyNetworkSyncReport>>(`${this.configuration.basePath}/api/psnb/reports/getPowerSupplyNetworkSyncReport`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create or Save Scroller Update in Power Supply Notebook
   * @param scrollerUpdateDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (scrollerUpdateDTO === null || scrollerUpdateDTO === undefined) {
      throw new Error('Required parameter scrollerUpdateDTO was null or undefined when calling createScrollerUpdate.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createScrollerUpdate`,
      scrollerUpdateDTO,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit or update Scroller Update in Power Supply Notebook
   * @param scrollerUpdateDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editScrollerUpdate(scrollerUpdateDTO: ScrollerUpdateDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (scrollerUpdateDTO === null || scrollerUpdateDTO === undefined) {
      throw new Error('Required parameter scrollerUpdateDTO was null or undefined when calling editScrollerUpdate.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/editScrollerUpdate`,
      scrollerUpdateDTO,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get active scroller message to dispaly on home screen
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fetchActiveScroller(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<ScrollerUpdateDTO>;
  public fetchActiveScroller(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<ScrollerUpdateDTO>>;
  public fetchActiveScroller(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<ScrollerUpdateDTO>>;
  public fetchActiveScroller(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<ScrollerUpdateDTO>(`${this.configuration.basePath}/api/psnb/admin/fetchActiveScroller`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get last 30 days scroller update record list to display in UI grid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fetchLast30DaysScrollerData(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<ScrollerUpdateDTO>>;
  public fetchLast30DaysScrollerData(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<ScrollerUpdateDTO>>>;
  public fetchLast30DaysScrollerData(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<ScrollerUpdateDTO>>>;
  public fetchLast30DaysScrollerData(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<ScrollerUpdateDTO>>(`${this.configuration.basePath}/api/psnb/admin/fetchLast30DaysScrollerData`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Save Hierarchy Preferences in Power Supply Notebook
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHierarchyPreferences(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PsnbHierarchyLocationPreferencesModel>;
  public getHierarchyPreferences(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PsnbHierarchyLocationPreferencesModel>>;
  public getHierarchyPreferences(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PsnbHierarchyLocationPreferencesModel>>;
  public getHierarchyPreferences(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PsnbHierarchyLocationPreferencesModel>(`${this.configuration.basePath}/api/psnb/userProfile/getHierarchyPreferences`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save User Hierarchy Location Preferences in Power Supply Notebook
   * @param psnbHierarchyLocationPreferencesModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psnbHierarchyLocationPreferencesModel === null || psnbHierarchyLocationPreferencesModel === undefined) {
      throw new Error('Required parameter psnbHierarchyLocationPreferencesModel was null or undefined when calling saveHierarchyPreferences.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/userProfile/saveHierarchyPreferences`,
      psnbHierarchyLocationPreferencesModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Delete User Hierarchy Location Preferences in Power Supply Notebook
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteHierarchyPreferences(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<number>;
  public deleteHierarchyPreferences(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<number>>;
  public deleteHierarchyPreferences(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<number>>;
  public deleteHierarchyPreferences(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteHierarchyPreferences.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<number>(`${this.configuration.basePath}/api/psnb/userProfile/deleteHierarchyPreferences/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update User Hierarchy Location Preferences in Power Supply Notebook
   * @param psnbHierarchyLocationPreferencesModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel: PsnbHierarchyLocationPreferencesModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psnbHierarchyLocationPreferencesModel === null || psnbHierarchyLocationPreferencesModel === undefined) {
      throw new Error('Required parameter psnbHierarchyLocationPreferencesModel was null or undefined when calling updateHierarchyPreferences.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/userProfile/updateHierarchyPreferences`,
      psnbHierarchyLocationPreferencesModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all Standby Options based on States
   * @param state
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStandByOptions(state: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<Standby>>;
  public getStandByOptions(state: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<Standby>>>;
  public getStandByOptions(state: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<Standby>>>;
  public getStandByOptions(state: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (state === null || state === undefined) {
      throw new Error('Required parameter state was null or undefined when calling getStandByOptions.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (state !== undefined && state !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>state, 'state');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<Standby>>(`${this.configuration.basePath}/api/psnb/ps/getStandByOptions`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add Transponder Details
   * @param transponderRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addTransponderDetails(transponderRequest: TransponderRequest, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<BaseResponseDTO>;
  public addTransponderDetails(transponderRequest: TransponderRequest, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<BaseResponseDTO>>;
  public addTransponderDetails(transponderRequest: TransponderRequest, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<BaseResponseDTO>>;
  public addTransponderDetails(transponderRequest: TransponderRequest, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (transponderRequest === null || transponderRequest === undefined) {
      throw new Error('Required parameter transponderRequest was null or undefined when calling addTransponderDetails.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/addTransponderDetails`,
      transponderRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Transponder Detail
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTransponderDetail(id: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<BaseResponseDTO>;
  public deleteTransponderDetail(id: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTransponderDetail(id: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTransponderDetail(id: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteTransponderDetail.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deleteTransponderDetail/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All Transponder Details
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderDetails(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<TransponderRequest>>;
  public getTransponderDetails(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<TransponderRequest>>>;
  public getTransponderDetails(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<TransponderRequest>>>;
  public getTransponderDetails(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<TransponderRequest>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderDetails`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All Transponder Model
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderModelName(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<string>>;
  public getTransponderModelName(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<string>>>;
  public getTransponderModelName(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<string>>>;
  public getTransponderModelName(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderModelName`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get All Transponder Vendor Name
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransponderVendorName(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<Array<string>>;
  public getTransponderVendorName(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<Array<string>>>;
  public getTransponderVendorName(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<Array<string>>>;
  public getTransponderVendorName(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/admin/getTransponderVendorName`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Transponder Details
   * @param transponderRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTransponderDetails(transponderRequest: TransponderRequest, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<BaseResponseDTO>;
  public updateTransponderDetails(transponderRequest: TransponderRequest, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<BaseResponseDTO>>;
  public updateTransponderDetails(transponderRequest: TransponderRequest, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<BaseResponseDTO>>;
  public updateTransponderDetails(transponderRequest: TransponderRequest, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (transponderRequest === null || transponderRequest === undefined) {
      throw new Error('Required parameter transponderRequest was null or undefined when calling updateTransponderDetails.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateTransponderDetails`,
      transponderRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  //  /**
  //  * Get Test Run minute Telemetry details by Test Run Id
  //  * @param testRunId
  //  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  //  * @param reportProgress flag to report request and response progress.
  //  */
  // public getPSRemoteTestRunTelemetryDetails(testRunId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTelemetryMinuteDetails>>;
  // public getPSRemoteTestRunTelemetryDetails(testRunId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTelemetryMinuteDetails>>>;
  // public getPSRemoteTestRunTelemetryDetails(testRunId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTelemetryMinuteDetails>>>;
  // public getPSRemoteTestRunTelemetryDetails(testRunId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
  //     if (testRunId === null || testRunId === undefined) {
  //         throw new Error('Required parameter testRunId was null or undefined when calling getPSRemoteTestRunTelemetryDetails.');
  //     }

  //     let headers = this.defaultHeaders;

  //     // authentication (bearerAuth) required
  //     if (this.configuration.accessToken) {
  //         const accessToken = typeof this.configuration.accessToken === 'function'
  //             ? this.configuration.accessToken()
  //             : this.configuration.accessToken;
  //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
  //     }
  //     let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
  //     if (httpHeaderAcceptSelected === undefined) {
  //         // to determine the Accept header
  //         const httpHeaderAccepts: string[] = [
  //             'application/json',
  //             'application/xml'
  //         ];
  //         httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
  //     }
  //     if (httpHeaderAcceptSelected !== undefined) {
  //         headers = headers.set('Accept', httpHeaderAcceptSelected);
  //     }


  //     let responseType: 'text' | 'json' = 'json';
  //     if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
  //         responseType = 'text';
  //     }

  //     return this.httpClient.get<Array<PSRemoteTelemetryMinuteDetails>>(`${this.configuration.basePath}/api/psnb/admin/getPSRemoteTestRunTelemetryDetails/${encodeURIComponent(String(testRunId))}`,
  //         {
  //             responseType: <any>responseType,
  //             withCredentials: this.configuration.withCredentials,
  //             headers: headers,
  //             observe: observe,
  //             reportProgress: reportProgress
  //         }
  //     );
  // }

  /**
   * Get Test Run minute Telemetry details by Test Run Id
   * @param deepCycleTelemetryExport
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSRemoteTestRunTelemetryDetails(deepCycleTelemetryExport: DeepCycleTelemetryExport, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTelemetryMinuteDetails>>;
  public getPSRemoteTestRunTelemetryDetails(deepCycleTelemetryExport: DeepCycleTelemetryExport, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTelemetryMinuteDetails>>>;
  public getPSRemoteTestRunTelemetryDetails(deepCycleTelemetryExport: DeepCycleTelemetryExport, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTelemetryMinuteDetails>>>;
  public getPSRemoteTestRunTelemetryDetails(deepCycleTelemetryExport: DeepCycleTelemetryExport, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (deepCycleTelemetryExport === null || deepCycleTelemetryExport === undefined) {
      throw new Error('Required parameter deepCycleTelemetryExport was null or undefined when calling getPSRemoteTestRunTelemetryDetails.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSRemoteTelemetryMinuteDetails>>(`${this.configuration.basePath}/api/psnb/admin/getPSRemoteTestRunTelemetryDetails`,
      deepCycleTelemetryExport,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Scroller Status
   * @param scrollerStatus
   * @param scrollerId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateScrollerStatus(scrollerStatus: number, scrollerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateScrollerStatus(scrollerStatus: number, scrollerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateScrollerStatus(scrollerStatus: number, scrollerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateScrollerStatus(scrollerStatus: number, scrollerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (scrollerStatus === null || scrollerStatus === undefined) {
      throw new Error('Required parameter scrollerStatus was null or undefined when calling updateScrollerStatus.');
    }
    if (scrollerId === null || scrollerId === undefined) {
      throw new Error('Required parameter scrollerId was null or undefined when calling updateScrollerStatus.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updateScrollerStatus/${encodeURIComponent(String(scrollerStatus))}/${encodeURIComponent(String(scrollerId))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * CM Kickstart Transponder Operation
   * @param ip
   * @param cmts
   * @param macAddress
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public performCMKickStart(ip: string, cmts: string, macAddress: string, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<PowerSupplyOperationsResponse>;
  public performCMKickStart(ip: string, cmts: string, macAddress: string, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpResponse<PowerSupplyOperationsResponse>>;
  public performCMKickStart(ip: string, cmts: string, macAddress: string, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<HttpEvent<PowerSupplyOperationsResponse>>;
  public performCMKickStart(ip: string, cmts: string, macAddress: string, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' | 'application/xml' }): Observable<any> {
    if (ip === null || ip === undefined) {
      throw new Error('Required parameter ip was null or undefined when calling performCMKickStart.');
    }
    if (cmts === null || cmts === undefined) {
      throw new Error('Required parameter cmts was null or undefined when calling performCMKickStart.');
    }
    if (macAddress === null || macAddress === undefined) {
      throw new Error('Required parameter macAddress was null or undefined when calling performCMKickStart.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling performCMKickStart.');
    }

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (ip !== undefined && ip !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>ip, 'ip');
    }
    if (cmts !== undefined && cmts !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>cmts, 'cmts');
    }
    if (macAddress !== undefined && macAddress !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>macAddress, 'macAddress');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<PowerSupplyOperationsResponse>(`${this.configuration.basePath}/api/psnb/ps/dmetrix/performCMKickStart`,
      null,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Power House Data
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerHouseByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplyPowerHouse>;
  public getPowerHouseByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplyPowerHouse>>;
  public getPowerHouseByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplyPowerHouse>>;
  public getPowerHouseByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPowerHouseByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplyPowerHouse>(`${this.configuration.basePath}/api/psnb/telemetry/getPowerhouse/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get All Email Notification Addresses
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmailNotificationAddresses(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<EmailNotificationAddresses>>;
  public getEmailNotificationAddresses(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<EmailNotificationAddresses>>>;
  public getEmailNotificationAddresses(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<EmailNotificationAddresses>>>;
  public getEmailNotificationAddresses(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<EmailNotificationAddresses>>(`${this.configuration.basePath}/api/psnb/admin/email/getEmailNotificationAddresses`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Email Notification Addresses By Email
   * @param emailAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByEmailAddress(emailAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<EmailNotificationAddresses>;
  public getByEmailAddress(emailAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<EmailNotificationAddresses>>;
  public getByEmailAddress(emailAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<EmailNotificationAddresses>>;
  public getByEmailAddress(emailAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (emailAddress === null || emailAddress === undefined) {
      throw new Error('Required parameter emailAddress was null or undefined when calling getByEmailAddress.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<EmailNotificationAddresses>(`${this.configuration.basePath}/api/psnb/admin/email/getByEmailAddress/${encodeURIComponent(String(emailAddress))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Create Email Notification Addresses
   * @param emailNotificationAddresses
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (emailNotificationAddresses === null || emailNotificationAddresses === undefined) {
      throw new Error('Required parameter emailNotificationAddresses was null or undefined when calling createEmailNotificationAddresses.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/email/createEmailNotificationAddresses`,
      emailNotificationAddresses,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete Email Notification Addresses
   * @param emailAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEmailNotificationAddresses(emailAddress: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteEmailNotificationAddresses(emailAddress: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteEmailNotificationAddresses(emailAddress: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteEmailNotificationAddresses(emailAddress: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (emailAddress === null || emailAddress === undefined) {
      throw new Error('Required parameter emailAddress was null or undefined when calling deleteEmailNotificationAddresses.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/email/deleteEmailNotificationAddresses/${encodeURIComponent(String(emailAddress))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Update Email Notification Addresses
   * @param emailNotificationAddresses
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateEmailNotificationAddresses(emailNotificationAddresses: EmailNotificationAddresses, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (emailNotificationAddresses === null || emailNotificationAddresses === undefined) {
      throw new Error('Required parameter emailNotificationAddresses was null or undefined when calling updateEmailNotificationAddresses.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/email/updateEmailNotificationAddresses`,
      emailNotificationAddresses,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Test Run minute Battery Telemetry details by Test Run Id and Power Supply Id
   * @param testRunId
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSRemoteTestRunBatteryTelemetryDetails(testRunId: number, powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSRemoteTelemetryBatteryMinuteDetails>>;
  public getPSRemoteTestRunBatteryTelemetryDetails(testRunId: number, powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSRemoteTelemetryBatteryMinuteDetails>>>;
  public getPSRemoteTestRunBatteryTelemetryDetails(testRunId: number, powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSRemoteTelemetryBatteryMinuteDetails>>>;
  public getPSRemoteTestRunBatteryTelemetryDetails(testRunId: number, powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (testRunId === null || testRunId === undefined) {
      throw new Error('Required parameter testRunId was null or undefined when calling getPSRemoteTestRunBatteryTelemetryDetails.');
    }
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPSRemoteTestRunBatteryTelemetryDetails.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (testRunId !== undefined && testRunId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>testRunId, 'testRunId');
    }
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSRemoteTelemetryBatteryMinuteDetails>>(`${this.configuration.basePath}/api/psnb/psRemoteTest/getPSRemoteTestRunBatteryTelemetryDetails`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Storm Mode Output Current Data
   * @param stormModeTelemetryHistoryRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStormOutputCurrent(stormModeTelemetryHistoryRequest: StormModeTelemetryHistoryRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<StormModeTelemetryHistoryResponse>;
  public getStormOutputCurrent(stormModeTelemetryHistoryRequest: StormModeTelemetryHistoryRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<StormModeTelemetryHistoryResponse>>;
  public getStormOutputCurrent(stormModeTelemetryHistoryRequest: StormModeTelemetryHistoryRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<StormModeTelemetryHistoryResponse>>;
  public getStormOutputCurrent(stormModeTelemetryHistoryRequest: StormModeTelemetryHistoryRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (stormModeTelemetryHistoryRequest === null || stormModeTelemetryHistoryRequest === undefined) {
      throw new Error('Required parameter stormModeTelemetryHistoryRequest was null or undefined when calling getStormOutputCurrent.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    let basePath: string = this.configuration.basePath;
    if (basePath === undefined || basePath === null || basePath.length === 0) {
      basePath = this.psnbBasePath;
    }

    return this.httpClient.post<StormModeTelemetryHistoryResponse>(
      `${basePath}/api/psnb/telemetry/history/getStormOutputCurrent`,
      stormModeTelemetryHistoryRequest,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Create PS Material Billing Codes
   * @param psMaterialBillingCodes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createPsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createPsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createPsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psMaterialBillingCodes === null || psMaterialBillingCodes === undefined) {
      throw new Error('Required parameter psMaterialBillingCodes was null or undefined when calling createPsMaterialBillingCodes.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/createPsMaterialBillingCodes`,
      psMaterialBillingCodes,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Material Billing Codes
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePsMaterialBillingCodes(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deletePsMaterialBillingCodes(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deletePsMaterialBillingCodes(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deletePsMaterialBillingCodes(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePsMaterialBillingCodes.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/deletePsMaterialBillingCodes/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  /**
   * Get All PS Material Billing Codes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllPsMaterialBillingCodes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsMaterialBillingCodes>>;
  public getAllPsMaterialBillingCodes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsMaterialBillingCodes>>>;
  public getAllPsMaterialBillingCodes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsMaterialBillingCodes>>>;
  public getAllPsMaterialBillingCodes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsMaterialBillingCodes>>(`${this.configuration.basePath}/api/psnb/admin/getAllPsMaterialBillingCodes`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Material Billing Codes
   * @param materialType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsMaterialBillingCodes(materialType: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PsMaterialBillingCodes>>;
  public getPsMaterialBillingCodes(materialType: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PsMaterialBillingCodes>>>;
  public getPsMaterialBillingCodes(materialType: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PsMaterialBillingCodes>>>;
  public getPsMaterialBillingCodes(materialType: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (materialType === null || materialType === undefined) {
      throw new Error('Required parameter materialType was null or undefined when calling getPsMaterialBillingCodes.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PsMaterialBillingCodes>>(`${this.configuration.basePath}/api/psnb/admin/getPsMaterialBillingCodes/${encodeURIComponent(String(materialType))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update PS Material Billing Codes
   * @param psMaterialBillingCodes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePsMaterialBillingCodes(psMaterialBillingCodes: PsMaterialBillingCodes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psMaterialBillingCodes === null || psMaterialBillingCodes === undefined) {
      throw new Error('Required parameter psMaterialBillingCodes was null or undefined when calling updatePsMaterialBillingCodes.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/updatePsMaterialBillingCodes`,
      psMaterialBillingCodes,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Certification Material Item
   * @param pSCertMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertMaterialItem === null || pSCertMaterialItem === undefined) {
      throw new Error('Required parameter pSCertMaterialItem was null or undefined when calling saveMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/saveMaterialItem`,
      pSCertMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Cert Material Items by PS Id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMaterialItemsByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertMaterialItem>>;
  public getMaterialItemsByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertMaterialItem>>>;
  public getMaterialItemsByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertMaterialItem>>>;
  public getMaterialItemsByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getMaterialItemsByPsId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertMaterialItem>>(`${this.configuration.basePath}/api/psnb/psCert/getMaterialItemsByPsId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Cert Material Item
   * @param powerSupplyId
   * @param psCertificationId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMaterialItems(powerSupplyId: number, psCertificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertMaterialItem>>;
  public getMaterialItems(powerSupplyId: number, psCertificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertMaterialItem>>>;
  public getMaterialItems(powerSupplyId: number, psCertificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertMaterialItem>>>;
  public getMaterialItems(powerSupplyId: number, psCertificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getMaterialItems.');
    }
    if (psCertificationId === null || psCertificationId === undefined) {
      throw new Error('Required parameter psCertificationId was null or undefined when calling getMaterialItems.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (powerSupplyId !== undefined && powerSupplyId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>powerSupplyId, 'powerSupplyId');
    }
    if (psCertificationId !== undefined && psCertificationId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psCertificationId, 'psCertificationId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertMaterialItem>>(`${this.configuration.basePath}/api/psnb/psCert/getMaterialItems`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Certification Material Item
   * @param psMaterialItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMaterialItem(psMaterialItemId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteMaterialItem(psMaterialItemId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteMaterialItem(psMaterialItemId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteMaterialItem(psMaterialItemId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psMaterialItemId === null || psMaterialItemId === undefined) {
      throw new Error('Required parameter psMaterialItemId was null or undefined when calling deleteMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/deleteMaterialItem/${encodeURIComponent(String(psMaterialItemId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit PS Certification Material Item
   * @param pSCertMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editMaterialItem(pSCertMaterialItem: Array<PSCertMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertMaterialItem === null || pSCertMaterialItem === undefined) {
      throw new Error('Required parameter pSCertMaterialItem was null or undefined when calling editMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/psCert/editMaterialItem`,
      pSCertMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Edit PS Triage Certification Material Item
   * @param pSCertTriageMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public editTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public editTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public editTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertTriageMaterialItem === null || pSCertTriageMaterialItem === undefined) {
      throw new Error('Required parameter pSCertTriageMaterialItem was null or undefined when calling editTriageMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/editTriageMaterialItem`,
      pSCertTriageMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Save PS Triage Certification Material Item
   * @param pSCertTriageMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertTriageMaterialItem>>;
  public saveTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertTriageMaterialItem>>>;
  public saveTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertTriageMaterialItem>>>;
  public saveTriageMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertTriageMaterialItem === null || pSCertTriageMaterialItem === undefined) {
      throw new Error('Required parameter pSCertTriageMaterialItem was null or undefined when calling saveTriageMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSCertTriageMaterialItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageMaterialItem`,
      pSCertTriageMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Triage Material Items to Master
   * @param pSCertTriageMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveTriageMaterialItemToMaster(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public saveTriageMaterialItemToMaster(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public saveTriageMaterialItemToMaster(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public saveTriageMaterialItemToMaster(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertTriageMaterialItem === null || pSCertTriageMaterialItem === undefined) {
      throw new Error('Required parameter pSCertTriageMaterialItem was null or undefined when calling saveTriageMaterialItemToMaster.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/saveTriageMaterialItemToMaster`,
      pSCertTriageMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save PS Triage ID Certification MaterialItem
   * @param pSCertTriageMaterialItem
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTriageIDMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updateTriageIDMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updateTriageIDMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updateTriageIDMaterialItem(pSCertTriageMaterialItem: Array<PSCertTriageMaterialItem>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSCertTriageMaterialItem === null || pSCertTriageMaterialItem === undefined) {
      throw new Error('Required parameter pSCertTriageMaterialItem was null or undefined when calling updateTriageIDMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/updateTriageIDMaterialItem`,
      pSCertTriageMaterialItem,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Triage Cert Material Item By PS Cert Id
   * @param psCertId
   * @param psId
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriageMaterialItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertTriageMaterialItem>>;
  public getTriageMaterialItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertTriageMaterialItem>>>;
  public getTriageMaterialItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertTriageMaterialItem>>>;
  public getTriageMaterialItemsBYPsCertID(psCertId: number, psId: number, triageId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psCertId === null || psCertId === undefined) {
      throw new Error('Required parameter psCertId was null or undefined when calling getTriageMaterialItemsBYPsCertID.');
    }
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getTriageMaterialItemsBYPsCertID.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psCertId !== undefined && psCertId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psCertId, 'psCertId');
    }
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertTriageMaterialItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/getTriageMaterialItemsBYPsCertID`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Triage Cert Material Item
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTriageMaterialItems(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSCertTriageMaterialItem>>;
  public getTriageMaterialItems(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSCertTriageMaterialItem>>>;
  public getTriageMaterialItems(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSCertTriageMaterialItem>>>;
  public getTriageMaterialItems(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getTriageMaterialItems.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<PSCertTriageMaterialItem>>(`${this.configuration.basePath}/api/psnb/triage/psCert/getTriageMaterialItems`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete PS Certification Material Item
   * @param psMaterialItemId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTriageMaterialItem(psMaterialItemId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTriageMaterialItem(psMaterialItemId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTriageMaterialItem(psMaterialItemId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTriageMaterialItem(psMaterialItemId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psMaterialItemId === null || psMaterialItemId === undefined) {
      throw new Error('Required parameter psMaterialItemId was null or undefined when calling deleteTriageMaterialItem.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/psCert/deleteTriageMaterialItem/${encodeURIComponent(String(psMaterialItemId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get CPO Optek Data
   * @param psReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCpoOptekData(psReportsByHie: PsReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<Array<CpoOptekData>>>;
  public getCpoOptekData(psReportsByHie: PsReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<Array<CpoOptekData>>>>;
  public getCpoOptekData(psReportsByHie: PsReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<Array<CpoOptekData>>>>;
  public getCpoOptekData(psReportsByHie: PsReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psReportsByHie === null || psReportsByHie === undefined) {
      throw new Error('Required parameter psReportsByHie was null or undefined when calling getCpoOptekData.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<Array<CpoOptekData>>>(`${this.configuration.basePath}/api/psnb/cpo/getCpoOptekData`,
      psReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get CPO Optek Data by Search view
   * @param value
   * @param identifier
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCpoSearchView(value: string, identifier: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<CpoOptekData>>;
  public getCpoSearchView(value: string, identifier: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<CpoOptekData>>>;
  public getCpoSearchView(value: string, identifier: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<CpoOptekData>>>;
  public getCpoSearchView(value: string, identifier: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (value === null || value === undefined) {
      throw new Error('Required parameter value was null or undefined when calling getCpoSearchView.');
    }
    if (identifier === null || identifier === undefined) {
      throw new Error('Required parameter identifier was null or undefined when calling getCpoSearchView.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (value !== undefined && value !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>value, 'value');
    }
    if (identifier !== undefined && identifier !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>identifier, 'identifier');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<CpoOptekData>>(`${this.configuration.basePath}/api/psnb/cpo/getCpoSearchView`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Get NWT Teams by nodeId
   * @param nodeId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNWTTeamsList(nodeId: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
  public getNWTTeamsList(nodeId: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
  public getNWTTeamsList(nodeId: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
  public getNWTTeamsList(nodeId: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
      throw new Error('Required parameter nodeId was null or undefined when calling getNWTTeamsList.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId) {
      nodeId.forEach((element) => {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>element, 'nodeId');
      })
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getNWTTeamsList`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply Log History by Preferred NodeId
   * @param psEQJbReportsByHie
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSHistoryByPreference(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PSReview>>;
  public getPSHistoryByPreference(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PSReview>>>;
  public getPSHistoryByPreference(psEQJbReportsByHie: PsEQJbReportsByHie, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PSReview>>>;
  public getPSHistoryByPreference(psEQJbReportsByHie: PsEQJbReportsByHie, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psEQJbReportsByHie === null || psEQJbReportsByHie === undefined) {
      throw new Error('Required parameter psEQJbReportsByHie was null or undefined when calling getPSHistoryByPreference.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PSReview>>(`${this.configuration.basePath}/api/psnb/powersupply/getPSHistoryByPreference`,
      psEQJbReportsByHie,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get PS Network Hierarchy Stats for Failure Mode Alerts by NhoId
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPSNetworkHierarchyFailureModeAlertsStatsByNhoId(requestBody: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<PowerSupplyNetworkHierarchyFailureModeAlertsStats>>;
  public getPSNetworkHierarchyFailureModeAlertsStatsByNhoId(requestBody: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<PowerSupplyNetworkHierarchyFailureModeAlertsStats>>>;
  public getPSNetworkHierarchyFailureModeAlertsStatsByNhoId(requestBody: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<PowerSupplyNetworkHierarchyFailureModeAlertsStats>>>;
  public getPSNetworkHierarchyFailureModeAlertsStatsByNhoId(requestBody: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling getPSNetworkHierarchyFailureModeAlertsStatsByNhoId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<Array<PowerSupplyNetworkHierarchyFailureModeAlertsStats>>(`${this.configuration.basePath}/api/psnb/getPSNetworkHierarchyFailureModeAlertsStatsByNhoId`,
      requestBody,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply SFP Triage by triage ID
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplySfpTriage(triageId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplySfpTriage>;
  public getPowerSupplySfpTriage(triageId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplySfpTriage>>;
  public getPowerSupplySfpTriage(triageId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplySfpTriage>>;
  public getPowerSupplySfpTriage(triageId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (triageId === null || triageId === undefined) {
      throw new Error('Required parameter triageId was null or undefined when calling getPowerSupplySfpTriage.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplySfpTriage>(`${this.configuration.basePath}/api/psnb/triage/ps/getPowerSupplySfpTriage/${encodeURIComponent(String(triageId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply SFP Triage
   * @param powerSupplySfpTriage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public savePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public savePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public savePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfpTriage === null || powerSupplySfpTriage === undefined) {
      throw new Error('Required parameter powerSupplySfpTriage was null or undefined when calling savePowerSupplySfpTriage.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/ps/savePowerSupplySfpTriage`,
      powerSupplySfpTriage,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save Power Supply SFP Triage to Master
   * @param powerSupplySfpTriage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePowerSupplySfpTriageToMaster(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public savePowerSupplySfpTriageToMaster(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public savePowerSupplySfpTriageToMaster(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public savePowerSupplySfpTriageToMaster(powerSupplySfpTriage: PowerSupplySfpTriage, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfpTriage === null || powerSupplySfpTriage === undefined) {
      throw new Error('Required parameter powerSupplySfpTriage was null or undefined when calling savePowerSupplySfpTriageToMaster.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/ps/savePowerSupplySfpTriageToMaster`,
      powerSupplySfpTriage,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update Power Supply SFP
   * @param powerSupplySfpTriage
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public updatePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public updatePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public updatePowerSupplySfpTriage(powerSupplySfpTriage: PowerSupplySfpTriage, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplySfpTriage === null || powerSupplySfpTriage === undefined) {
      throw new Error('Required parameter powerSupplySfpTriage was null or undefined when calling updatePowerSupplySfpTriage.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/triage/ps/updatePowerSupplySfpTriage`,
      powerSupplySfpTriage,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Power Supply SFP Triage By PS Id
   * @param psId
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

  /**
   * Get Power Supply SFP Triage By PS Id
   * @param psId
   * @param triageId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPowerSupplySfpTriageByPsId(psId: number, triageId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<PowerSupplySfpTriage>;
  public getPowerSupplySfpTriageByPsId(psId: number, triageId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<PowerSupplySfpTriage>>;
  public getPowerSupplySfpTriageByPsId(psId: number, triageId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<PowerSupplySfpTriage>>;
  public getPowerSupplySfpTriageByPsId(psId: number, triageId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (psId === null || psId === undefined) {
      throw new Error('Required parameter psId was null or undefined when calling getPowerSupplySfpTriageByPsId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (psId !== undefined && psId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>psId, 'psId');
    }
    if (triageId !== undefined && triageId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>triageId, 'triageId');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<PowerSupplySfpTriage>(`${this.configuration.basePath}/api/psnb/triage/ps/getPowerSupplySfpTriageByPsId`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Retest Battery Health Failed Remote Tests
   * @param pSRemoteTestStart
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retestFailedBatteryHealthTests(pSRemoteTestStart: PSRemoteTestStart, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public retestFailedBatteryHealthTests(pSRemoteTestStart: PSRemoteTestStart, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public retestFailedBatteryHealthTests(pSRemoteTestStart: PSRemoteTestStart, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public retestFailedBatteryHealthTests(pSRemoteTestStart: PSRemoteTestStart, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (pSRemoteTestStart === null || pSRemoteTestStart === undefined) {
      throw new Error('Required parameter pSRemoteTestStart was null or undefined when calling retestFailedBatteryHealthTests.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnb/admin/retestFailedBatteryHealthTests`,
      pSRemoteTestStart,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get power supply record with power supply id
   * @param powerSupplyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPsBatteryHealthScoreByPsId(powerSupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BatteryHealthScoreResponse>;
  public getPsBatteryHealthScoreByPsId(powerSupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BatteryHealthScoreResponse>>;
  public getPsBatteryHealthScoreByPsId(powerSupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BatteryHealthScoreResponse>>;
  public getPsBatteryHealthScoreByPsId(powerSupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (powerSupplyId === null || powerSupplyId === undefined) {
      throw new Error('Required parameter powerSupplyId was null or undefined when calling getPsBatteryHealthScoreByPsId.');
    }
    let headers: HttpHeaders = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<BatteryHealthScoreResponse>(`${this.configuration.basePath}/api/psnb/ps/getPsBatteryHealthScoreByPsId/${encodeURIComponent(String(powerSupplyId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  private isAccessTokenExpired(token: string): boolean {
    const decodedToken: any = jwtDecode(token); // eslint-disable-line @typescript-eslint/no-explicit-any
    const currentTimeInSeconds: number = Math.floor(Date.now() / 1000);
    return decodedToken.exp < currentTimeInSeconds;
  }

  /**
   * Get Generator Usage Report by division, region, or nodeIds
   * Returns generator deployment history for the last 90 days or currently deployed generators, filtered by division, region, or nodeIds.
   * @param division Filter by division name
   * @param region Filter by region name
   * @param nodeIds Filter by node IDs (comma-separated)
   * @param history If true, returns history for past 90 days; if false, returns only currently deployed
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUsageReport(division?: string, region?: string, nodeIds?: string, history?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<GeneratorUsageReportResponse>;
  public getUsageReport(division?: string, region?: string, nodeIds?: string, history?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<GeneratorUsageReportResponse>>;
  public getUsageReport(division?: string, region?: string, nodeIds?: string, history?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<GeneratorUsageReportResponse>>;
  public getUsageReport(division?: string, region?: string, nodeIds?: string, history?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (division !== undefined && division !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>division, 'division');
    }
    if (region !== undefined && region !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>region, 'region');
    }
    if (nodeIds !== undefined && nodeIds !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeIds, 'nodeIds');
    }
    if (history !== undefined && history !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>history, 'history');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<GeneratorUsageReportResponse>(`${this.configuration.basePath}/api/psnbGenerator/reports/usage`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Get Generator Inventory Report by division, region, or nodeIds
   * Returns generator inventory information filtered by division, region, or multiple nodeIds. NodeIds can be provided as comma-separated values.
   * @param division Filter by division name
   * @param region Filter by region name
   * @param nodeIds Filter by node IDs (comma-separated)
   * @param includeFuelTanks Include fuel tanks in the report
   * @param includeTrailers Include trailers in the report
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInventoryReport(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<GeneratorInventoryReportResponse>;
  public getInventoryReport(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<GeneratorInventoryReportResponse>>;
  public getInventoryReport(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<GeneratorInventoryReportResponse>>;
  public getInventoryReport(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (division !== undefined && division !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>division, 'division');
    }
    if (region !== undefined && region !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>region, 'region');
    }
    if (nodeIds !== undefined && nodeIds !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeIds, 'nodeIds');
    }
    if (includeFuelTanks !== undefined && includeFuelTanks !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>includeFuelTanks, 'includeFuelTanks');
    }
    if (includeTrailers !== undefined && includeTrailers !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>includeTrailers, 'includeTrailers');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<GeneratorInventoryReportResponse>(`${this.configuration.basePath}/api/psnbGenerator/reports/inventory`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Create a new Generator Asset Type
   * @param assetType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createAssetType(assetType: AssetType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createAssetType(assetType: AssetType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createAssetType(assetType: AssetType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createAssetType(assetType: AssetType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (assetType === null || assetType === undefined) {
          throw new Error('Required parameter assetType was null or undefined when calling createAssetType.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createAssetType`,
          assetType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Delete a Generator Asset Type
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteAsset(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteAsset(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteAsset(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteAsset(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteAsset.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteAsset`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Generator Asset Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllAssetTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<AssetTypeDTO>>;
    public getAllAssetTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<AssetTypeDTO>>>;
    public getAllAssetTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<AssetTypeDTO>>>;
    public getAllAssetTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<AssetTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllAssetTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Asset Type
   * @param id 
   * @param assetType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateAssetType(id: number, assetType: AssetType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateAssetType(id: number, assetType: AssetType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateAssetType(id: number, assetType: AssetType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateAssetType(id: number, assetType: AssetType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateAssetType.');
      }
      if (assetType === null || assetType === undefined) {
          throw new Error('Required parameter assetType was null or undefined when calling updateAssetType.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateAssetType`,
          assetType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }


  /**
   * Create a new Generator Current Type
   * @param currentType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createCurrentType(currentType: CurrentType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createCurrentType(currentType: CurrentType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createCurrentType(currentType: CurrentType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createCurrentType(currentType: CurrentType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (currentType === null || currentType === undefined) {
          throw new Error('Required parameter currentType was null or undefined when calling createCurrentType.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createCurrent`,
          currentType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Delete a Generator Current Type
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCurrentType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteCurrentType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteCurrentType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteCurrentType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteCurrentType.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteCurrent`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get All Generator Current Types
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllCurrentTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<CurrentTypeDTO>>;
    public getAllCurrentTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<CurrentTypeDTO>>>;
    public getAllCurrentTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<CurrentTypeDTO>>>;
    public getAllCurrentTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<CurrentTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllCurrentTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Generator Current Type
   * @param id 
   * @param currentType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateCurrentType(id: number, currentType: CurrentType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateCurrentType(id: number, currentType: CurrentType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateCurrentType(id: number, currentType: CurrentType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateCurrentType(id: number, currentType: CurrentType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateCurrentType.');
      }
      if (currentType === null || currentType === undefined) {
          throw new Error('Required parameter currentType was null or undefined when calling updateCurrentType.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateCurrent`,
          currentType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Create a new Fuel Tank Size
   * @param fuelTankSize 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createFuelTankSize(fuelTankSize: FuelTankSize, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createFuelTankSize(fuelTankSize: FuelTankSize, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createFuelTankSize(fuelTankSize: FuelTankSize, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createFuelTankSize(fuelTankSize: FuelTankSize, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (fuelTankSize === null || fuelTankSize === undefined) {
          throw new Error('Required parameter fuelTankSize was null or undefined when calling createFuelTankSize.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createFuelTankSize`,
          fuelTankSize,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
   * Create a new Fuel Tank
   * @param fuelTank 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createFuelTank(fuelTank: FuelTank, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createFuelTank(fuelTank: FuelTank, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createFuelTank(fuelTank: FuelTank, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createFuelTank(fuelTank: FuelTank, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (fuelTank === null || fuelTank === undefined) {
        throw new Error('Required parameter fuelTank was null or undefined when calling createFuelTank.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
        'application/json',
        'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
        headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/createFuelTank`,
        fuelTank,
        {
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

    /**
     * Get all Trailers
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTrailers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<TrailerEntity>>;
    public getAllTrailers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<TrailerEntity>>>;
    public getAllTrailers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<TrailerEntity>>>;
    public getAllTrailers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<TrailerEntity>>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/getTrailer`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Create a new Generator
   * @param generator 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createGenerator(generator: Generator, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public createGenerator(generator: Generator, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public createGenerator(generator: Generator, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public createGenerator(generator: Generator, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (generator === null || generator === undefined) {
        throw new Error('Required parameter generator was null or undefined when calling createGenerator.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
          'application/json',
          'application/xml'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/createGenerator`,
      generator,
      {
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
      }
    );
  }

    /**
     * Create a new Trailer
     * @param trailer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTrailer(trailer: Trailer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public createTrailer(trailer: Trailer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createTrailer(trailer: Trailer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createTrailer(trailer: Trailer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (trailer === null || trailer === undefined) {
          throw new Error('Required parameter trailer was null or undefined when calling createTrailer.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json',
          'application/xml'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/createTrailer`,
          trailer,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Delete a Fuel Tank Size
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteFuelTankSize(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteFuelTankSize(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteFuelTankSize(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteFuelTankSize(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteFuelTankSize.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteFuelTankSize`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Fuel Tank Sizes
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllFuelTankSizes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<FuelTankSizeDTO>>;
    public getAllFuelTankSizes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<FuelTankSizeDTO>>>;
    public getAllFuelTankSizes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<FuelTankSizeDTO>>>;
    public getAllFuelTankSizes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<FuelTankSizeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllFuelTankSize`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Fuel Tank Size
   * @param id 
   * @param fuelTankSize 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateFuelTankSize(id: number, fuelTankSize: FuelTankSize, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateFuelTankSize(id: number, fuelTankSize: FuelTankSize, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateFuelTankSize(id: number, fuelTankSize: FuelTankSize, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateFuelTankSize(id: number, fuelTankSize: FuelTankSize, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateFuelTankSize.');
      }
      if (fuelTankSize === null || fuelTankSize === undefined) {
          throw new Error('Required parameter fuelTankSize was null or undefined when calling updateFuelTankSize.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateFuelTankSize`,
          fuelTankSize,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

      /**
   * Create a new Generator Location Type
   * @param locationType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createLocation(locationType: LocationType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createLocation(locationType: LocationType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createLocation(locationType: LocationType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createLocation(locationType: LocationType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (locationType === null || locationType === undefined) {
          throw new Error('Required parameter locationType was null or undefined when calling createLocation.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createLocation`,
          locationType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Delete a Generator Location Type
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteLocation(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteLocation(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteLocation(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteLocation(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteLocation.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteLocation`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Generator Location Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllLocationTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<LocationTypeDTO>>;
    public getAllLocationTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<LocationTypeDTO>>>;
    public getAllLocationTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<LocationTypeDTO>>>;
    public getAllLocationTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<LocationTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllLocationTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Generator Location Type
   * @param id 
   * @param locationType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateLocation(id: number, locationType: LocationType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateLocation(id: number, locationType: LocationType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateLocation(id: number, locationType: LocationType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateLocation(id: number, locationType: LocationType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateLocation.');
      }
      if (locationType === null || locationType === undefined) {
          throw new Error('Required parameter locationType was null or undefined when calling updateLocation.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateLocation`,
          locationType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Search by Asset Id
   * @param assetId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByAssetId(assetId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorSearch>>;
  public advanceSearchByAssetId(assetId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorSearch>>>;
  public advanceSearchByAssetId(assetId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorSearch>>>;
  public advanceSearchByAssetId(assetId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (assetId === null || assetId === undefined) {
        throw new Error('Required parameter assetId was null or undefined when calling advanceSearchByAssetId.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (assetId !== undefined && assetId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>assetId, 'assetId');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByAssetId`,
      {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
      }
    );
  }
  
  /**
   * Search by Node
   * @param nodeId 
   * @param nodeCommunityServed 
   * @param node 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNode(nodeId: number, nodeCommunityServed: string, node: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorSearch>>;
  public advanceSearchByNode(nodeId: number, nodeCommunityServed: string, node: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorSearch>>>;
  public advanceSearchByNode(nodeId: number, nodeCommunityServed: string, node: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorSearch>>>;
  public advanceSearchByNode(nodeId: number, nodeCommunityServed: string, node: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
        throw new Error('Required parameter nodeId was null or undefined when calling advanceSearchByNode.');
    }
    if (nodeCommunityServed === null || nodeCommunityServed === undefined) {
        throw new Error('Required parameter nodeCommunityServed was null or undefined when calling advanceSearchByNode.');
    }
    if (node === null || node === undefined) {
        throw new Error('Required parameter node was null or undefined when calling advanceSearchByNode.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    if (nodeCommunityServed !== undefined && nodeCommunityServed !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeCommunityServed, 'nodeCommunityServed');
    }
    if (node !== undefined && node !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>node, 'node');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByNode`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }


  /**
   * Search by NWT Team name
   * @param nwtTeam 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNwtTeam(nwtTeam: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorSearch>>;
  public advanceSearchByNwtTeam(nwtTeam: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorSearch>>>;
  public advanceSearchByNwtTeam(nwtTeam: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorSearch>>>;
  public advanceSearchByNwtTeam(nwtTeam: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nwtTeam === null || nwtTeam === undefined) {
        throw new Error('Required parameter nwtTeam was null or undefined when calling advanceSearchByNwtTeam.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nwtTeam !== undefined && nwtTeam !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nwtTeam, 'nwtTeam');
    }

    let headers = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByNwtTeam`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Search by NWT Make
   * @param make 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNwtMake(make?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
  public advanceSearchByNwtMake(make?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
  public advanceSearchByNwtMake(make?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
  public advanceSearchByNwtMake(make?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (make !== undefined && make !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>make, 'make');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<object>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByMake`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Search by NWT Model
   * @param model 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNwtModel(model?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
  public advanceSearchByNwtModel(model?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
  public advanceSearchByNwtModel(model?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
  public advanceSearchByNwtModel(model?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (model !== undefined && model !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>model, 'model');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<object>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByModel`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Delete a Trailer by Trailer ID
   * @param trailerId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTrailerByTrailerId(trailerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteTrailerByTrailerId(trailerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteTrailerByTrailerId(trailerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteTrailerByTrailerId(trailerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (trailerId === null || trailerId === undefined) {
        throw new Error('Required parameter trailerId was null or undefined when calling deleteTrailerByTrailerId.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/trailer/deleteByTrailerId/${encodeURIComponent(String(trailerId))}`,
        {
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }


  /**
   * Delete a Generator by generator ID
   * @param generatorId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteGeneratorByGeneratorId(generatorId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteGeneratorByGeneratorId(generatorId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteGeneratorByGeneratorId(generatorId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteGeneratorByGeneratorId(generatorId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (generatorId === null || generatorId === undefined) {
        throw new Error('Required parameter generatorId was null or undefined when calling deleteGeneratorByGeneratorId.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/deleteByGeneratorId/${encodeURIComponent(String(generatorId))}`,
        {
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Delete a Fuel Tank by Fuel Tank ID
   * @param fueltankId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteFuelTankByFuelTankId(fueltankId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
  public deleteFuelTankByFuelTankId(fueltankId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
  public deleteFuelTankByFuelTankId(fueltankId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
  public deleteFuelTankByFuelTankId(fueltankId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (fueltankId === null || fueltankId === undefined) {
        throw new Error('Required parameter fueltankId was null or undefined when calling deleteFuelTankByFuelTankId.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/fuelTank/deleteByFuelTankId/${encodeURIComponent(String(fueltankId))}`,
        {
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Create a new Generator Deployment
   * @param telemetryActionRequest 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createDeployment(telemetryActionRequest: TelemetryActionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public createDeployment(telemetryActionRequest: TelemetryActionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createDeployment(telemetryActionRequest: TelemetryActionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createDeployment(telemetryActionRequest: TelemetryActionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (telemetryActionRequest === null || telemetryActionRequest === undefined) {
          throw new Error('Required parameter telemetryActionRequest was null or undefined when calling createDeployment.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json',
          'application/xml'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/generatorDeployment`,
          telemetryActionRequest,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Recover Generator
   * @param recoverRequest 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public recoverGenerator(recoverRequest: RecoverRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public recoverGenerator(recoverRequest: RecoverRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public recoverGenerator(recoverRequest: RecoverRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public recoverGenerator(recoverRequest: RecoverRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (recoverRequest === null || recoverRequest === undefined) {
          throw new Error('Required parameter recoverRequest was null or undefined when calling recoverGenerator.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json',
          'application/xml'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/generatorRecover`,
          recoverRequest,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Refuel Generator
   * @param refuelRequest 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public refuelGenerator(refuelRequest: RefuelRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public refuelGenerator(refuelRequest: RefuelRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public refuelGenerator(refuelRequest: RefuelRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public refuelGenerator(refuelRequest: RefuelRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (refuelRequest === null || refuelRequest === undefined) {
          throw new Error('Required parameter refuelRequest was null or undefined when calling refuelGenerator.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json',
          'application/xml'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/generatorRefuel`,
          refuelRequest,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Search by Generator Serial Number
     * @param searchValue 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGeneratorBySerialNumber(searchValue: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<GeneratorSearchDTO>>;
    public searchGeneratorBySerialNumber(searchValue: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<GeneratorSearchDTO>>>;
    public searchGeneratorBySerialNumber(searchValue: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<GeneratorSearchDTO>>>;
    public searchGeneratorBySerialNumber(searchValue: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (searchValue === null || searchValue === undefined) {
          throw new Error('Required parameter searchValue was null or undefined when calling searchGeneratorBySerialNumber.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (searchValue !== undefined && searchValue !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>searchValue, 'searchValue');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<GeneratorSearchDTO>>(`${this.configuration.basePath}/api/psnbGenerator/generatorSearchBySerialNumber`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Check if deployment exists by Power Supply ID
     * @param powersupplyId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkDeploymentStatus(powersupplyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeploymentStatusDTO>;
    public checkDeploymentStatus(powersupplyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeploymentStatusDTO>>;
    public checkDeploymentStatus(powersupplyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeploymentStatusDTO>>;
    public checkDeploymentStatus(powersupplyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (powersupplyId === null || powersupplyId === undefined) {
          throw new Error('Required parameter powersupplyId was null or undefined when calling checkDeploymentStatus.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (powersupplyId !== undefined && powersupplyId !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>powersupplyId, 'powersupplyId');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<DeploymentStatusDTO>(`${this.configuration.basePath}/api/psnbGenerator/checkDeploymentStatus`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Search by Local ID or QR Code ID
   * @param searchValue 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public searchGenerator(searchValue: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<GeneratorSearchDTO>>;
    public searchGenerator(searchValue: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<GeneratorSearchDTO>>>;
    public searchGenerator(searchValue: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<GeneratorSearchDTO>>>;
    public searchGenerator(searchValue: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (searchValue === null || searchValue === undefined) {
          throw new Error('Required parameter searchValue was null or undefined when calling searchGenerator.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (searchValue !== undefined && searchValue !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>searchValue, 'searchValue');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<GeneratorSearchDTO>>(`${this.configuration.basePath}/api/psnbGenerator/generatorSearchById`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Search Fuel Tank by Local ID or QR Code ID
     * @param searchValue 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fuelTankSearchById(searchValue: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<FuelTankEntity>>;
    public fuelTankSearchById(searchValue: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<FuelTankEntity>>>;
    public fuelTankSearchById(searchValue: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<FuelTankEntity>>>;
    public fuelTankSearchById(searchValue: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (searchValue === null || searchValue === undefined) {
          throw new Error('Required parameter searchValue was null or undefined when calling fuelTankSearchById.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (searchValue !== undefined && searchValue !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>searchValue, 'searchValue');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<FuelTankEntity>>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/fuelTankSearchById`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get Generator Usage Report by division, region, or nodeIds
   * Returns generator deployment history for the last 90 days or currently deployed generators, filtered by division, region, or nodeIds.
   * @param division Filter by division name
   * @param region Filter by region name
   * @param nodeIds Filter by node IDs (comma-separated)
   * @param history If true, returns history for past 90 days; if false, returns only currently deployed
   * @param timezone Timezone for the report (e.g., "UTC", "America/New_York")
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUsageReportExcel(division?: string, region?: string, nodeIds?: string, history?: boolean, timezone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Blob>;
  public getUsageReportExcel(division?: string, region?: string, nodeIds?: string, history?: boolean, timezone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Blob>>;
  public getUsageReportExcel(division?: string, region?: string, nodeIds?: string, history?: boolean, timezone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Blob>>;
  public getUsageReportExcel(division?: string, region?: string, nodeIds?: string, history?: boolean, timezone?: string,  observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (division !== undefined && division !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>division, 'division');
    }
    if (region !== undefined && region !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>region, 'region');
    }
    if (nodeIds !== undefined && nodeIds !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeIds, 'nodeIds');
    }
    if (history !== undefined && history !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>history, 'history');
    }

    if (timezone !== undefined && timezone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timezone, 'timezone');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    return this.httpClient.get(`${this.configuration.basePath}/api/psnbGenerator/reports/usage-Export`,
        {
            params: queryParameters,
            responseType: 'blob',
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Get Generator Inventory Report by division, region, or nodeIds
   * Returns generator inventory information filtered by division, region, or multiple nodeIds. NodeIds can be provided as comma-separated values.
   * @param division Filter by division name
   * @param region Filter by region name
   * @param nodeIds Filter by node IDs (comma-separated)
   * @param includeFuelTanks Include fuel tanks in the report
   * @param includeTrailers Include trailers in the report
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInventoryReportExcel(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Blob>;
  public getInventoryReportExcel(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Blob>>;
  public getInventoryReportExcel(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Blob>>;
  public getInventoryReportExcel(division?: string, region?: string, nodeIds?: string, includeFuelTanks?: boolean, includeTrailers?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (division !== undefined && division !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>division, 'division');
    }
    if (region !== undefined && region !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>region, 'region');
    }
    if (nodeIds !== undefined && nodeIds !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeIds, 'nodeIds');
    }
    if (includeFuelTanks !== undefined && includeFuelTanks !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>includeFuelTanks, 'includeFuelTanks');
    }
    if (includeTrailers !== undefined && includeTrailers !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>includeTrailers, 'includeTrailers');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get(`${this.configuration.basePath}/api/psnbGenerator/reports/inventory-export`,
        {
            params: queryParameters,
            responseType: 'blob',
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Update an existing Generator Voltage Type
   * @param id 
   * @param voltageType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateVoltage(id: number, voltageType: VoltageType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateVoltage(id: number, voltageType: VoltageType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateVoltage(id: number, voltageType: VoltageType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateVoltage(id: number, voltageType: VoltageType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateVoltage.');
      }
      if (voltageType === null || voltageType === undefined) {
          throw new Error('Required parameter voltageType was null or undefined when calling updateVoltage.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateVoltage`,
          voltageType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Create a new Generator Voltage Type
   * @param voltageType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createVoltage(voltageType: VoltageType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createVoltage(voltageType: VoltageType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createVoltage(voltageType: VoltageType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createVoltage(voltageType: VoltageType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (voltageType === null || voltageType === undefined) {
          throw new Error('Required parameter voltageType was null or undefined when calling createVoltage.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createVoltage`,
          voltageType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Delete a Generator Voltage Type
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteVoltage(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteVoltage(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteVoltage(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteVoltage(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteVoltage.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteVoltage`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Generator Voltage Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllVoltageTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<VoltageTypeDTO>>;
    public getAllVoltageTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<VoltageTypeDTO>>>;
    public getAllVoltageTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<VoltageTypeDTO>>>;
    public getAllVoltageTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<VoltageTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllVoltageTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Create a new Generator Status Type
   * @param statusType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createStatusType(statusType: StatusType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createStatusType(statusType: StatusType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createStatusType(statusType: StatusType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createStatusType(statusType: StatusType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (statusType === null || statusType === undefined) {
          throw new Error('Required parameter statusType was null or undefined when calling createStatusType.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createStatusType`,
          statusType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Delete a Generator Status Type
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteStatusType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteStatusType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteStatusType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteStatusType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteStatusType.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteStatusType`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get All Generator Status Types
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllStatusTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<StatusTypeDTO>>;
    public getAllStatusTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<StatusTypeDTO>>>;
    public getAllStatusTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<StatusTypeDTO>>>;
    public getAllStatusTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<StatusTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllStatusTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Update an existing Generator Status Type
     * @param id 
     * @param statusType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatusType(id: number, statusType: StatusType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateStatusType(id: number, statusType: StatusType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateStatusType(id: number, statusType: StatusType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateStatusType(id: number, statusType: StatusType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateStatusType.');
      }
      if (statusType === null || statusType === undefined) {
          throw new Error('Required parameter statusType was null or undefined when calling updateStatusType.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateStatusType`,
          statusType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Create a new Generator Model Type
     * @param modelType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createModelType(modelType: ModelType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createModelType(modelType: ModelType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createModelType(modelType: ModelType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createModelType(modelType: ModelType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (modelType === null || modelType === undefined) {
          throw new Error('Required parameter modelType was null or undefined when calling createModelType.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createModelType`,
          modelType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Delete a Generator Model Type
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteModel(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteModel(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteModel(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteModel(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteModel.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteModel`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get All Generator Model Types
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllModelTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<ModelTypeDTO>>;
    public getAllModelTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<ModelTypeDTO>>>;
    public getAllModelTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<ModelTypeDTO>>>;
    public getAllModelTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<ModelTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllModels`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Update an existing Generator Model Type
     * @param id 
     * @param modelType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateModel(id: number, modelType: ModelType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateModel(id: number, modelType: ModelType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateModel(id: number, modelType: ModelType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateModel(id: number, modelType: ModelType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateModel.');
        }
        if (modelType === null || modelType === undefined) {
            throw new Error('Required parameter modelType was null or undefined when calling updateModel.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>id, 'id');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateModel`,
            modelType,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

      /**
   * Create a new Generator Maintenance Type
   * @param maintenanceType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createMaintenance(maintenanceType: MaintenanceType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createMaintenance(maintenanceType: MaintenanceType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createMaintenance(maintenanceType: MaintenanceType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createMaintenance(maintenanceType: MaintenanceType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (maintenanceType === null || maintenanceType === undefined) {
          throw new Error('Required parameter maintenanceType was null or undefined when calling createMaintenance.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createMaintenance`,
          maintenanceType,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Delete a Generator Maintenance Type
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteMaintenance(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteMaintenance(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteMaintenance(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteMaintenance(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteMaintenance.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteMaintenance`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Generator Maintenance Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllMaintenanceTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<MaintenanceTypeDTO>>;
    public getAllMaintenanceTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<MaintenanceTypeDTO>>>;
    public getAllMaintenanceTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<MaintenanceTypeDTO>>>;
    public getAllMaintenanceTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<MaintenanceTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllMaintenanceTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Generator Maintenance Type
   * @param id 
   * @param maintenanceType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateMaintenance(id: number, maintenanceType: MaintenanceType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateMaintenance(id: number, maintenanceType: MaintenanceType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateMaintenance(id: number, maintenanceType: MaintenanceType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateMaintenance(id: number, maintenanceType: MaintenanceType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateMaintenance.');
      }
      if (maintenanceType === null || maintenanceType === undefined) {
          throw new Error('Required parameter maintenanceType was null or undefined when calling updateMaintenance.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateMaintenance`,
          maintenanceType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Create a new Generator Manufacture Type
   * @param manufactureType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public createManufactureType(manufactureType: ManufactureType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public createManufactureType(manufactureType: ManufactureType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public createManufactureType(manufactureType: ManufactureType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public createManufactureType(manufactureType: ManufactureType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (manufactureType === null || manufactureType === undefined) {
            throw new Error('Required parameter manufactureType was null or undefined when calling createManufactureType.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/createManufactureType`,
            manufactureType,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

  /**
   * Delete a Generator Manufacture Type
   * @param id 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public deleteManufacture(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public deleteManufacture(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public deleteManufacture(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public deleteManufacture(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling deleteManufacture.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.delete<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/deleteManufacture`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get All Generator Manufacture Types
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllManufactureTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<ManufactureTypeDTO>>;
    public getAllManufactureTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<ManufactureTypeDTO>>>;
    public getAllManufactureTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<ManufactureTypeDTO>>>;
    public getAllManufactureTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<ManufactureTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getAllManufactureTypes`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update an existing Generator Manufacture Type
   * @param id 
   * @param manufactureType 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateManufacture(id: number, manufactureType: ManufactureType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BaseResponseDTO>;
    public updateManufacture(id: number, manufactureType: ManufactureType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateManufacture(id: number, manufactureType: ManufactureType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateManufacture(id: number, manufactureType: ManufactureType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateManufacture.');
      }
      if (manufactureType === null || manufactureType === undefined) {
          throw new Error('Required parameter manufactureType was null or undefined when calling updateManufacture.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (id !== undefined && id !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>id, 'id');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/admin/updateManufacture`,
          manufactureType,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Get NWT Teams
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public getAllLoanedNWTTeams(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
    public getAllLoanedNWTTeams(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
    public getAllLoanedNWTTeams(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
    public getAllLoanedNWTTeams(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnb/eqJobs/getAllNWTTeams`,
        {
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

    /**
     * Get Trailers by Owner Team
     * @param ownerTeam 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTrailersByOwnerTeam(ownerTeam: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<TrailerNameIdDTO>>;
    public getTrailersByOwnerTeam(ownerTeam: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<TrailerNameIdDTO>>>;
    public getTrailersByOwnerTeam(ownerTeam: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<TrailerNameIdDTO>>>;
    public getTrailersByOwnerTeam(ownerTeam: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (ownerTeam === null || ownerTeam === undefined) {
          throw new Error('Required parameter ownerTeam was null or undefined when calling getTrailersByOwnerTeam.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (ownerTeam !== undefined && ownerTeam !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>ownerTeam, 'ownerTeam');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<TrailerNameIdDTO>>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/trailersByOwnerTeam`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get list of States
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGeneratorStates(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<StatesEntity>>;
    public getGeneratorStates(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<StatesEntity>>>;
    public getGeneratorStates(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<StatesEntity>>>;
    public getGeneratorStates(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<StatesEntity>>(`${this.configuration.basePath}/api/psnbGenerator/generators/getStates`,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Search Trailer by Local ID or QR Code ID
     * @param searchValue 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public trailerSearchById(searchValue: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<TrailerEntity>>;
    public trailerSearchById(searchValue: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<TrailerEntity>>>;
    public trailerSearchById(searchValue: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<TrailerEntity>>>;
    public trailerSearchById(searchValue: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (searchValue === null || searchValue === undefined) {
          throw new Error('Required parameter searchValue was null or undefined when calling trailerSearchById.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (searchValue !== undefined && searchValue !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>searchValue, 'searchValue');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<TrailerEntity>>(`${this.configuration.basePath}/api/psnbGenerator/api/psnbGenerator/trailerSearchById`,
          {
              params: queryParameters,
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

  /**
   * Update a Generator
   * @param id 
   * @param generator 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
    public updateGenerator(id: number, generator: Generator, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public updateGenerator(id: number, generator: Generator, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateGenerator(id: number, generator: Generator, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateGenerator(id: number, generator: Generator, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateGenerator.');
      }
      if (generator === null || generator === undefined) {
          throw new Error('Required parameter generator was null or undefined when calling updateGenerator.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/updateGenerator/${encodeURIComponent(String(id))}`,
          generator,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Update an existing Fuel Tank
     * @param id 
     * @param fuelTank 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFuelTank(id: number, fuelTank: FuelTank, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public updateFuelTank(id: number, fuelTank: FuelTank, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateFuelTank(id: number, fuelTank: FuelTank, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateFuelTank(id: number, fuelTank: FuelTank, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateFuelTank.');
      }
      if (fuelTank === null || fuelTank === undefined) {
          throw new Error('Required parameter fuelTank was null or undefined when calling updateFuelTank.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/updateFuelTank/${encodeURIComponent(String(id))}`,
          fuelTank,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }


    /**
     * Update an existing Trailer
     * @param id 
     * @param trailer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTrailer(id: number, trailer: Trailer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<BaseResponseDTO>;
    public updateTrailer(id: number, trailer: Trailer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<BaseResponseDTO>>;
    public updateTrailer(id: number, trailer: Trailer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<BaseResponseDTO>>;
    public updateTrailer(id: number, trailer: Trailer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
      if (id === null || id === undefined) {
          throw new Error('Required parameter id was null or undefined when calling updateTrailer.');
      }
      if (trailer === null || trailer === undefined) {
          throw new Error('Required parameter trailer was null or undefined when calling updateTrailer.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.put<BaseResponseDTO>(`${this.configuration.basePath}/api/psnbGenerator/updateTrailer/${encodeURIComponent(String(id))}`,
          trailer,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get Asset Hierarchy Search Report by nodeIds
     * Returns asset summary information filtered by multiple nodeIds. NodeIds can be provided as comma-separated values.
     * @param hierarchySearchPayload 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAssetHierarchySearch(hierarchySearchPayload: HierarchySearchPayload, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<AssetHierarchySearchDTO>>;
    public getAssetHierarchySearch(hierarchySearchPayload: HierarchySearchPayload, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<AssetHierarchySearchDTO>>>;
    public getAssetHierarchySearch(hierarchySearchPayload: HierarchySearchPayload, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<AssetHierarchySearchDTO>>>;
    public getAssetHierarchySearch(hierarchySearchPayload: HierarchySearchPayload, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (hierarchySearchPayload === null || hierarchySearchPayload === undefined) {
          throw new Error('Required parameter hierarchySearchPayload was null or undefined when calling getAssetHierarchySearch.');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              '*/*'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.post<Array<AssetHierarchySearchDTO>>(`${this.configuration.basePath}/api/psnbGenerator/reports/heirarchysearch`,
          hierarchySearchPayload,
          {
              responseType: <any>responseType,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
    }

    /**
     * Get manufacturer/make options based on prefix
     * @param prefix 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMakeOptions(prefix?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
    public getMakeOptions(prefix?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
    public getMakeOptions(prefix?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
    public getMakeOptions(prefix?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (prefix !== undefined && prefix !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>prefix, 'prefix');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnbGenerator/search/getmakeoptions`,
        {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

    /**
     * Get model options based on prefix
     * @param prefix 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getModelOptions(prefix?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
    public getModelOptions(prefix?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
    public getModelOptions(prefix?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
    public getModelOptions(prefix?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (prefix !== undefined && prefix !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>prefix, 'prefix');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnbGenerator/search/getmodeloptions`,
        {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

    /**
     * Get team name options based on prefix
     * @param prefix 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNwtTeamNameOptions(prefix?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<string>>;
    public getNwtTeamNameOptions(prefix?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<string>>>;
    public getNwtTeamNameOptions(prefix?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<string>>>;
    public getNwtTeamNameOptions(prefix?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (prefix !== undefined && prefix !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>prefix, 'prefix');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/api/psnbGenerator/search/getnwtteamnameoptions`,
        {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

    /**
     * Get Generator Model Types by Manufacturer
     * @param manufacturer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getModelsByManufacturer(manufacturer: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Array<ModelTypeDTO>>;
    public getModelsByManufacturer(manufacturer: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Array<ModelTypeDTO>>>;
    public getModelsByManufacturer(manufacturer: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Array<ModelTypeDTO>>>;
    public getModelsByManufacturer(manufacturer: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
      if (manufacturer === null || manufacturer === undefined) {
        throw new Error('Required parameter manufacturer was null or undefined when calling getModelsByManufacturer.');
      }

      let queryParameters = new HttpParams({encoder: this.encoder});
      if (manufacturer !== undefined && manufacturer !== null) {
        queryParameters = this.addToHttpParams(queryParameters,
          <any>manufacturer, 'manufacturer');
      }

      let headers = this.defaultHeaders;

      // authentication (bearerAuth) required
      if (this.configuration.accessToken) {
          const accessToken = typeof this.configuration.accessToken === 'function'
              ? this.configuration.accessToken()
              : this.configuration.accessToken;
          headers = headers.set('Authorization', 'Bearer ' + accessToken);
      }
      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      let responseType: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType = 'text';
      }

      return this.httpClient.get<Array<ModelTypeDTO>>(`${this.configuration.basePath}/api/psnbGenerator/admin/getModelsByManufacturer`,
        {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }

  /**
   * Search by Asset Id
   * @param assetId 
   * @param timeZone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByAssetIdMobile(assetId: string, timeZone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorMobileSearch>>;
  public advanceSearchByAssetIdMobile(assetId: string, timeZone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorMobileSearch>>>;
  public advanceSearchByAssetIdMobile(assetId: string, timeZone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorMobileSearch>>>;
  public advanceSearchByAssetIdMobile(assetId: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (assetId === null || assetId === undefined) {
        throw new Error('Required parameter assetId was null or undefined when calling advanceSearchByAssetIdMobile.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (assetId !== undefined && assetId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>assetId, 'assetId');
    }
    if (timeZone !== undefined && timeZone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timeZone, 'timeZone');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorMobileSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByAssetIdMobile`,
      {
          params: queryParameters,
          responseType: <any>responseType,
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
      }
    );
  }
  
  /**
   * Search by Node
   * @param nodeId 
   * @param nodeCommunityServed 
   * @param node 
   * @param timeZone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNodeMobile(nodeId: number, nodeCommunityServed: string, node: string, timeZone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorMobileSearch>>;
  public advanceSearchByNodeMobile(nodeId: number, nodeCommunityServed: string, node: string, timeZone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorMobileSearch>>>;
  public advanceSearchByNodeMobile(nodeId: number, nodeCommunityServed: string, node: string, timeZone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorMobileSearch>>>;
  public advanceSearchByNodeMobile(nodeId: number, nodeCommunityServed: string, node: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nodeId === null || nodeId === undefined) {
        throw new Error('Required parameter nodeId was null or undefined when calling advanceSearchByNodeMobile.');
    }
    if (nodeCommunityServed === null || nodeCommunityServed === undefined) {
        throw new Error('Required parameter nodeCommunityServed was null or undefined when calling advanceSearchByNodeMobile.');
    }
    if (node === null || node === undefined) {
        throw new Error('Required parameter node was null or undefined when calling advanceSearchByNodeMobile.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nodeId !== undefined && nodeId !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeId, 'nodeId');
    }
    if (nodeCommunityServed !== undefined && nodeCommunityServed !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nodeCommunityServed, 'nodeCommunityServed');
    }
    if (node !== undefined && node !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>node, 'node');
    }
    if (timeZone !== undefined && timeZone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timeZone, 'timeZone');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorMobileSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByNodeMobile`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }


  /**
   * Search by NWT Team name
   * @param nwtTeam 
   * @param timeZone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByNwtTeamMobile(nwtTeam: string, timeZone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorMobileSearch>>;
  public advanceSearchByNwtTeamMobile(nwtTeam: string, timeZone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorMobileSearch>>>;
  public advanceSearchByNwtTeamMobile(nwtTeam: string, timeZone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorMobileSearch>>>;
  public advanceSearchByNwtTeamMobile(nwtTeam: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
    if (nwtTeam === null || nwtTeam === undefined) {
        throw new Error('Required parameter nwtTeam was null or undefined when calling advanceSearchByNwtTeamMobile.');
    }

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (nwtTeam !== undefined && nwtTeam !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>nwtTeam, 'nwtTeam');
    }
    if (timeZone !== undefined && timeZone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timeZone, 'timeZone');
    }

    let headers = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken: string = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;

      if (!this.isAccessTokenExpired(accessToken)) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorMobileSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByNwtTeamMobile`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Search by NWT Make
   * @param make 
   * @param timeZone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByMakeMobile(make?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
  public advanceSearchByMakeMobile(make?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
  public advanceSearchByMakeMobile(make?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
  public advanceSearchByMakeMobile(make?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (make !== undefined && make !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>make, 'make');
    }
    if (timeZone !== undefined && timeZone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timeZone, 'timeZone');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<object>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByMakeMobile`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

  /**
   * Search by NWT Model
   * @param model 
   * @param timeZone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public advanceSearchByModelMobile(model?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<Array<GeneratorMobileSearch>>;
  public advanceSearchByModelMobile(model?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<Array<GeneratorMobileSearch>>>;
  public advanceSearchByModelMobile(model?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<Array<GeneratorMobileSearch>>>;
  public advanceSearchByModelMobile(model?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {

    let queryParameters = new HttpParams({encoder: this.encoder});
    if (model !== undefined && model !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>model, 'model');
    }
    if (timeZone !== undefined && timeZone !== null) {
      queryParameters = this.addToHttpParams(queryParameters,
        <any>timeZone, 'timeZone');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    let responseType: 'text' | 'json' = 'json';
    if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
        responseType = 'text';
    }

    return this.httpClient.get<Array<GeneratorMobileSearch>>(`${this.configuration.basePath}/api/psnbGenerator/search/advanceSearchByModelMobile`,
        {
            params: queryParameters,
            responseType: <any>responseType,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
  }

}
